// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/NeueHaasDisplay-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/NeueHaasDisplay-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/NeueHaasDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/NeueHaasDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/NeueHaasDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/NeueHaasDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/NeueHaasDisplay-Mediu.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/NeueHaasDisplay-Mediu.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/NeueHaasDisplay-Roman.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/NeueHaasDisplay-Roman.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/NeueHaasDisplay-XXThin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/NeueHaasDisplay-XXThin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/NeueHaasDisplay-XThin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/NeueHaasDisplay-XThin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/NeueHaasDisplay-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/NeueHaasDisplay-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/NeueHaasDisplay-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/NeueHaasDisplay-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/NeueHaasDisplay-RomanItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/NeueHaasDisplay-RomanItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Manrope-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Manrope-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Manrope-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Manrope-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Manrope-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Manrope-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/Manrope-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/Manrope-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/Manrope-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/Manrope-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/Manrope-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/Manrope-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../fonts/Manrope-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../fonts/Manrope-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../fonts/DMSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../fonts/DMSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../fonts/DMSans-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../fonts/DMSans-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../fonts/DMSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../fonts/DMSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../fonts/DMSans-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../fonts/DMSans-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../fonts/DMSans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../fonts/DMSans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../fonts/DMSans-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../fonts/DMSans-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../images/social.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../images/video.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../images/games2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../images/ads2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../images/web.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../images/metaverse.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../images/ads.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../images/animation-&-motion-graphics.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../images/Rikki.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../images/Dia.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../images/Dooj.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../images/Khushboo.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../images/Michell.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../images/Prerna.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../images/Mobile-BG.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../images/hero_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../images/Playbutton.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../images/ad-images/arrowRight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../images/ad-images/leftArrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../images/ad-images/backMeta.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../images/ad-images/google_ads.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../images/ad-images/Tiktok.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../images/ad-images/Taboola.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../images/ad-images/Snap.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../images/ad-images/footerback.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../images/blinkecom-images/gredient.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Neue Haas Grotesk Display Pro Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro XXThin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro XThin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro Thin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro light italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff");
  font-weight: 300;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Neue Haas Grotesk Display Pro roman italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff");
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}
/* VARIABLES */
/* Color */
@font-face {
  font-family: "Manrope Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Extralight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff");
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Extrabold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Manrope Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
/* VARIABLES */
@font-face {
  font-family: "DM Sans Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans MedItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff");
  font-weight: 500;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("woff");
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans BoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_44___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_45___}) format("woff");
  font-weight: bold;
  font-style: italic;
  font-display: swap;
}
/* VARIABLES */
/* MIXINS */
/* RESET CSS */
/* http://meyerweb.com/eric/tools/css/reset/
     v2.0 | 20110126
     License: none (public domain)
  */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  color: inherit;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}
a, a:hover, a:active, a:visited, a:focus {
  color: inherit;
}

i,
em,
.italic-text {
  font-style: italic;
}

.left {
  float: left;
}

.right {
  float: right;
}

.wrap-clear::after {
  content: "";
  display: block;
  clear: both;
}

.clearfix {
  zoom: 1;
  display: table;
  clear: both;
}
.clearfix:before, .clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}

:focus {
  outline: none;
}

input,
button,
textarea {
  border-radius: 0;
  appearance: none;
}

select {
  border-radius: 0;
}

textarea {
  resize: none;
}

/* COMMONS */
body {
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0.6px;
}

ol,
ul {
  margin: 0px;
}

button,
input,
select,
textarea {
  -webkit-appearance: none;
  outline: none;
  border-radius: 0;
  background-color: transparent;
}

input,
textarea {
  background: transparent;
  border: none;
}

input:focus,
select:focus,
textarea:focus,
button:focus,
a:focus {
  outline: none;
}

a {
  color: inherit;
  cursor: pointer;
}

.h1,
.h2,
.h3,
.h4,
h1,
h2,
h3,
h4 {
  line-height: 1.4;
}

p {
  line-height: 1.6;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.slick-slider.reverse {
  transform: rotate(180deg);
}

.slick-slider.reverse .slick-slide {
  transform: rotate(180deg);
}

@media only screen and (min-width: 1025px) {
  .hidden-lg {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .hidden-md {
    display: none !important;
  }
}

.img-responsive {
  width: 100%;
  height: auto;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  width: 90%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .container {
    max-width: 768px;
  }
}
@media (max-width: 767px) {
  .container {
    width: 100%;
    padding: 0 20px;
  }
}

/* MAIN CSS */
main {
  position: relative;
}

body {
  scroll-behavior: smooth;
}

.dark-footer {
  background-color: black;
  color: white;
}

.white-footer {
  background-color: white;
  color: black;
}

/* Header styles */
.header {
  padding: 16px 0px;
  position: fixed;
  top: 0px;
  left: 50%;
  /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, 0);
  z-index: 100;
  width: 100%;
  background-color: transparent;
  transition: all 0.3s ease;
}
@media (max-width: 767px) {
  .header {
    padding: 10px 0;
  }
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
@media (max-width: 767px) {
  .header-wrapper {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.logo img {
  width: 140px;
}
@media (max-width: 767px) {
  .logo img {
    width: 130px;
    /* Adjust according to your logo size */
  }
}

/* Desktop nav styles */
.nav-links {
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  .nav-links {
    width: 100%;
    position: absolute;
    top: -100vh;
    left: 0;
    background-color: rgb(233, 228, 228);
    display: flex;
    flex-direction: column;
  }
}
@media (max-width: 767px) {
  .nav-links .wrap-links {
    padding-top: 80px;
    padding-bottom: 80px;
    width: 100%;
    height: 100vh;
    background-color: white;
  }
}
.nav-links ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 52px;
}
@media (max-width: 767px) {
  .nav-links ul {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
.nav-links ul li a {
  transition: all 0.3s ease;
}
@media (max-width: 767px) {
  .nav-links ul li {
    margin: 0;
  }
  .nav-links ul li a {
    line-height: 1.4;
    font-size: 26px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
  }
}

/* Mobile nav styles */
.menu-icon {
  display: none;
  cursor: pointer;
}
@media (max-width: 767px) {
  .menu-icon {
    position: relative;
    z-index: 20000;
  }
}

.hamburger {
  width: 30px;
  height: 21px;
  position: relative;
}

.hamburger span {
  display: block;
  width: 100%;
  height: 2px;
  background: #000;
  margin-bottom: 6px;
  transition: transform 0.3s, opacity 0.3s;
}

.hamburger.open span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.hamburger.open span:nth-child(2) {
  opacity: 0;
}

.hamburger.open span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

/* Sliding menu styles */
@keyframes italicAnimation {
  0% {
    font-variation-settings: "ital" 12;
  }
  100% {
    font-variation-settings: "ital" 0;
  }
}
li {
  text-align: right;
}
@media (max-width: 767px) {
  li {
    min-width: unset;
  }
}
li a {
  text-decoration: none;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: black;
  font-size: 18px;
  transition: all 0.3s ease;
  display: block;
  transition: transform 0.2s ease;
}
li a:hover {
  transform: skew(-15deg);
}
li a:not(:hover) {
  animation-name: italics-animation-reverse;
}

li:last-child {
  margin-right: 0;
}

/* Media query for mobile */
@media (max-width: 768px) {
  .nav-links {
    text-align: center;
  }
  .menu-icon {
    display: block;
  }
}
.header.scroll-top {
  background: white;
}
.header.scroll-top .header-wrapper .nav-links ul li a:hover {
  color: #516beb;
}

#hero {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
@media (max-width: 767px) {
  #hero {
    padding-top: 160px;
    padding-bottom: 100px;
    height: auto;
  }
}
#hero .headings .top-copy-container p {
  color: white;
}
#hero .headings .head-copy-container h1 {
  color: white;
}
#hero .headings p {
  font-family: "Neue Haas Grotesk Display Pro Light";
  text-align: center;
  font-size: 100px;
  line-height: 1;
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #hero .headings p {
    font-size: 40px;
    line-height: 1.1;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #hero .headings p {
    font-size: 70px;
  }
}
#hero .headings h1 {
  font-family: "Neue Haas Grotesk Display Pro Light";
  text-align: center;
  font-size: 200px;
  line-height: 1;
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #hero .headings h1 {
    font-size: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #hero .headings h1 {
    font-size: 140px;
  }
}
#hero .headings .bottom-copy {
  margin-top: 2rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
  z-index: 10;
  text-align: center;
  color: black;
}
@media (max-width: 767px) {
  #hero .headings .bottom-copy {
    text-align: center;
    margin-top: 20px;
    font-size: 13px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #hero .headings .bottom-copy {
    font-size: 26px;
  }
}
#hero .top-copy-container,
#hero .bottom-copy-container,
#hero .head-copy-container {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
}

.image-at-cursor {
  position: absolute;
  pointer-events: none;
  z-index: 1000;
  transition: transform 0.3s ease;
}

#about {
  padding-top: 20px;
}
@media (max-width: 767px) {
  #about {
    padding-bottom: 0;
    padding-top: 70px;
  }
}
#about .about-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
}
@media (max-width: 767px) {
  #about .about-wrapper {
    gap: 180px;
    gap: 2rem;
  }
}
#about .about-wrapper .top-img-wrap .about-image {
  padding: 15px;
}
@media (max-width: 767px) {
  #about .about-wrapper .top-img-wrap .about-image {
    padding: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #about .about-wrapper .top-img-wrap .about-image {
    width: 350px;
    height: 240px;
  }
}
#about .about-wrapper .top-img-wrap .about-image img {
  object-fit: cover;
}
#about .about-wrapper .top-img-wrap .about-image p {
  background-color: white;
  border-radius: 20px;
  padding: 0px 10px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
}
@media (max-width: 767px) {
  #about .about-wrapper .top-img-wrap .about-image p {
    font-size: 10px;
    line-height: 100%;
    padding: 3px 10px;
    font-size: 10px;
    line-height: 100%;
    padding: 3px 0px;
  }
}
#about .about-wrapper .top-img-wrap .intro {
  max-width: 500px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 1.5rem;
  line-height: 1.25;
}
@media (max-width: 767px) {
  #about .about-wrapper .top-img-wrap .intro {
    font-size: 1rem;
  }
}
#about .about-wrapper .about-image {
  border-radius: 30px;
}
#about .about-wrapper .about-image .img-wrap {
  position: relative;
}
#about .about-wrapper .about-image .img-wrap .black-overlay {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40%;
  padding: 10px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image .img-wrap .black-overlay {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}
#about .about-wrapper .about-image .img-wrap .copy-below {
  position: absolute;
  bottom: 15px;
  right: 10px;
  color: white;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image .img-wrap .copy-below {
    bottom: 5px;
    right: 10px;
  }
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image {
    border-radius: 10px;
  }
}
#about .about-wrapper .about-image img {
  object-fit: cover;
}
#about .about-wrapper .about-image.about-image-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-top {
    max-width: 200px;
  }
}
#about .about-wrapper .about-image.about-image-top img {
  margin-bottom: 0px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-top img {
    margin-bottom: 0px;
  }
}
#about .about-wrapper .about-image.about-image-top p {
  background-color: unset;
}
#about .about-wrapper .about-image.about-image-top .copy-below {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
  left: 10px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-top .copy-below {
    font-size: 14px;
  }
}
#about .about-wrapper .about-image.about-image-center {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  align-self: flex-end;
  justify-content: flex-end;
  align-items: flex-end;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-center {
    flex-direction: column;
  }
}
#about .about-wrapper .about-image.about-image-center p {
  border-radius: 20px;
  padding: 0px 10px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
  max-width: -moz-fit-content;
  max-width: fit-content;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-center p {
    font-size: 10px;
    font-size: 10px;
    line-height: 100%;
    padding: 0px;
  }
}
#about .about-wrapper .about-image.about-image-center .copy-below {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-center .copy-below {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-center {
    align-self: flex-end;
    position: static;
    max-width: 200px;
    padding: 0px;
    background-size: cover;
    margin-top: -10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #about .about-wrapper .about-image.about-image-center {
    width: 350px;
    height: 240px;
  }
}
#about .about-wrapper .about-image.about-image-bottom {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
}
#about .about-wrapper .about-image.about-image-bottom img {
  object-fit: cover;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-bottom {
    width: 200px;
    padding: 0;
    margin-top: -10px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #about .about-wrapper .about-image.about-image-bottom {
    width: 350px;
    height: 240px;
  }
}
#about .about-wrapper .about-image.about-image-bottom p {
  border-radius: 20px;
  padding: 0px 10px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-bottom p {
    font-size: 10px;
    font-size: 10px;
    line-height: 100%;
    padding: 0px;
  }
}
#about .about-wrapper .about-image.about-image-bottom .copy-below {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
  left: 10px;
}
@media (max-width: 767px) {
  #about .about-wrapper .about-image.about-image-bottom .copy-below {
    font-size: 14px;
  }
}
#about .about-wrapper .center-copy {
  width: 100%;
  position: absolute;
  top: 50%;
  /* position the top  edge of the element at the middle of the parent */
  left: 50%;
  /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -50%);
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 100px;
  z-index: 50;
  line-height: 1;
  color: white;
  will-change: transform;
  -webkit-font-smoothing: antialiased;
  text-align: center;
}
@media (max-width: 767px) {
  #about .about-wrapper .center-copy {
    font-size: 34px;
    position: static;
    transform: unset;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    margin-bottom: 0px;
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #about .about-wrapper .center-copy {
    font-size: 60px;
  }
}

.back-constant {
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}

#work {
  padding: 120px 0;
}
@media (max-width: 767px) {
  #work {
    padding: 40px 0;
    padding-top: 80px;
  }
}
#work .work-copy {
  max-width: 100%;
}
@media (max-width: 767px) {
  #work .work-copy {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
}
#work .work-copy h3 {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 100%;
  color: white;
}
@media (max-width: 767px) {
  #work .work-copy h3 {
    font-size: 34px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #work .work-copy h3 {
    font-size: 60px;
  }
}
#work .work-copy p {
  font-size: 1rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.4;
  font-size: 18px;
}
@media (max-width: 767px) {
  #work .work-copy p {
    font-size: 15px;
  }
}
#work .sliders-wrap {
  z-index: 7;
  position: relative;
  display: flex;
  gap: 90px;
  flex-direction: column;
}
@media (max-width: 767px) {
  #work .sliders-wrap {
    gap: 3rem;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #work .sliders-wrap {
    gap: 80px;
  }
}
#work .sliders-wrap .work-slider-top {
  max-width: 100%;
}
#work .sliders-wrap .work-slider-top .slick-slider .slick-prev {
  display: none;
}
#work .sliders-wrap .work-slider-top .slick-slider .slick-next {
  display: none;
}
#work .sliders-wrap .work-slider-top .card-item {
  width: 360px;
  height: 250px;
  margin: 0 80px;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  display: flex;
  justify-content: end;
  align-items: flex-start;
  padding: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  justify-content: flex-start;
  align-items: flex-end;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work-slider-top .card-item {
    margin: 0 30px;
    padding: 10px;
    width: 90%;
    height: 150px;
    background-size: cover;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #work .sliders-wrap .work-slider-top .card-item {
    width: 320px;
    height: 220px;
  }
}
#work .sliders-wrap .work-slider-top .card-item img {
  object-fit: cover;
  display: block;
}
#work .sliders-wrap .work-slider-top .card-item p {
  line-height: 1.2;
  padding: 1px 10px;
  border-radius: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: white;
  font-size: 22px;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work-slider-top .card-item p {
    font-size: 16px;
  }
}
#work .sliders-wrap .work-slider-top .card-item.card-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-top .card-item.card-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-top .card-item.card-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-top .card-item.card-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-bottom {
  max-width: 100%;
}
#work .sliders-wrap .work-slider-bottom .slick-slider .slick-prev {
  display: none;
}
#work .sliders-wrap .work-slider-bottom .slick-slider .slick-next {
  display: none;
}
#work .sliders-wrap .work-slider-bottom .card-item {
  width: 360px;
  height: 250px;
  margin: 0 80px;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  display: flex;
  justify-content: end;
  align-items: flex-start;
  padding: 10px;
  justify-content: flex-start;
  align-items: flex-end;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work-slider-bottom .card-item {
    margin: 0 10px;
    width: 90%;
    height: 150px;
    background-size: cover;
    padding: 10px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #work .sliders-wrap .work-slider-bottom .card-item {
    width: 320px;
    height: 220px;
  }
}
#work .sliders-wrap .work-slider-bottom .card-item img {
  object-fit: cover;
  display: block;
}
#work .sliders-wrap .work-slider-bottom .card-item p {
  line-height: 1.2;
  padding: 1px 10px;
  border-radius: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: white;
  font-size: 22px;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work-slider-bottom .card-item p {
    font-size: 16px;
  }
}
#work .sliders-wrap .work-slider-bottom .card-item.card-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-bottom .card-item.card-1 p {
  background-color: white;
  line-height: 1.2;
  padding: 0px 10px;
  border-radius: 8px;
}
#work .sliders-wrap .work-slider-bottom .card-item.card-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  background-color: rgb(100, 98, 124);
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-bottom .card-item.card-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work-slider-bottom .card-item.card-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  background-color: rgb(100, 98, 124);
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
#work .sliders-wrap .work_heading {
  position: absolute;
  font-size: 11rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  top: 50%;
  /* position the top  edge of the element at the middle of the parent */
  left: 50%;
  /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -50%);
  color: white;
  z-index: 1;
}
@media (max-width: 767px) {
  #work .sliders-wrap .work_heading {
    font-size: 3rem;
  }
}

#team {
  pointer-events: none;
  position: relative;
}
@media (max-width: 767px) {
  #team {
    padding: 0px 0;
  }
}
#team .team-slider {
  z-index: 10;
}
@media (max-width: 767px) {
  #team .team-slider {
    padding: 0;
  }
}
#team .team-slider .slick-slider .slick-prev {
  display: none;
}
#team .team-slider .slick-slider .slick-next {
  display: none;
}
#team .team-slider .slick-slide {
  padding: 0 20px;
}
@media (max-width: 767px) {
  #team .team-slider .slick-slide {
    padding: 0 15px;
  }
}
#team .team-slider .team-card {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  border-radius: 15px;
  position: relative;
}
#team .team-slider .team-card .black-overlay {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40%;
  padding: 10px;
}
#team .team-slider .team-card .team-name {
  position: absolute;
  margin-bottom: 15px;
  margin-left: 15px;
}
#team .team-slider .team-card p {
  color: white;
  font-size: 19px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1;
}
@media (max-width: 767px) {
  #team .team-slider .team-card p {
    font-size: 16px;
  }
}
#team .team-slider .team-card.team-card-0 {
  width: 130px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}
#team .team-slider .team-card.team-card-1 {
  width: 130px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}
#team .team-slider .team-card.team-card-2 {
  width: 150px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}
#team .team-slider .team-card.team-card-3 {
  width: 130px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}
#team .team-slider .team-card.team-card-4 {
  width: 110px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}
#team .team-slider .team-card.team-card-5 {
  width: 140px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}
#team .team-slider .team-card.team-card-6 {
  width: 140px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}
#team .team-slider .team-card.team-card-7 {
  width: 200px;
  height: 500px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}
#team .team-slider .team-card.team-card-8 {
  width: 120px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}
#team .team-slider .team-card.team-card-9 {
  width: 140px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}
#team .team-slider .team-card.team-card-10 {
  width: 130px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}
#team .team-slider .team-card.team-card-11 {
  width: 120px;
  height: 400px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}
#team .team-slider .m-50 {
  margin-top: 50px;
}
@media (max-width: 767px) {
  #team .team-slider .m-50 {
    margin-top: 0px;
  }
}
#team .team-slider .m-100 {
  margin-top: 100px;
}
@media (max-width: 767px) {
  #team .team-slider .m-100 {
    margin-top: 30px;
  }
}
#team .team-slider .m-150 {
  margin-top: 150px;
}
@media (max-width: 767px) {
  #team .team-slider .m-150 {
    margin-top: 120px;
  }
}
#team .team-slider .m-200 {
  margin-top: 200px;
}
@media (max-width: 767px) {
  #team .team-slider .m-200 {
    margin-top: 140px;
  }
}
#team .designation {
  margin-top: 6px;
  font-size: 13px !important;
}
@media (max-width: 767px) {
  #team .designation {
    font-size: 10px !important;
  }
}
#team .overlapped-copy-top {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  top: 0rem;
  left: 200px;
  line-height: 100%;
  color: white;
  z-index: 10;
}
@media (max-width: 767px) {
  #team .overlapped-copy-top {
    left: 20px;
    top: 4rem;
    font-size: 34px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #team .overlapped-copy-top {
    font-size: 60px;
  }
}
#team .overlapped-copy-bottom {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  bottom: -4rem;
  right: 200px;
  text-align: right;
  line-height: 100%;
  color: white;
}
@media (max-width: 767px) {
  #team .overlapped-copy-bottom {
    right: 20px;
    font-size: 2rem;
    bottom: 0rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #team .overlapped-copy-bottom {
    font-size: 60px;
  }
}

.zIndex-box {
  display: none;
}
@media (max-width: 767px) {
  .zIndex-box {
    display: block;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: -20%;
    right: 0;
    z-index: -1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
    background-repeat: repeat-y;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
}

.home-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
@media (max-width: 767px) {
  .home-page {
    background-image: unset;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  .home-page:before {
    content: "";
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
    background-size: cover;
  }
}

.home-page-all {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.work-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
@media (max-width: 767px) {
  .work-page {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
    background-repeat: repeat;
  }
}

#awards {
  padding: 135px 0;
}
@media (max-width: 767px) {
  #awards {
    padding: 0;
    padding: 80px 0;
  }
}
#awards .awards-heading {
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 100px;
  text-align: center;
  margin-bottom: 4rem;
  color: white;
  line-height: 1;
}
@media (max-width: 767px) {
  #awards .awards-heading {
    font-size: 34px;
    margin-bottom: 2rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 40px;
    margin-bottom: 2rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    line-height: 1;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #awards .awards-heading {
    font-size: 60px;
  }
}
#awards .awards-wrapper {
  max-width: 900px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5rem;
}
#awards .awards-wrapper .custom-tooltip {
  background-color: red;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
}
#awards .awards-wrapper .custom-tooltip-arrow {
  color: #333; /* Matches the background color of the tooltip */
}
#awards .awards-wrapper .slick-slide {
  padding: 0 40px;
}
@media (max-width: 767px) {
  #awards .awards-wrapper .slick-slide {
    padding: 0 20px;
  }
}
@media (max-width: 767px) {
  #awards .awards-wrapper {
    max-width: unset;
    gap: 20px;
  }
}
#awards .awards-wrapper #tooltip {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
}
#awards .awards-wrapper .tooltip {
  max-width: 83px;
}
#awards .awards-wrapper .tooltip p {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  margin-top: 10px;
  text-align: center;
}
@media (max-width: 767px) {
  #awards .awards-wrapper .tooltip p {
    margin-top: 12px;
    font-size: 12px;
  }
}
#awards .awards-wrapper .tooltip .tooltiptext {
  visibility: hidden;
  width: -moz-fit-content;
  width: fit-content;
  white-space: nowrap;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 5px;
  bottom: 120%;
  left: 50%;
  /* margin-left: -60px; */
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
  transform: translate(-50%, 0%);
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}
#awards .awards-wrapper .tooltip:hover .tooltiptext {
  visibility: visible;
}
#awards .award-slider .slick-track {
  display: flex;
  padding: 0 10px;
}

#offices {
  padding-bottom: 120px;
}
@media (max-width: 767px) {
  #offices {
    padding: 0px 0;
    padding-bottom: 50px;
  }
}
#offices .offices-heading {
  max-width: 900px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 100px;
  line-height: 1;
  margin-bottom: 4rem;
  color: white;
}
@media (max-width: 767px) {
  #offices .offices-heading {
    margin-bottom: 2rem;
    font-size: 34px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    line-height: 1;
    font-size: 40px;
    text-align: start;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #offices .offices-heading {
    font-size: 60px;
  }
}
#offices .card-wrapper {
  max-width: 900px;
  display: flex;
  justify-content: center;
  gap: 4rem;
}
@media (max-width: 767px) {
  #offices .card-wrapper {
    flex-direction: column;
    gap: 30px;
    padding: 0 70px;
  }
}
#offices .card-wrapper .card {
  background-color: rgba(255, 255, 255, 0.568627451);
  padding: 30px;
  flex: 1 1;
}
#offices .card-wrapper .card .city {
  font-size: 2.5rem;
  margin-bottom: 1.2rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #offices .card-wrapper .card .city {
    font-size: 26px;
    margin-bottom: 10px;
  }
}
#offices .card-wrapper .card .adj {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  border-bottom: 1px solid black;
  line-height: 1;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin-bottom: 10px;
}
#offices .card-wrapper .card .adj.adj1 {
  border-bottom: none;
  line-height: 1.3;
  margin-bottom: 3px;
}
@media (max-width: 767px) {
  #offices .card-wrapper .card .adj {
    font-size: 12px;
  }
  #offices .card-wrapper .card .adj.adj1 {
    font-size: 14px;
  }
}
#offices .card-wrapper .card .location {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 21px;
  line-height: 1;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  #offices .card-wrapper .card .location {
    font-size: 17px;
  }
}
#offices .card-wrapper .card .our-location {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  border-bottom: 1px solid black;
  line-height: 1;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin-bottom: 0.5rem;
}
#offices .card-wrapper .card .our-location.hgb {
  border-bottom: none;
}
#offices .card-wrapper .card .lets {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  border-bottom: 1px solid black;
  line-height: 1;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin-bottom: 0.5rem;
}
#offices .card-wrapper .card .name {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 21px;
  line-height: 1;
  margin-bottom: 1.4rem;
}
#offices .card-wrapper .card .post {
  line-height: 1;
  font-size: 1.2rem;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  margin-bottom: 5px;
}
#offices .card-wrapper .card .email {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 80%;
}
#offices .adr-slider-mobile {
  display: none;
}
@media (max-width: 767px) {
  #offices .adr-slider-mobile {
    display: block;
  }
  #offices .adr-slider-mobile .slick-list {
    padding: 0 50px; /* Optional: Adjust padding to control visibility of side slides */
  }
  #offices .adr-slider-mobile .slick-track {
    display: flex;
  }
  #offices .adr-slider-mobile .slick-slide {
    margin: 0 20px;
    max-width: 300px;
    transform: translateZ(0);
  }
  #offices .adr-slider-mobile .swiper-wrapper {
    display: flex;
  }
  #offices .adr-slider-mobile .card {
    background-color: rgba(255, 255, 255, 0.568627451);
    padding: 30px;
    flex: 1 1;
    height: 290px;
    margin: 0 20px;
  }
  #offices .adr-slider-mobile .card .city {
    font-size: 2.5rem;
    margin-bottom: 1.2rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  #offices .adr-slider-mobile .card .city {
    font-size: 26px;
    margin-bottom: 10px;
  }
}
@media (max-width: 767px) {
  #offices .adr-slider-mobile .card .adj {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    border-bottom: 1px solid black;
    line-height: 1;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin-bottom: 10px;
  }
  #offices .adr-slider-mobile .card .adj.adj1 {
    border-bottom: none;
    line-height: 1.3;
    margin-bottom: 3px;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  #offices .adr-slider-mobile .card .adj {
    font-size: 12px;
  }
  #offices .adr-slider-mobile .card .adj.adj1 {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  #offices .adr-slider-mobile .card .location {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 21px;
    line-height: 1;
    margin-bottom: 10px;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  #offices .adr-slider-mobile .card .location {
    font-size: 17px;
  }
}
@media (max-width: 767px) {
  #offices .adr-slider-mobile .card .our-location {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    border-bottom: 1px solid black;
    line-height: 1;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin-bottom: 0.5rem;
  }
  #offices .adr-slider-mobile .card .our-location.hgb {
    border-bottom: none;
  }
  #offices .adr-slider-mobile .card .lets {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    border-bottom: 1px solid black;
    line-height: 1;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin-bottom: 0.5rem;
  }
  #offices .adr-slider-mobile .card .name {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 21px;
    line-height: 1;
    margin-bottom: 1.4rem;
  }
  #offices .adr-slider-mobile .card .post {
    line-height: 1;
    font-size: 1.2rem;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    margin-bottom: 5px;
  }
  #offices .adr-slider-mobile .card .email {
    font-family: "Neue Haas Grotesk Display Pro Roman";
    line-height: 80%;
  }
}

#news {
  padding-top: 200px;
  padding-bottom: 60px;
}
#news .news-heading {
  font-size: 180px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 100%;
  text-transform: uppercase;
  line-height: 0.8;
  padding-bottom: 10px;
  margin-left: -5px;
}
@media (max-width: 767px) {
  #news .news-heading {
    line-height: 1.4;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #news .news-heading {
    font-size: 100px;
  }
}
@media only screen and (min-width: 1025px) {
  #news .news-heading {
    font-size: 140px;
  }
}
#news .news-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
@media (max-width: 767px) {
  #news .news-item {
    flex-direction: column;
    gap: 20px;
  }
}
#news .news-item .filter-wrapper {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  align-self: flex-end;
}
#news .news-item .filter-wrapper .label {
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #news .news-item .filter-wrapper {
    gap: 10px;
  }
  #news .news-item .filter-wrapper span {
    font-size: 14px;
  }
}
#news .news-item .filter-wrapper .select-div {
  border: 1px black solid;
  border-radius: 50px;
  padding: 4px 20px;
  display: flex;
  align-items: center;
  gap: 2rem;
}
@media (max-width: 767px) {
  #news .news-item .filter-wrapper .select-div {
    padding: 4px 14px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
#news .news-item .filter-wrapper .select-div select {
  text-transform: capitalize;
  border: none;
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #news .news-item .filter-wrapper .select-div select {
    font-size: 16px;
  }
}
#news .news-item.news-one {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  padding-top: 17px;
}
@media (max-width: 767px) {
  #news .news-item.news-one {
    padding-top: 14px;
    padding-bottom: 40px;
  }
}
#news .news-item.news-one .news-individual {
  padding-top: 60px;
  padding-bottom: 60px;
  border-top: black 1px solid;
  display: flex;
  gap: 2rem;
  transition: all 0.3s ease;
}
#news .news-item.news-one .news-individual:hover p.copy {
  text-decoration: underline;
}
#news .news-item.news-one .news-individual .news-image {
  flex: 1 1;
  overflow: hidden;
}
#news .news-item.news-one .news-individual .news-image .news-img-class {
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
}
#news .news-item.news-one .news-individual .news-image.news-image-copy {
  flex: 2 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 767px) {
  #news .news-item.news-one .news-individual .news-image.news-image-copy {
    gap: 20px;
  }
}
#news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
}
#news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap .award {
  border: 1px black solid;
  border-radius: 50px;
  padding: 3px 20px;
  text-align: center;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  text-transform: capitalize;
}
#news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap .copy {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 26px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  #news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap {
    gap: 20px;
  }
  #news .news-item.news-one .news-individual .news-image.news-image-copy .award-copy-wrap .copy {
    font-size: 18px;
    line-height: 1.4;
  }
}
#news .news-item.news-one .news-individual .news-image.news-image-copy .date {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 18px;
  line-height: 1.1;
}
@media (max-width: 767px) {
  #news .news-item.news-one .news-individual .news-image.news-image-copy .date {
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  #news .news-item.news-one .news-individual {
    flex-direction: column;
    gap: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
  }
}
#news .show-more {
  text-align: center;
  display: block;
  text-decoration: underline;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #news {
    padding-top: 140px;
    padding-bottom: 0;
  }
  #news .news-heading {
    font-size: 60px;
    margin: 0;
    padding: 0;
  }
}

#initatives {
  padding-top: 200px;
  padding-bottom: 60px;
}
@media (max-width: 767px) {
  #initatives {
    padding-top: 140px;
  }
}
#initatives .initatives-wrapper .initatives-flex {
  display: flex;
  flex-direction: column;
}
#initatives .initatives-wrapper .initatives-flex .flex-item {
  display: flex;
  justify-content: space-between;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flx-center {
  align-items: center;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item {
    flex-direction: column;
    align-items: flex-start;
  }
  #initatives .initatives-wrapper .initatives-flex .flex-item.flx-center {
    align-items: flex-start;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item .it-copy {
  font-size: 23px;
  line-height: 1.4;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item .it-copy {
    font-size: 22px;
    line-height: 1.3;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item .it-heading {
  font-size: 180px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  line-height: 100%;
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item .it-heading {
    font-size: 60px;
    line-height: 1.4;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item .it-heading {
    font-size: 100px;
  }
}
@media only screen and (min-width: 1025px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item .it-heading {
    font-size: 140px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it {
  padding-top: 50px;
  gap: 20px;
  row-gap: 40px;
  min-height: 340px;
  display: flex;
  flex-direction: column;
  /* Apply flex-direction: row-reverse; to every second .it-card */
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it {
    padding-top: 20px;
    gap: 40px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card {
  display: flex;
  background: rgba(255, 255, 255, 0.568627451);
  height: 380px;
  overflow: hidden;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card {
    flex: auto;
    flex-direction: column;
    height: unset;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card h3 {
  font-family: "Neue Haas Grotesk Display Pro Bold";
  font-size: 35px;
  margin-bottom: 0px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card h3 {
    font-size: 24px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card p {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card p {
    font-size: 16px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .img-wrap {
  display: flex;
  overflow: hidden;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .img-wrap img {
  flex: 1 1;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .img-wrap {
    border-radius: 20px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container {
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
  border-radius: 0;
  flex: 70% 1;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container {
    border-bottom-right-radius: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container {
    align-items: unset;
  }
}
@media only screen and (min-width: 1025px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container img {
    transition: all 0.2s ease-in-out;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container img {
    object-fit: cover;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card:hover img {
  transform: scale(1.02);
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container:nth-child(even) {
  border-radius: 0;
  overflow: hidden;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container:nth-child(odd) {
  overflow: hidden;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .hover-image-container:nth-child(odd) {
    border-bottom-left-radius: 0;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .copy-wrapper {
  padding: 30px 40px;
  flex: 30% 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .copy-wrapper {
    padding: 20px 20px;
    gap: 40px;
    flex-direction: column;
    align-items: flex-start;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .tags-container {
  font-size: 16px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  border: 1px black solid;
  padding: 5px 18px;
  border-radius: 50px;
  width: max-content;
  color: black;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .tags-container {
    font-size: 14px;
    padding: 5px 15px;
    margin-bottom: 10px;
    width: max-content;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .tag {
  background-color: black;
  width: -moz-fit-content;
  width: fit-content;
  color: white;
  padding: 3px 10px;
  border-radius: 50px;
  margin-bottom: 20px;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .copy-discription {
  line-height: 1.25;
  font-size: 17px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy .copy-discription {
    text-overflow: ellipsis;
    font-size: 13px;
  }
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .top-copy {
    flex: 1 1;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more img {
  transform: translate(-10px, 10px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more {
    gap: 5px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more p {
  font-size: 16px;
  padding-bottom: 2px;
  line-height: 1;
  width: max-content;
  position: relative;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more p {
    font-size: 13px;
    flex: 2 0;
    width: max-content;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more p::after {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  background: black;
  left: 0;
  bottom: -1px; /* Adjust to position underline closer to text */
  transition: width 0.3s ease;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more img {
  width: 10px;
  padding-bottom: 5px;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card .more img {
    width: 7px;
  }
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card:hover .more img {
  transform: translate(0, 0); /* Move to original position and reset rotation */
  opacity: 1;
}
#initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card:nth-child(even) {
  flex-direction: row-reverse;
  overflow: hidden;
}
@media (max-width: 767px) {
  #initatives .initatives-wrapper .initatives-flex .flex-item.flex-item-it .it-card:nth-child(even) {
    flex-direction: column;
  }
}

#contact-page {
  padding-top: 200px;
  padding-bottom: 60px;
}
@media (max-width: 767px) {
  #contact-page {
    padding-top: 140px;
  }
}
#contact-page .contact-wrapper .world-contact-map {
  display: flex;
  flex-direction: column;
}
#contact-page .contact-wrapper .world-contact-map .heading-contact {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  line-height: 100%;
  text-transform: lowercase;
  margin-bottom: 50px;
  text-align: center;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .heading-contact {
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #contact-page .contact-wrapper .world-contact-map .heading-contact {
    font-size: 60px;
  }
}
#contact-page .contact-wrapper .world-contact-map .world-map {
  width: 1180px;
  margin: auto;
}
#contact-page .contact-wrapper .world-contact-map .info-card {
  margin-top: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.568627451);
  padding: 30px 30px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-right: 1px solid black;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item {
    border-bottom: 1px solid black;
    border-right: none;
    padding-bottom: 20px;
  }
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item:last-child {
    border-bottom: none;
  }
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item:last-child {
  border-right: none;
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item h4 {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  font-size: 24px;
  margin-bottom: 5px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item h4 {
    font-size: 20px;
  }
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item a {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 18px;
  transition: all 0.2s ease;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item a {
    font-size: 14px;
  }
}
#contact-page .contact-wrapper .world-contact-map .info-card .card-item a:hover {
  color: #516beb;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .world-contact-map .info-card .card-item:last-child {
    padding-bottom: 0;
  }
}
#contact-page .contact-wrapper .our-offices {
  margin-top: 50px;
}
#contact-page .contact-wrapper .our-offices .office-head {
  font-size: 90px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .office-head {
    font-size: 40px;
  }
}
#contact-page .contact-wrapper .our-offices .filter {
  display: flex;
  gap: 30px;
  margin-top: 40px;
  margin-bottom: 60px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .filter {
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
    margin-top: 20px;
    margin-bottom: 0px;
  }
}
#contact-page .contact-wrapper .our-offices .filter .timezone-filter {
  border: 1px solid rgba(19, 19, 19, 0.737);
  padding: 10px 40px;
  border-radius: 30px;
  font-size: 18px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  transition: all 0.3s ease;
}
#contact-page .contact-wrapper .our-offices .filter .timezone-filter:hover {
  background: white;
  color: black;
  border: 1px solid white;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .filter .timezone-filter {
    font-size: 14px;
    padding: 8px 18px;
  }
}
#contact-page .contact-wrapper .our-offices .filter .reset-timezones {
  border: 1px solid rgba(19, 19, 19, 0.737);
  padding: 10px 40px;
  border-radius: 30px;
  font-size: 18px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  transition: all 0.3s ease;
}
#contact-page .contact-wrapper .our-offices .filter .reset-timezones:hover {
  background: white;
  color: black;
  border: 1px solid white;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .filter .reset-timezones {
    font-size: 14px;
    padding: 8px 35px;
  }
}
#contact-page .contact-wrapper .our-offices .filter .timezone-filter.active {
  background: white;
  color: black;
  border: 1px solid white;
}
#contact-page .contact-wrapper .our-offices .filter .reset-timezones {
  font-size: 18px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  align-self: center;
  transition: all 0.2s ease;
  background-color: white;
  color: black;
  border: white 1px solid;
}
#contact-page .contact-wrapper .our-offices .filter .reset-timezones:hover {
  color: gray;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .filter .reset-timezones {
    display: flex;
    flex: 1 1;
    justify-content: end;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item {
  display: none;
  padding: 80px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: black solid 1px;
  gap: 20px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 40px 0;
    gap: 20px;
  }
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:last-child {
    padding-bottom: 0;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .hover-image-container {
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
  border-radius: 15px;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:hover .hover-image-container {
  border-radius: 0;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:hover .address-item {
  animation: upToDown 0.45s;
  transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:hover img {
  transform: scale(1.1);
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .city {
  flex: 1.3 1;
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 80px;
  line-height: 0.8;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .city {
    font-size: 32px;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress {
  flex: 2 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  align-items: stretch;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress {
    width: 100%;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress h4 {
  display: none;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress h4 {
    font-size: 18px;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .icon img {
  transform: translate(-30px, 30px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .hover-image-container {
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
  border-radius: 15px;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap:hover .hover-image-container {
  border-radius: 0;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .rolling-copy-wrap {
  width: 100%;
  display: flex;
  align-items: flex-end;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap:hover .text {
  transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap:hover img {
  transform: translate(0, 0); /* Move to original position and reset rotation */
  opacity: 1;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .icon {
  flex: 0.1 1;
  display: block;
  font-weight: 400;
  display: flex;
  justify-content: flex;
  padding-bottom: 8px;
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .icon img {
  width: 20px;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .icon img {
    padding-bottom: 5px;
    width: 14px;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .text {
  flex: 1.2 1;
  font-size: 30px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap .text {
    font-size: 22px;
  }
}
@media (max-width: 767px) {
  #contact-page .contact-wrapper .our-offices .adress-wrapper .address-item .adress .adr-tag-wrap {
    font-size: 16px;
  }
}
#contact-page .contact-wrapper .our-offices .adress-wrapper .address-item:last-child {
  border-bottom: none;
}
#contact-page .contact-wrapper .our-offices .filter-applied .address-item {
  border-bottom: 0;
}

#people {
  padding-top: 200px;
  padding-bottom: 150px;
}
@media (max-width: 767px) {
  #people {
    padding-top: 140px;
  }
}
#people .people-wrapper .people-head-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 767px) {
  #people .people-wrapper .people-head-wrap {
    flex-direction: column;
    align-items: flex-start;
  }
}
#people .people-wrapper .people-head-wrap p {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 23px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  #people .people-wrapper .people-head-wrap p {
    font-size: 21px;
    line-height: 1.3;
  }
}
#people .people-wrapper .contact-heading {
  font-size: 180px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  line-height: 100%;
  text-transform: lowercase;
}
@media (max-width: 767px) {
  #people .people-wrapper .contact-heading {
    font-size: 60px;
    line-height: 1.4;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #people .people-wrapper .contact-heading {
    font-size: 100px;
  }
}
@media only screen and (min-width: 1025px) {
  #people .people-wrapper .contact-heading {
    font-size: 140px;
  }
}
#people .people-wrapper .people-card-wrapper {
  padding-top: 50px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 100px;
  row-gap: 65px;
}
@media (max-width: 767px) {
  #people .people-wrapper .people-card-wrapper {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #people .people-wrapper .people-card-wrapper {
    grid-template-columns: repeat(3, 1fr);
    column-gap: 35px;
    row-gap: 65px;
  }
}
#people .people-wrapper .img-wrap {
  flex: 1 1;
  overflow: hidden;
}
#people .people-wrapper .img-wrap img {
  transition: transform 0.3s ease-in-out; /* Smooth scaling transition */
  transform: scale(1); /* Start at normal size */
  will-change: transform; /* Optimize for smooth animations */
  transform-origin: center;
}
#people .people-wrapper .name {
  padding: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 28px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  line-height: 1.1;
  gap: 10px;
}
#people .people-wrapper .name .arrow-png {
  padding-bottom: 12px;
  transform: translate(-30px, 30px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
@media (max-width: 767px) {
  #people .people-wrapper .name .arrow-png {
    width: 20px;
    transform: translateY(0); /* Move to original position */
    opacity: 1;
    padding-bottom: 4px;
  }
}
#people .people-wrapper .name .arrow-png img {
  width: 50px;
}
@media (max-width: 767px) {
  #people .people-wrapper .name {
    font-size: 18px;
    padding: 10px;
  }
}
#people .people-wrapper .reverse {
  flex-direction: row-reverse; /* Apply reverse order */
}
@media (max-width: 767px) {
  #people .people-wrapper .reverse {
    flex-direction: row;
  }
}
@media (max-width: 767px) {
  #people .people-wrapper .reverse-mobile {
    flex-direction: row-reverse !important;
  }
}
#people .people-wrapper .people-card {
  display: flex;
  background-color: rgba(255, 255, 255, 0.568627451);
}
#people .people-wrapper .people-card:hover {
  cursor: pointer;
}
#people .people-wrapper .people-card:hover .arrow-png {
  transform: translateY(0); /* Move to original position */
  opacity: 1; /* Fully visible */
}
#people .people-wrapper .people-card:hover .img-wrap {
  overflow: hidden;
}
#people .people-wrapper .people-card:hover .img-wrap img {
  transform: scale(1.03);
}
#people .people-wrapper .people-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#people .people-wrapper .designation {
  padding: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 16px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  #people .people-wrapper .designation {
    font-size: 12px;
    padding: 10px;
  }
}

.footer-home {
  padding: 100px 0;
}
@media (max-width: 767px) {
  .footer-home {
    padding: 40px 0;
  }
}
.footer-home .footer-wrapper {
  max-width: 1100px;
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 60px;
  }
}
.footer-home .footer-wrapper .internet-logo img {
  width: 120px;
}
.footer-home .footer-wrapper .footer-item img {
  width: 130px;
}
.footer-home .footer-wrapper .footer-item a {
  line-height: 1.2;
}
.footer-home .footer-wrapper .footer-item a:hover {
  color: #516beb;
}
.footer-home .footer-wrapper .footer-item h4 {
  line-height: 1.2;
}
.footer-home .footer-wrapper .footer-item .head {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  font-size: 15px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  text-transform: capitalize;
  margin-bottom: 0.5rem;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .head {
    font-size: 13px;
    margin-bottom: 0.3rem;
  }
}
.footer-home .footer-wrapper .footer-item .head-b {
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  font-size: 16px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  text-transform: capitalize;
  margin-bottom: 0.5rem;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .head-b {
    font-size: 13px;
    margin-bottom: 0.3rem;
  }
}
.footer-home .footer-wrapper .footer-item .email {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  margin-bottom: 1rem;
  font-size: 16px;
  display: block;
  transition: all 0.2s ease;
  cursor: pointer;
}
.footer-home .footer-wrapper .footer-item .email:hover {
  color: #516beb;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .email {
    font-size: 13px;
  }
}
.footer-home .footer-wrapper .footer-item .city {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 16px;
  display: block;
  line-height: 1.6;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .city {
    font-size: 13px;
  }
}
.footer-home .footer-wrapper .footer-item .link {
  font-size: 16px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  margin-bottom: 0.3rem;
  transition: all 0.2s ease;
  cursor: pointer;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .link {
    font-size: 13px;
  }
}
.footer-home .footer-wrapper .footer-item .link:hover {
  color: #516beb;
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item .link:hover {
    color: unset;
  }
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item.order-2 {
    order: 1;
  }
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item.order-3 {
    order: 0;
  }
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item.order-0 {
    order: 0;
  }
}
@media (max-width: 767px) {
  .footer-home .footer-wrapper .footer-item.order-1 {
    order: 2;
  }
}
.cursor-circle {
  position: fixed;
  content: "drag";
  width: 50px;
  height: 50px;
  border-radius: 50%;
  top: 0;
  left: 0;
  background-color: rgb(185, 181, 181);
  z-index: 1000;
  cursor: none;
  will-change: transform;
}
.cursor-circle::after {
  content: "drag";
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 15px;
  text-transform: capitalize;
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.work-page {
  padding-top: 200px;
  padding-bottom: 80px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
@media (max-width: 767px) {
  .work-page {
    padding-top: 140px;
  }
}
.work-page .work-wrapper .work-banner {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  gap: 110px;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .work-page .work-wrapper .work-banner {
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0;
    gap: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .work-page .work-wrapper .work-banner {
    align-items: flex-start;
    flex-direction: column;
  }
}
.work-page .work-wrapper .work-banner h2 {
  font-family: "Neue Haas Grotesk Display Pro Light";
  text-transform: lowercase;
  font-size: 180px;
  line-height: 0.85;
}
@media (max-width: 767px) {
  .work-page .work-wrapper .work-banner h2 {
    font-size: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .work-page .work-wrapper .work-banner h2 {
    font-size: 100px;
  }
}
@media only screen and (min-width: 1025px) {
  .work-page .work-wrapper .work-banner h2 {
    font-size: 140px;
  }
}
.work-page .work-wrapper .work-banner p {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 23px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  .work-page .work-wrapper .work-banner p {
    font-size: 16px;
  }
}
.work-page .work-ct .total-slide {
  color: black;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  position: absolute;
  right: 0;
  top: -65px;
  font-size: 20px;
}
@media (max-width: 767px) {
  .work-page .work-ct .total-slide {
    font-size: 15px;
    top: -50px;
  }
}
.work-page .select-ct {
  display: flex;
  align-items: center;
  gap: 20px;
}
.work-page .select-ct .btn-filter {
  border-radius: 50px;
  border: 1px solid black;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  padding: 7px 20px;
  cursor: pointer;
  font-size: 18px;
  color: black;
}
.work-page .select-ct .btn-filter:hover {
  border: white;
  background-color: white;
  color: black;
  border: 1px solid white;
}
.work-page .select-ct .btn-filter.active {
  background-color: white;
  color: black;
  border: 1px solid white;
}
@media (max-width: 767px) {
  .work-page .select-ct {
    gap: 10px;
    margin-bottom: 20px;
  }
}
.work-page .select-ct .label-select {
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  .work-page .select-ct .label-select {
    font-size: 13px;
  }
}
.work-page .select-ct .select-wrapper {
  display: flex;
  gap: 20px;
}
@media (max-width: 767px) {
  .work-page .select-ct .select-wrapper {
    gap: 5px;
  }
}
.work-page .select-ct .select-wrapper li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
@media (max-width: 767px) {
  .work-page .select-ct .select-wrapper li {
    padding: 5px 0px;
  }
}
.work-page .select-ct .select-wrapper li .custom-select {
  min-width: 180px;
  max-width: 200px;
  border: none;
  outline: none;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 16px;
  cursor: pointer;
}
.work-page .select-ct .select-wrapper li .custom-select .css-13cymwt-control {
  background-color: transparent;
  border: 1px solid black;
  border-radius: 50px;
}
.work-page .select-ct .select-wrapper li .custom-select .css-t3ipsp-control {
  background-color: transparent !important;
  border-color: black !important;
  border-radius: 50px;
  box-shadow: none;
}
.work-page .select-ct .select-wrapper li .custom-select .css-b62m3t-container {
  background-color: transparent;
}
.work-page .select-ct .select-wrapper li .custom-select .css-tipsp-control {
  background-color: transparent;
}
.work-page .select-ct .select-wrapper li .custom-select .css-1xc3v61-indicatorContainer {
  color: black;
  background-color: transparent;
}
.work-page .select-ct .select-wrapper li .custom-select .css-1y632ze-singleValue {
  padding-left: 5px;
}
@media (max-width: 767px) {
  .work-page .select-ct .select-wrapper li .custom-select {
    font-size: 13px;
    min-width: 90px;
    max-width: 200px;
  }
}
.work-page .select-ct .select-wrapper li span {
  position: absolute;
  right: 10px;
}
@media (max-width: 767px) {
  .work-page .select-ct .select-wrapper li span {
    font-size: 10px;
  }
}
.work-page .work-card {
  margin-top: 40px;
  margin-bottom: 40px;
  position: relative;
  min-height: 340px;
}
@media (max-width: 767px) {
  .work-page .work-card {
    margin-top: 20px;
    margin-bottom: 40px;
  }
}
.work-page .work-card .card-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 120px;
  row-gap: 60px;
}
@media (max-width: 1200px) {
  .work-page .work-card .card-wrapper.card-wrapper {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 900px) {
  .work-page .work-card .card-wrapper.card-wrapper {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .work-page .work-card .card-wrapper.card-wrapper {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 767px) {
  .work-page .work-card .card-wrapper {
    gap: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .work-page .work-card .card-wrapper {
    justify-content: space-between;
  }
}
.work-page .Slider-heading {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 26px;
  margin-top: 100px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .work-page .Slider-heading {
    margin-top: 50px;
    font-size: 20px;
  }
}
.work-page .slider-wrapper .work-card-wrapper {
  display: flex;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .work-card-wrapper {
    gap: 10px;
  }
}
.work-page .slider-wrapper .work-card-wrapper .name {
  padding-left: 20px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 18px;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .work-card-wrapper .name {
    font-size: 14px;
    padding-left: 10px;
  }
}
.work-page .slider-wrapper .card-item .copy-wrap {
  padding: 0 20px;
  padding-bottom: 20px;
  flex: 1 1;
  display: flex;
  height: 130px;
  align-items: flex-end;
  justify-content: space-between;
}
.work-page .slider-wrapper .card-item .copy-wrap .img-wrapper {
  transform: translate(-30px, 30px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .card-item .copy-wrap .img-wrapper {
    display: block;
  }
}
.work-page .slider-wrapper .card-item .copy-wrap .img-wrapper img {
  width: 50px;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .card-item .copy-wrap .img-wrapper img {
    width: 30px;
  }
}
.work-page .slider-wrapper .card-item .copy-wrap .img-wrapper-1 {
  padding-bottom: 7px;
}
.work-page .slider-wrapper .card-item .copy-wrap .img-wrapper-1 img {
  width: 50px;
}
.work-page .slider-wrapper .card-item .copy-wrap .rolling-copy-wrap {
  padding-top: 0;
  width: 400px;
  display: flex;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .card-item .copy-wrap {
    height: 70px;
    padding: 0 10px;
    padding-bottom: 10px;
  }
}
.work-page .slider-wrapper .card-item .hover-image-container {
  flex: 2.3 1;
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
  display: flex;
  justify-content: flex-end;
  aspect-ratio: unset;
}
.work-page .slider-wrapper .card-item .hover-image-container .hover-img {
  transition: all 0.2s ease-in-out;
}
.work-page .slider-wrapper .card-item:hover .hover-image-container {
  border-radius: 0;
}
.work-page .slider-wrapper .card-item:hover .hover-img {
  transform: scale(1.02);
}
.work-page .slider-wrapper .card-item:hover {
  transition: all ease 0.2s;
}
.work-page .slider-wrapper .card-item:hover .img-wrapper {
  transform: translate(0, 0); /* Move to original position and reset rotation */
  opacity: 1;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper {
    flex: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .work-page .slider-wrapper {
    flex: 0 0 340px;
  }
}
.work-page .slider-wrapper .name-wrap {
  margin-top: 20px;
}
.work-page .slider-wrapper .category {
  margin-top: 20px;
}
.work-page .slider-wrapper .name {
  flex: 1 1;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 34px;
  line-height: 1.2;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper .name {
    font-size: 22px;
    margin-top: 10px;
  }
}
.work-page .slider-wrapper .discr {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 40px;
  line-height: 1.2;
  word-wrap: break-word;
  white-space: normal;
}
.work-page .slider-wrapper button {
  border: none; /* Remove borders */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Change cursor to pointer */
}
.work-page .slider-wrapper button.left-arrow {
  width: 55px;
  transform: rotate(180deg);
  position: absolute;
  top: -62px;
  right: 60px;
  padding: 10px;
  padding-right: 0;
  width: 40px;
  position: absolute;
  top: -45px;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper button.left-arrow {
    width: 25px;
    right: 50px;
    top: -30px;
    padding: 5px;
  }
}
.work-page .slider-wrapper button.right-arrow {
  width: 55px;
  position: absolute;
  top: -62px;
  right: 10px;
  padding: 10px;
  padding-right: 0;
  width: 40px;
  position: absolute;
  top: -45px;
  right: 0;
}
@media (max-width: 767px) {
  .work-page .slider-wrapper button.right-arrow {
    width: 25px;
    top: -30px;
    padding: 5px;
  }
}
.work-page .show-more-btn {
  border-bottom: 1px solid black;
}
.work-page .empty-filter-result {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
}

.user-card .card-wrapper {
  display: flex;
}

.wrapper-player .player {
  padding: 5rem 0;
  padding-top: 140px;
  width: 90%;
}
@media only screen and (min-width: 1025px) {
  .wrapper-player .player {
    min-height: 100vh;
  }
}
@media (max-width: 767px) {
  .wrapper-player .player {
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 40px;
    width: 100%;
  }
}
.wrapper-player .player .player-copy-wrapper {
  gap: 30px;
}
.wrapper-player .player .player-copy-wrapper .player-gif {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_62___}), auto;
  width: 100%;
  height: auto;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-copy-wrapper {
    flex-direction: column;
    gap: 10px;
  }
}
.wrapper-player .player .player-copy-wrapper .page-copy {
  flex: 1.2 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-copy-wrapper .page-copy {
    gap: 10px;
  }
}
.wrapper-player .player .player-copy-wrapper .page-copy .top-left-copy {
  font-size: 55px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.2;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-copy-wrapper .page-copy .top-left-copy {
    font-size: 28px;
  }
}
.wrapper-player .player .player-copy-wrapper .page-copy .top-bottom-copy {
  font-size: 22px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-copy-wrapper .page-copy .top-bottom-copy {
    font-size: 16px;
  }
}
.wrapper-player .player .player-container {
  flex: 2 1;
  margin: 0 auto;
}
@media (max-width: 767px) {
  .wrapper-player .player .player-container {
    margin: unset;
  }
}
.wrapper-player .player .player-head {
  font-size: 46px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
@media (max-width: 767px) {
  .wrapper-player .player .player-head {
    font-size: 30px;
  }
}
.wrapper-player .player .nav-work-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wrapper-player .player .nav-work-wrapper a {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  text-decoration: underline;
}
.wrapper-player .player .player-para {
  font-size: 24px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
.wrapper-player .player .player-wrapper-small {
  position: relative;
  padding-top: 56.25%;
  background: #000;
  overflow: hidden;
}
.wrapper-player .player .player-wrapper-small .spinner span {
  border: 3px solid white;
  border-right-color: rgba(119, 119, 119, 0.702);
}
.wrapper-player .player .player-wrapper-small .react-player {
  position: absolute;
  top: 0;
  left: 0;
}
.wrapper-player .player .copy-thumbnail {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 22px;
  margin-top: 20px;
}
@media (max-width: 767px) {
  .wrapper-player .player .copy-thumbnail {
    font-size: 16px;
  }
}
.wrapper-player .player .video-thumbnails {
  margin-top: 20px;
  gap: 20px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
}
@media (max-width: 767px) {
  .wrapper-player .player .video-thumbnails {
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
  }
}
.wrapper-player .player .video-thumbnails .thumbnail-item {
  overflow: hidden;
  max-width: 140px;
  border: 1px solid transparent;
  transition: all 0.3s ease;
  position: relative;
}
.wrapper-player .player .video-thumbnails .thumbnail-item:hover {
  border: 1px solid white;
}
.wrapper-player .player .video-thumbnails .thumbnail-item .vimeo-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3 ease;
  color: rgba(255, 255, 255, 0.7607843137);
  font-size: 24px;
}
.wrapper-player .player .video-thumbnails .thumbnail-item:hover .vimeo-play-icon {
  color: white;
}
@media (max-width: 767px) {
  .wrapper-player .player .video-thumbnails .thumbnail-item {
    flex: 0 0 24%;
  }
}
.wrapper-player .video-details {
  background-color: white;
  padding: 64px 0;
}
@media (max-width: 767px) {
  .wrapper-player .video-details {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.wrapper-player .video-details .video-detail-wrapper {
  max-width: 1110px;
  display: flex;
  gap: 130px;
  flex-direction: row-reverse;
}
@media (max-width: 767px) {
  .wrapper-player .video-details .video-detail-wrapper {
    gap: 50px;
    flex-direction: column-reverse;
  }
}
.wrapper-player .video-details .video-detail-wrapper .detail-item {
  display: flex;
  flex-direction: column;
  flex: 1.2 1;
  gap: 2rem;
}
.wrapper-player .video-details .video-detail-wrapper .detail-item .client {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  width: max-content;
  line-height: 1;
  margin-bottom: 5px;
  font-size: 30px;
}
@media (max-width: 767px) {
  .wrapper-player .video-details .video-detail-wrapper .detail-item .client {
    font-size: 28px;
  }
}
.wrapper-player .video-details .video-detail-wrapper .detail-item .work-title {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: black;
  font-size: 17px;
  margin-top: 12px;
}
@media (max-width: 767px) {
  .wrapper-player .video-details .video-detail-wrapper .detail-item .work-title {
    font-size: 16px;
    margin-top: 7px;
  }
}
.wrapper-player .video-details .video-detail-wrapper .detail-item-2 {
  flex: 2 1;
}
.wrapper-player .shoot-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 64px 0;
  padding-bottom: 6rem;
}
@media (max-width: 767px) {
  .wrapper-player .shoot-image {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.wrapper-player .shoot-image .head-copy {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 60px;
  margin-bottom: 32px;
  line-height: 1;
  text-align: center;
}
@media (max-width: 767px) {
  .wrapper-player .shoot-image .head-copy {
    font-size: 40px;
    margin-bottom: 20px;
  }
}
.wrapper-player .shoot-image .image-wrapper {
  position: relative;
}
.wrapper-player .shoot-image .image-wrapper .slick-slide {
  padding: 0 20px;
}
.wrapper-player .shoot-image .image-wrapper .img-flex-item {
  flex: 1 0 48%;
  overflow: hidden;
}
.wrapper-player .shoot-image .image-wrapper .img-flex-item img {
  width: 100%;
}
.wrapper-player .all-details {
  background-color: white;
  padding: 4rem 0;
  padding-top: 32px;
}
@media (max-width: 767px) {
  .wrapper-player .all-details {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
.wrapper-player .all-details .all-details-wrapper {
  max-width: 1110px;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper {
  padding: 40px 0;
  display: flex;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper {
    flex-direction: column;
    padding: 20px 0;
    row-gap: 10px;
    align-items: flex-start;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper:last-child {
  border-bottom: none;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .title {
  flex: 1.5 0;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .title h4 {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 34px;
  width: -moz-fit-content;
  width: fit-content;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .title h4 {
    font-size: 28px;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy {
  flex: 2 1;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item {
  flex: 1 1 28%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item {
    gap: 0px;
    width: 100%;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-head {
  font-size: 48px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  margin-bottom: 5px;
  line-height: 1.2;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-head img {
  width: 100px;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-head {
    font-size: 38px;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-head img {
    width: 80px;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-para {
  font-size: 14px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  color: black;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-para {
    text-align: start;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-meta {
  display: flex;
  align-items: center;
  column-gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-start;
  color: #808080;
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-meta p {
  font-size: 14px;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy .copy-item .copy-meta {
    justify-content: center;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.copy-text {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  line-height: 1.4;
  font-size: 20px;
  color: black;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.copy-text {
    font-size: 16px;
    margin-top: 0px;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  justify-items: flex-start;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
    width: 100%;
    margin-top: 20px;
    align-items: center;
    gap: 20px;
  }
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile .copy-item {
    gap: 10px;
  }
}
@media (max-width: 1200px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
}
@media (max-width: 900px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.award-mobile {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    row-gap: 30px;
    width: 100%;
    align-items: flex-start;
  }
}
.wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: start;
  gap: 30px;
}
@media (max-width: 767px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-top: 20px;
    align-self: center;
    gap: 20px;
  }
}
@media (max-width: 1200px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile.result-mobile {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
}
@media (max-width: 900px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile.result-mobile {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .wrapper-player .all-details .all-details-wrapper .wrapper-flex .flex-item-wrapper .copy.result-mobile.result-mobile {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    row-gap: 30px;
    width: 100%;
  }
}
.wrapper-player .related-work {
  padding: 64px 0;
}
@media (max-width: 767px) {
  .wrapper-player .related-work {
    padding: 40px 0;
  }
}
.wrapper-player .related-work .related-work-wrapper .head-copy {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 60px;
  margin-bottom: 2rem;
  text-align: center;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .head-copy {
    font-size: 40px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .wrapper-flex {
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item {
  flex: 1 0 48%;
  display: flex;
  flex-direction: column;
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .hover-image-container {
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover .hover-image-container {
  border-radius: 0;
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover .discr, .wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover .arrow-wrapper > img {
  transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover img {
  transform: scale(1.1);
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .main-image {
  margin-bottom: 10px;
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title .name {
  margin-top: 0px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 16px;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title .name {
    font-size: 14px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title h4 {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 20px;
  line-height: 1.2;
  margin-bottom: 5px;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title h4 {
    font-size: 22px;
    margin-bottom: 0px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .img-title .view-more {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 13px;
  border-bottom: 1px solid black;
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .rolling-copy-wrap .arrow-png {
  width: 20px;
  transform: translate(-10px, 10px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
@media (max-width: 767px) {
  .wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item .rolling-copy-wrap .arrow-png-1 {
    width: 20px;
    padding-bottom: 5px;
  }
}
.wrapper-player .related-work .related-work-wrapper .wrapper-flex .flex-item:hover .arrow-png {
  transform: translate(0, 0); /* Move to original position and reset rotation */
  opacity: 1;
}

.spinner {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.spinner span {
  display: block;
  width: 30px;
  height: 30px;
  border: 3px solid transparent;
  border-radius: 50%;
  border-right-color: rgba(0, 0, 0, 0.7019607843);
  animation: spinner-anim 0.8s linear infinite;
}
.spinner.spinner-int {
  top: 85%;
}
.spinner.spinner-news {
  top: 85%;
}

@keyframes spinner-anim {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.reset-btn {
  font-family: "Neue Haas Grotesk Display Pro Bold";
  text-decoration: underline;
}

.scroll-down-svg {
  left: 50%;
  transform: translateY(0%) rotate(45deg);
  opacity: 1;
}

.scroll-down-svg1 {
  width: 2em;
  height: 2em;
  background-color: transparent;
  z-index: 80;
  bottom: 40px;
  position: absolute;
  border-width: 0 0.25em 0.25em 0;
  border-style: solid;
  border-color: rgb(0, 0, 0);
  animation: scrolldown 1.2s ease-in-out infinite;
}

.scroll-down-svg2 {
  width: 2em;
  height: 2em;
  background-color: transparent;
  z-index: 80;
  bottom: 60px;
  position: absolute;
  border-width: 0 0.16em 0.16em 0;
  border-style: solid;
  border-color: white;
}
@media (max-width: 767px) {
  .scroll-down-svg2 {
    bottom: 20px;
    width: 1em;
    height: 1em;
    border-width: 0 0.14em 0.14em 0;
  }
}

@keyframes scrolldown {
  0% {
    transform: translateY(20%) rotate(45deg);
    opacity: 0.7;
  }
  50% {
    transform: translateY(0%) rotate(45deg);
    opacity: 0.1;
  }
  100% {
    transform: translateY(20%) rotate(45deg);
    opacity: 0.7;
  }
}
.hover-image-container {
  position: relative;
  margin-bottom: 10px;
  aspect-ratio: 16/9;
  overflow: hidden;
}
.hover-image-container::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #e5e5e5;
  opacity: 0;
  transition: 0.4s ease all;
}
.hover-image-container .main-image {
  transition: 0.4s ease all;
  width: 100%;
  object-fit: cover;
}

.rolling-copy-wrap {
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .rolling-copy-wrap {
    padding-top: 5px;
    padding-top: 5px;
    align-items: flex-end;
    padding-right: 5px;
  }
}

@keyframes upToDown {
  49% {
    transform: translateY(-100%);
  }
  50% {
    opacity: 0;
    transform: translateY(100%);
  }
  51% {
    opacity: 1;
  }
}
.divider {
  border-bottom: 1px solid;
}

#news {
  padding-top: 200px;
  padding-bottom: 60px;
}
@media (max-width: 767px) {
  #news {
    padding-top: 120px;
    padding-bottom: 40px;
  }
}
#news .news-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#news .news-header h2 {
  font-size: 140px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  text-transform: lowercase;
  line-height: 100%;
  margin-bottom: 50px;
}
@media (max-width: 767px) {
  #news .news-header h2 {
    font-size: 60px;
    margin-bottom: 20px;
  }
}
#news .news-header .filter-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
}
#news .news-list {
  min-height: 340px;
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  margin-top: 60px;
  row-gap: 60px;
}
#news .news-list .news-item {
  display: flex;
  align-items: flex-start;
  gap: 35px;
  border-bottom: 1px solid black;
  padding-bottom: 40px;
}
#news .news-list .news-item:last-child {
  border-bottom: none;
}
#news .news-list .news-item .tumbnail-img {
  flex: 1 1;
}
#news .news-list .news-item .copy-wrap {
  flex: 2.7 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#news .news-list .news-item .arrow-wrapper {
  flex: 0.07 1;
}
#news .news-list .news-item .arrow-wrapper img {
  padding-top: 2px;
  padding-right: 2px;
}
#news .news-list .news-item .hover-image-container {
  transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);
  border-radius: 15px;
}
@media (max-width: 767px) {
  #news .news-list .news-item .hover-image-container {
    border-radius: 7px;
  }
}
#news .news-list .news-item:hover .hover-image-container {
  border-radius: 0;
}
#news .news-list .news-item:hover .news-title, #news .news-list .news-item:hover .arrow-wrapper > img {
  animation: upToDown 0.45s;
  transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}
#news .news-list .news-item:hover img {
  transform: scale(1.1);
}
#news .news-list .news-item .news-title {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 28px;
  line-height: 1.4;
}
@media (max-width: 767px) {
  #news .news-list .news-item .news-title {
    font-size: 15px;
  }
}
#news .news-list .news-item .date {
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 14px;
}
@media (max-width: 767px) {
  #news .news-list .news-item {
    flex-direction: row;
    gap: 10px;
    padding-bottom: 20px;
    border-bottom: 0.7px solid;
  }
}
@media (max-width: 767px) {
  #news .news-list {
    margin-top: 25px;
    row-gap: 25px;
  }
}
/* LIGHTBOX  */
.yarl__button.yarl__navigation_next,
.yarl__button.yarl__navigation_prev {
  display: none;
}

.yarl__portal_open {
  z-index: 100000;
}

.show-more-button {
  border: 1px solid rgba(19, 19, 19, 0.737);
  border: none;
  padding: 4px 12px;
  font-size: 16px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  transition: all 0.3s ease;
  padding: 0;
  border-bottom: 1px solid;
  cursor: pointer;
}
.show-more-button:hover {
  color: white;
}

.show-more-wrap {
  position: relative;
  display: flex;
  margin-top: 60px;
  justify-content: center;
}
@media (max-width: 767px) {
  .show-more-wrap {
    margin-top: 25px;
  }
}

.react-player {
  width: 100% !important;
  height: 100% !important;
}
.react-player .Button_module_button__a2d215de {
  display: none;
}

.react-player iframe {
  width: 100%;
  height: 100%;
}

.back-link {
  transition: all 0.2s ease;
}
.back-link:hover {
  color: white;
}

/* SCATTER ANIMATION */
.scatter-section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 770px;
  position: relative;
  overflow: unset;
}
@media (max-width: 767px) {
  .scatter-section {
    overflow: hidden;
    padding-top: 0px;
    padding-bottom: 0px;
    height: 650px;
  }
}
.scatter-section .image-container {
  position: absolute;
  border-radius: 10px;
  cursor: pointer;
  flex-direction: column;
}
.scatter-section .image-container .image {
  width: 100%;
}
.scatter-section .image-container .text-overlay {
  margin-top: 10px;
  font-family: "Neue Haas Grotesk Display Pro Roman";
  font-size: 15px;
}
@media (max-width: 767px) {
  .scatter-section .image-container .text-overlay {
    bottom: 5px;
    left: 3px;
    font-size: 10px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    margin-top: 7px;
  }
}
.scatter-section .center-text {
  font-size: 100px;
  font-family: "Neue Haas Grotesk Display Pro Light";
  line-height: 100%;
  color: white;
  text-align: center;
  z-index: 1;
}
@media (max-width: 767px) {
  .scatter-section .center-text {
    font-size: 34px;
    font-family: "Neue Haas Grotesk Display Pro Roman";
    font-size: 40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .scatter-section .center-text {
    font-size: 60px;
  }
}

.skeleton-wrap span {
  border-radius: 0;
}

.add-accounts-page-css .container-ad {
  max-width: 1200px;
  margin: 0 auto;
  width: 90%;
}
@media (max-width: 767px) {
  .add-accounts-page-css .container-ad {
    max-width: 320px;
  }
}
.add-accounts-page-css header {
  padding: 52px 0;
}
@media (max-width: 767px) {
  .add-accounts-page-css header {
    padding: 20px 0;
  }
}
@media (max-width: 767px) {
  .add-accounts-page-css header .logo {
    width: 120px;
  }
}
.add-accounts-page-css header nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.add-accounts-page-css header .nav-list {
  display: flex;
  align-items: center;
}
.add-accounts-page-css header .nav-list .nav-item {
  font-size: 14px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  margin-right: 31px;
  letter-spacing: 0%;
  color: #6e5e7e;
}
@media (max-width: 767px) {
  .add-accounts-page-css header .nav-list .nav-item {
    margin-right: 0;
  }
}
.add-accounts-page-css header a {
  display: block;
}
.add-accounts-page-css header .login-btn,
.add-accounts-page-css header .getin-btn {
  font-family: "Manrope Regular";
  font-size: 15px;
  line-height: 20px;
  padding: 12px 25px;
  border-radius: 40px;
  letter-spacing: -0.23px;
}
.add-accounts-page-css header .login-btn {
  border: 1px solid black;
  margin-right: 10px;
  margin-left: 97px;
}
@media (max-width: 767px) {
  .add-accounts-page-css header .login-btn {
    margin-left: 0;
    margin-right: 0;
  }
}
.add-accounts-page-css header .getin-btn {
  background: rgb(143, 55, 200);
  background: linear-gradient(0deg, rgb(143, 55, 200) 0%, rgb(159, 63, 181) 8%, rgb(210, 89, 125) 22%, rgb(242, 105, 91) 39%, rgb(255, 112, 78) 51%, rgb(255, 101, 104) 65%, rgb(255, 94, 125) 79%, rgb(255, 143, 107) 98%);
  color: white;
}
.add-accounts-page-css header .hamburger-1 {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 34px;
  height: 18px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1000;
}
.add-accounts-page-css header .hamburger-1 .bar {
  width: 100%;
  height: 2px;
  background-color: #5c3688;
  transition: all 0.3s ease;
}
.add-accounts-page-css header .hamburger-1.active .bar:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}
.add-accounts-page-css header .hamburger-1.active .bar:nth-child(2) {
  opacity: 0;
}
.add-accounts-page-css header .hamburger-1.active .bar:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}
@media screen and (max-width: 768px) {
  .add-accounts-page-css header .nav-list {
    position: fixed;
    top: -100%;
    right: 0;
    width: 100%;
    background-color: white;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: top 0.4s ease;
  }
  .add-accounts-page-css header .nav-list.active {
    padding-top: 100px;
    top: 0;
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: white;
    gap: 20px;
    z-index: 5;
  }
  .add-accounts-page-css header .hamburger-1 {
    display: flex;
  }
}
.add-accounts-page-css .no-scroll {
  overflow: hidden;
  height: 100%;
  position: fixed;
  width: 100%;
}
.add-accounts-page-css .scroll-top-btn {
  background-color: red;
  background: linear-gradient(0deg, rgb(143, 55, 200) 0%, rgb(159, 63, 181) 8%, rgb(210, 89, 125) 22%, rgb(242, 105, 91) 39%, rgb(255, 112, 78) 51%, rgb(255, 101, 104) 65%, rgb(255, 94, 125) 79%, rgb(255, 143, 107) 98%);
  font-size: 25px;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
.add-accounts-page-css main #home .hero-copy {
  margin-top: 12px;
  font-family: "Manrope Semibold";
  font-size: 57px;
  line-height: 70px;
  color: #5c3688;
  margin-bottom: 40px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .hero-copy {
    text-align: center;
    font-size: 32px;
    line-height: 1.2;
    margin-top: 40px;
    margin-bottom: 50px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css main #home .hero-copy {
    font-size: 50px;
    text-align: center;
    line-height: 70px;
  }
}
.add-accounts-page-css main #home .services {
  display: grid;
  grid-template-columns: repeat(2, 2fr);
  gap: 35px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .services {
    display: grid;
    grid-template-columns: repeat(2, 2fr);
    gap: 35px;
  }
}
.add-accounts-page-css main #home .wrapper {
  display: flex;
  gap: 20px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper {
    align-items: center;
    flex-direction: column;
  }
}
.add-accounts-page-css main #home .orange-ring {
  width: 60px;
  height: 60px;
  border: 2px solid #f17380;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-accounts-page-css main #home .orange-ring p {
  font-family: "Manrope Regular";
  color: #6e5e7e;
  font-size: 30px;
}
.add-accounts-page-css main #home .copy {
  color: #6e5e7e;
  font-family: "Manrope Regular";
  line-height: 28px;
  font-size: 28px;
  font-weight: 600;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .copy {
    line-height: 1.2;
    font-size: 20px;
    text-align: center;
  }
}
.add-accounts-page-css main #home .homepage-btn {
  margin-top: 52px;
  display: flex;
  justify-content: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .homepage-btn {
    margin-top: 40px;
  }
}
.add-accounts-page-css main #home .login-btn {
  font-family: "Manrope Regular";
  font-size: 15px;
  line-height: 20px;
  padding: 22px 44px;
  border: 1px solid black;
  border-radius: 40px;
  margin-right: 20px;
  letter-spacing: -0.23px;
}
.add-accounts-page-css main #home .getin-btn {
  font-family: "Manrope Regular";
  font-size: 15px;
  line-height: 20px;
  padding: 22px 83px;
  border-radius: 40px;
  background: rgb(143, 55, 200);
  background: linear-gradient(0deg, rgb(143, 55, 200) 0%, rgb(159, 63, 181) 8%, rgb(210, 89, 125) 22%, rgb(242, 105, 91) 39%, rgb(255, 112, 78) 51%, rgb(255, 101, 104) 65%, rgb(255, 94, 125) 79%, rgb(255, 143, 107) 98%);
  color: white;
  letter-spacing: -0.23px;
}
.add-accounts-page-css main #home .wrapper-form-banner {
  display: flex;
  gap: 0px;
  align-items: start;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner {
    flex-direction: column;
    align-items: stretch;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .wrapper-form-form {
  flex: 1 1;
  padding: 15px 40px;
  margin-top: 10px;
  background: linear-gradient(0deg, rgb(143, 55, 200) 0%, rgb(159, 63, 181) 8%, rgb(210, 89, 125) 22%, rgb(242, 105, 91) 39%, rgb(255, 112, 78) 51%, rgb(255, 101, 104) 65%, rgb(255, 94, 125) 79%, rgb(255, 143, 107) 98%);
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .wrapper-form-form {
    padding: 20px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .wrapper-form-copy {
  flex: 1.6 1;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch {
  margin-bottom: 0;
  padding-bottom: 0px;
  display: flex;
  flex-direction: column;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch div {
  border-radius: 8px;
  width: 100%;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .input-wrapper {
  margin-top: 7px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .input-wrapper {
    gap: 5px;
  }
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .input-wrapper label {
    text-align: center;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .wrapper-radio-btn {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0;
  gap: 0px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .wrapper-radio-btn {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .error-form {
  font-family: "Manrope Semibold";
  font-size: 13px;
  padding-top: 5px;
  text-align: left;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .error-wrapper {
  padding: 0;
  margin-top: 10px;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-btn-section {
  justify-content: center;
  padding: 0;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch h2 {
  text-align: center;
  font-family: "Manrope Semibold";
  color: white;
  font-size: 20px;
  padding-bottom: 20px;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch form {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .form-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .form-grid {
    display: flex;
    flex-direction: column;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch label {
  font-weight: bold;
  color: white;
  margin-bottom: 5px;
  font-family: "Manrope Semibold";
  font-size: 30px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch label {
    font-size: 22px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch select {
  padding: 7px 20px;
  border: 1px solid white;
  border-radius: 50px;
  font-size: 18px;
  width: 100%;
  color: white !important;
  font-family: "DM Sans Regular";
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch input[type=text],
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch input[type=number] {
  padding: 7px 20px;
  border: 1px solid white;
  border-radius: 50px;
  font-size: 18px;
  width: 100%;
  color: white !important;
  font-family: "DM Sans Regular";
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch input::placeholder {
  color: white; /* Placeholder text color */
  font-size: 18px; /* Font size */
  opacity: 0.8; /* Thoda transparent effect */
  font-family: "DM Sans Regular";
  text-transform: capitalize;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-label {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  font-size: 22px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-label {
    font-size: 15px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-input {
  width: 16px;
  height: 16px;
  margin-right: 15px;
  padding: 10px;
  border-radius: 50%;
  border: 2px solid #5c3688;
  transition: background-color 0.3s, border 0.3s;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-input {
    padding: 7px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-input:checked {
  background-color: #4f1d89;
  border-color: #4f1d89;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .radio-input:checked + .radio-label {
  font-weight: bold;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch p {
  color: red;
  font-size: 14px;
  margin: 0;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch button {
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch button:hover {
  background-color: #45a049;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch div > div {
  text-align: center;
  border-radius: 8px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch div > div {
    text-align: center;
    padding-bottom: 0;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .back-plate {
  padding: 40px;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch h4 {
  color: #5c3688;
  font-family: "Manrope Semibold";
  font-size: 40px;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch h4 {
    font-size: 28px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .success-p {
  color: #5c3688;
  font-family: "Manrope Regular";
  font-size: 30px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch .success-p {
    font-size: 18px;
  }
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch button {
  background-color: white;
  padding: 15px 20px;
  font-size: "Manrope Regular";
  font-size: 22px;
  color: #5c3688;
  font-size: 20px;
  line-height: 20px;
  padding: 12px 25px;
  border-radius: 40px;
  letter-spacing: -0.23px;
  margin: auto;
}
.add-accounts-page-css main #home .wrapper-form-banner .form-wrapper-get-in-touch button:hover {
  background-color: #470e89;
}
.add-accounts-page-css main .msg-btn {
  position: fixed;
  bottom: 0;
  width: 90px;
  bottom: 20px;
  right: 20px;
  width: 90px;
  z-index: 10;
}
.add-accounts-page-css main .msg-btn img {
  border-radius: 50%;
  border: solid 1px white;
}
@media (max-width: 767px) {
  .add-accounts-page-css main .msg-btn {
    width: 40px;
  }
}
.add-accounts-page-css main #about {
  position: relative;
}
.add-accounts-page-css main #about .swiper-container {
  margin-top: 134px;
  width: 100%;
  overflow: hidden;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #about .swiper-container {
    margin-top: 60px;
  }
}
.add-accounts-page-css main #about .swiper-slide {
  width: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-accounts-page-css main #about .hero-img {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
}
.add-accounts-page-css main #about .dot-img {
  flex-grow: 1;
}
.add-accounts-page-css main #partnership {
  padding-top: 167px;
}
.add-accounts-page-css main #partnership .partnership-wrapper {
  text-align: center;
}
.add-accounts-page-css main #partnership .head-copy {
  font-size: 80px;
  line-height: 90px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css main #partnership .head-copy {
    font-size: 40px;
    line-height: 50px;
  }
}
.add-accounts-page-css main #partnership .copy {
  margin-top: 33px;
  font-size: 30px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  line-height: 40px;
}
.add-accounts-page-css main #mediaSpend {
  margin-top: 120px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #mediaSpend {
    margin-top: 50px;
  }
}
.add-accounts-page-css main #mediaSpend .spand-wrapper {
  display: flex;
  justify-content: center;
}
.add-accounts-page-css main #mediaSpend .img-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.add-accounts-page-css main #mediaSpend .copy-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.add-accounts-page-css main #mediaSpend .copy-wrapper h4 {
  color: #5c3688;
  font-size: 100px;
  line-height: 100px;
  font-weight: 600;
  font-family: "Manrope Regular";
  text-align: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #mediaSpend .copy-wrapper h4 {
    font-size: 60px;
    line-height: 1.2;
  }
}
.add-accounts-page-css main #mediaSpend .copy-wrapper p {
  color: #5c3688;
  font-size: 60px;
  line-height: 70px;
  font-weight: 600;
  font-family: "Manrope Regular";
  text-align: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #mediaSpend .copy-wrapper p {
    font-size: 45px;
    line-height: 1.2;
  }
}
.add-accounts-page-css main #knowmore {
  padding-top: 157px;
}
.add-accounts-page-css main #knowmore .knowmore-wrapper {
  max-width: 1071px;
  margin: auto;
}
.add-accounts-page-css main #knowmore .card-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 137px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #knowmore .card-wrapper {
    flex-direction: column;
  }
}
.add-accounts-page-css main #knowmore .card-img {
  flex: 1 1;
}
.add-accounts-page-css main #knowmore .card-copy {
  flex: 1 1;
}
.add-accounts-page-css main #knowmore .card-title {
  font-size: 40px;
  line-height: 90px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css main #knowmore .card-title {
    line-height: 50px;
  }
}
.add-accounts-page-css main #knowmore .card-discription {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  line-height: 30px;
  width: 338px;
}
.add-accounts-page-css main #knowmore .learnmore-btn {
  margin-top: 11px;
  font-size: 15px;
  font-family: "Manrope Regular";
  line-height: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.add-accounts-page-css main #sliderContainer {
  padding-top: 0px;
  padding-bottom: 160px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px -4px 11px -4px inset;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer {
    padding-top: 0;
    padding-bottom: 120px;
    box-shadow: rgba(0, 0, 0, 0.19) 1px -10px 11px -4px inset;
  }
}
.add-accounts-page-css main #sliderContainer .wrapper {
  position: relative;
  display: flex;
  justify-content: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .wrapper {
    display: block;
  }
}
.add-accounts-page-css main #sliderContainer .heading-slider-2 {
  font-family: "Manrope Semibold";
  font-size: 60px;
  line-height: 90px;
  text-align: center;
  color: #5c3688;
  margin-bottom: 60px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .heading-slider-2 {
    font-size: 40px;
    line-height: 1.2;
    margin-bottom: 40px;
  }
}
.add-accounts-page-css main #sliderContainer .swiper-container {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  top: 61px;
  bottom: 0;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .swiper-container {
    position: static;
    display: block;
    width: 100%;
    position: absolute;
    display: block;
    left: 50%;
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
    bottom: unset;
  }
}
.add-accounts-page-css main #sliderContainer .swiper-wrapper {
  max-width: 1200px;
}
.add-accounts-page-css main #sliderContainer .swiper-slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: visible;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .swiper-slide {
    padding: 0 40px;
    width: 100%;
  }
}
.add-accounts-page-css main #sliderContainer .swiper-button-next:after {
  content: unset;
}
.add-accounts-page-css main #sliderContainer .swiper-button-prev:after {
  content: unset;
}
.add-accounts-page-css main #sliderContainer .swiper-button-next2,
.add-accounts-page-css main #sliderContainer .swiper-button-prev2 {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 44px;
  height: 44px;
  position: absolute; /* Ensure absolute positioning */
  top: 50%;
  transform: translateY(-50%); /* Center vertically */
  z-index: 10; /* Ensure buttons are on top */
  cursor: pointer;
}
.add-accounts-page-css main #sliderContainer .swiper-button-next2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .swiper-button-next2 {
    width: 30px;
    right: -5px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css main #sliderContainer .swiper-button-next2 {
    right: 150px;
  }
}
.add-accounts-page-css main #sliderContainer .swiper-button-prev2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .swiper-button-prev2 {
    width: 30px;
    left: -5px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css main #sliderContainer .swiper-button-prev2 {
    left: 150px;
  }
}
.add-accounts-page-css main #sliderContainer .heading,
.add-accounts-page-css main #sliderContainer .city {
  font-size: 28px;
  line-height: 34px;
  font-family: "Manrope Regular";
  font-weight: 600;
  color: #5c3688;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .heading,
  .add-accounts-page-css main #sliderContainer .city {
    text-align: center;
  }
}
.add-accounts-page-css main #sliderContainer .para {
  font-size: 18px;
  line-height: 24px;
  margin-top: 16px;
  font-family: "Manrope Regular";
  font-weight: 400;
  color: #5c3688;
  text-align: center;
  margin-bottom: 16px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #sliderContainer .para {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
}
.add-accounts-page-css main #multichannel {
  padding-top: px;
}
.add-accounts-page-css main #multichannel .head-title {
  font-size: 80px;
  line-height: 90px;
  font-family: "Manrope Semibold";
  text-align: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #multichannel .head-title {
    font-size: 35px;
    line-height: 45px;
  }
}
.add-accounts-page-css main #multichannel .head-copy {
  font-size: 30px;
  line-height: 40px;
  font-family: "Manrope Semibold";
  text-align: center;
  margin-bottom: 93px;
}
.add-accounts-page-css main #multichannel .card-wrapper {
  margin-top: 93px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 339px;
  row-gap: 199px;
  position: relative;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #multichannel .card-wrapper {
    grid-template-columns: unset;
  }
}
.add-accounts-page-css main #multichannel .center-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.add-accounts-page-css main #multichannel .card-title {
  font-size: 40px;
  font-family: "Manrope Semibold";
  line-height: 90px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #multichannel .card-title {
    line-height: 50px;
  }
}
.add-accounts-page-css main #multichannel .card-copy {
  font-size: 20px;
  font-family: "Manrope Semibold";
  line-height: 30px;
}
.add-accounts-page-css main #cardSection {
  padding-top: 80px;
}
.add-accounts-page-css main #cardSection .heading-cardSection {
  font-size: 60px;
  line-height: 90px;
  color: #5c3688;
  font-family: "Manrope Semibold";
  text-align: center;
  margin-bottom: 32px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .heading-cardSection {
    font-size: 40px;
    line-height: 1.2;
  }
}
.add-accounts-page-css main #cardSection .card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.add-accounts-page-css main #cardSection .row {
  display: flex;
  width: 100%;
  position: relative;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .row {
    flex-direction: column;
  }
}
.add-accounts-page-css main #cardSection .top-cards .card {
  width: 30%;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .top-cards .card {
    width: 100%;
  }
}
.add-accounts-page-css main #cardSection .center-card {
  position: relative;
}
.add-accounts-page-css main #cardSection .center-card .card {
  width: 45%;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .center-card .card {
    width: 100%;
  }
}
.add-accounts-page-css main #cardSection .card {
  padding: 16px;
  padding-top: 23px;
  padding-bottom: 76px;
  flex-grow: 1;
  position: relative;
}
.add-accounts-page-css main #cardSection .heading-card {
  font-size: 28px;
  font-family: "Manrope Semibold";
  line-height: 34px;
  color: #5c3688;
  margin-bottom: 15px;
}
.add-accounts-page-css main #cardSection .copy-card {
  font-size: 18px;
  font-family: "Manrope Regular";
  line-height: 24px;
  color: #5c3688;
  position: relative;
  z-index: 5;
}
.add-accounts-page-css main #cardSection .top-cards .card {
  border-bottom: 1px solid rgba(92, 54, 136, 0.2);
  z-index: 5; /* Add border-right to all cards except the last one */
}
.add-accounts-page-css main #cardSection .top-cards .card:not(:last-child) {
  border-right: 1px solid rgba(92, 54, 136, 0.2); /* Add border-right to all cards except the last one */
  z-index: 5; /* Add border-right to all cards except the last one */
}
.add-accounts-page-css main #cardSection .center-card .card:not(:last-child) {
  border-right: 1px solid rgba(92, 54, 136, 0.2); /* Add border-right to all cards except the last one */
  z-index: 5; /* Add border-right to all cards except the last one */
}
.add-accounts-page-css main #cardSection .card-container .row .card::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  background-color: rgba(92, 54, 136, 0.2);
  border-radius: 50%;
  z-index: 10;
}
.add-accounts-page-css main #cardSection .top-cards .card:not(:last-child)::after {
  top: 100%;
  right: -4px;
  transform: translateY(-50%);
  z-index: 10;
}
.add-accounts-page-css main #cardSection .center-card .card:not(:last-child)::after {
  top: 100%;
  right: -4px;
  transform: translateY(-50%);
  top: 0;
  z-index: 10;
}
.add-accounts-page-css main #cardSection .circle-pink {
  margin-bottom: 30px;
}
.add-accounts-page-css main #cardSection .card-4 {
  padding-left: 211px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .card-4 {
    padding-left: 16px;
    border-bottom: 1px solid rgba(92, 54, 136, 0.2);
  }
}
.add-accounts-page-css main #cardSection .card-5 {
  padding-right: 211px;
}
@media (max-width: 767px) {
  .add-accounts-page-css main #cardSection .card-5 {
    padding: 16px;
  }
}
.add-accounts-page-css main #cardSection .card-5::after {
  content: unset !important;
  width: unset;
}
.add-accounts-page-css main #cardSection .card-3::after {
  content: unset !important;
  width: unset;
}
@media (max-width: 767px) {
  .add-accounts-page-css .scroll-container {
    padding-top: 60px;
  }
}
.add-accounts-page-css .section {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-accounts-page-css .pin-section {
  position: relative;
  height: 100vh;
  display: flex;
  overflow: hidden;
  justify-content: center;
  flex-direction: row-reverse;
  gap: 40px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .pin-section {
    flex-direction: column-reverse;
    gap: 20px;
  }
}
.add-accounts-page-css .pin-section .card-copy {
  flex: 1 1;
}
.add-accounts-page-css .pin-section .learnmore-btn {
  margin-top: 11px;
  font-size: 15px;
  font-family: "Manrope Regular";
  line-height: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.add-accounts-page-css .text-container,
.add-accounts-page-css .image-container {
  flex: 1 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767px) {
  .add-accounts-page-css .text-container,
  .add-accounts-page-css .image-container {
    align-items: unset;
    top: 30px;
  }
}
.add-accounts-page-css .text-container {
  overflow: hidden;
}
.add-accounts-page-css .text-slide {
  position: absolute;
  width: 100%;
  opacity: 0;
  color: #5c3688;
}
.add-accounts-page-css .text-slide .card-title {
  font-size: 40px;
  line-height: 90px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css .text-slide .card-title {
    font-size: 24px;
    line-height: 50px;
  }
}
.add-accounts-page-css .text-slide .card-discription {
  font-size: 20px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  line-height: 30px;
  width: 338px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .text-slide .card-discription {
    font-size: 15px;
    line-height: 1.4;
  }
}
.add-accounts-page-css .image-slide {
  position: absolute;
  width: 400px;
  height: 400px;
  background-size: cover;
  background-position: center;
  opacity: 0;
  padding: 100px 0;
}
@media (max-width: 767px) {
  .add-accounts-page-css .image-slide {
    width: 300px;
    height: 300px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css .image-slide {
    width: 300px;
    height: 300px;
  }
}
.add-accounts-page-css .image-slide.backmeta {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}
.add-accounts-page-css .image-slide.google-ads {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
}
.add-accounts-page-css .image-slide.tiktok {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}
.add-accounts-page-css .image-slide.tabola {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
}
.add-accounts-page-css .image-slide.snap {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
}
.add-accounts-page-css .accordion-section {
  padding-top: 89px;
}
.add-accounts-page-css .accordion-section .heading-acc {
  font-size: 60px;
  line-height: 90px;
  color: #5c3688;
  text-align: center;
  margin-bottom: 50px;
  font-family: "Manrope Semibold";
}
@media (max-width: 767px) {
  .add-accounts-page-css .accordion-section .heading-acc {
    font-size: 40px;
    line-height: 1.2;
  }
}
.add-accounts-page-css .accordion-section .accordion {
  width: 80%;
  margin: 0 auto;
}
.add-accounts-page-css .accordion-section .accordion-item {
  border: 1px solid rgba(92, 54, 136, 0.2);
  margin-bottom: 20px;
  border-radius: 20px;
}
.add-accounts-page-css .accordion-section .accordion-button {
  border: none;
  padding: 30px;
  padding: 30px 100px;
  text-align: left;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #5c3688;
  font-size: 28px;
  background: transparent;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}
.add-accounts-page-css .accordion-section .accordion-button span {
  font-size: 28px;
  width: 36px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .accordion-section .accordion-button {
    padding: 30px;
    gap: 5px;
  }
  .add-accounts-page-css .accordion-section .accordion-button .btn-copy {
    font-size: 18px;
    line-height: 22px;
  }
}
.add-accounts-page-css .accordion-section .accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease;
  padding: 0 30px;
  font-size: 18px;
  color: #5c3688;
  padding: 0 100px;
  margin-left: 36px;
}
.add-accounts-page-css .accordion-section .accordion-content.show {
  max-height: 1000px;
}
.add-accounts-page-css .accordion-section .accordion-content p {
  font-family: "Manrope Regular";
}
@media (max-width: 767px) {
  .add-accounts-page-css .accordion-section .accordion-content {
    padding: 0 20px;
  }
}
.add-accounts-page-css .accordion-section .accordion-content p {
  font-family: "Manrope Regular";
  font-size: 18px;
  line-height: 24px;
  color: #5c3688;
  margin-bottom: 30px;
}
.add-accounts-page-css .accordion-section .accordion-content.show {
  max-height: 1000px; /* Arbitrarily large value to ensure content is visible */
}
.add-accounts-page-css #cardContact {
  padding-top: 116px;
}
@media (max-width: 767px) {
  .add-accounts-page-css #cardContact {
    padding-top: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .add-accounts-page-css #cardContact {
    padding: 64px 50px;
  }
}
.add-accounts-page-css #cardContact .wrapper {
  display: flex;
  background-color: #f17380;
  justify-content: space-between;
  padding: 83px 121px;
  border-radius: 20px;
}
@media (max-width: 767px) {
  .add-accounts-page-css #cardContact .wrapper {
    flex-direction: column;
    padding: 30px;
  }
}
.add-accounts-page-css #cardContact .wrapper a {
  font-family: "Manrope Regular";
  font-size: 18px;
  line-height: 34px;
  font-weight: 600;
  color: white;
}
.add-accounts-page-css #cardContact .wrapper p {
  font-family: "Manrope Regular";
  font-size: 18px;
  line-height: 34px;
  font-weight: 600;
  color: white;
}
@media (max-width: 767px) {
  .add-accounts-page-css #cardContact .wrapper p {
    font-size: 14px;
  }
}
.add-accounts-page-css .footer-add {
  margin-top: 106px;
  padding-top: 56px;
  padding-bottom: 80px;
  background-color: #5c3688;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
    background-position: bottom;
    background-size: contain;
    background-repeat: no-repeat;
    padding-bottom: 80px;
    margin-top: 80px;
  }
}
.add-accounts-page-css .footer-add .footer-wrapper-ad {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .footer-wrapper-ad {
    flex-direction: column;
    gap: 30px;
  }
}
.add-accounts-page-css .footer-add .footer-wrapper-ad .privacy-policy {
  font-family: "DM Sans Regular";
  font-size: 16px;
  color: white;
}
.add-accounts-page-css .footer-add .logo {
  width: 200px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .logo {
    width: 150px;
  }
}
.add-accounts-page-css .footer-add .nav-list {
  display: flex;
  align-items: center;
}
.add-accounts-page-css .footer-add .nav-list a {
  display: block;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .nav-list {
    flex-direction: column;
    gap: 20px;
  }
}
.add-accounts-page-css .footer-add .nav-item {
  font-size: 14px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  margin-right: 31px;
  letter-spacing: 0%;
  color: white;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .nav-item {
    margin-right: 0;
  }
}
.add-accounts-page-css .footer-add .footer-hero-img {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: 100%;
  bottom: 10px;
}
.add-accounts-page-css .footer-add .footer-hero-img img {
  flex-grow: 1;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .footer-hero-img {
    bottom: 10px;
  }
}
.add-accounts-page-css .footer-add .copyright-copy {
  color: white;
  font-size: 14px;
  font-family: "Neue Haas Grotesk Display Pro Mediu";
  line-height: 40px;
  text-align: center;
  bottom: 32px;
}
@media (max-width: 767px) {
  .add-accounts-page-css .footer-add .copyright-copy {
    font-size: 14px;
    width: 100%;
    left: unset;
    transform: unset;
    text-align: center;
    bottom: 10px;
  }
}

.privacy-policy-media-solution {
  padding: 40px 0;
}
.privacy-policy-media-solution .privacy-policy-wrapper h1 {
  font-family: "Neue Haas Grotesk Display Pro Bold";
  font-size: 30px;
  text-align: center;
  padding-bottom: 40px;
}
.privacy-policy-media-solution .privacy-policy-wrapper p {
  font-family: "Neue Haas Grotesk Display Pro Light";
  font-size: 20px;
}
.privacy-policy-media-solution .privacy-policy-wrapper h2 {
  font-family: "DM Sans Bold";
  font-size: 24px;
  margin: 20px 0;
}
.privacy-policy-media-solution .privacy-policy-wrapper h3 {
  font-family: "DM Sans Regular";
  font-size: 24px;
  margin: 20px 0;
}

.build-ecomm-page-css .container_ecom {
  max-width: 900px;
  margin: 0 auto;
  width: 90%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .build-ecomm-page-css .container_ecom {
    width: 90%;
    max-width: 768px;
    margin: 0 auto;
  }
}
@media (max-width: 767px) {
  .build-ecomm-page-css .container_ecom {
    width: 320px;
    margin: 0 auto;
  }
}
.build-ecomm-page-css .container-1 {
  max-width: 1200px;
  margin: 0 auto;
  width: 90%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .build-ecomm-page-css .container-1 {
    width: 90%;
    max-width: 768px;
    margin: 0 auto;
  }
}
@media (max-width: 767px) {
  .build-ecomm-page-css .container-1 {
    width: 320px;
    margin: 0 auto;
  }
}
.build-ecomm-page-css .banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.build-ecomm-page-css .banner .wrapper {
  padding: 6rem 0;
  max-width: 1100px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper {
    padding-bottom: 3rem;
    padding-top: 3rem;
  }
}
.build-ecomm-page-css .banner .wrapper .gredient_back {
  position: absolute;
  width: 400px;
  right: 0px;
  z-index: 5;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .gredient_back {
    width: 225px;
    bottom: 10px;
    position: absolute;
    right: 0;
  }
}
.build-ecomm-page-css .banner .wrapper .gredient_back .time {
  width: 100%;
  position: absolute;
  z-index: 7;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.build-ecomm-page-css .banner .wrapper .gredient_back .time i {
  font-size: 50px;
}
.build-ecomm-page-css .banner .wrapper .gredient_back .time h4 {
  text-align: center;
  font-family: "DM Sans Bold";
  font-size: 20px;
  line-height: 1.3;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .gredient_back .time h4 {
    font-size: 12px;
  }
}
.build-ecomm-page-css .banner .wrapper .logo-section {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: -moz-fit-content;
  width: fit-content;
}
.build-ecomm-page-css .banner .wrapper .logo-section p {
  text-align: end;
  margin-bottom: 5px;
  font-family: "DM Sans Regular";
  font-size: 12px;
  margin-right: -4px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .logo-section p {
    padding-right: unset;
  }
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second {
  display: flex;
  align-items: stretch;
  gap: 20px;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo {
  display: flex;
  border: 1px solid black;
  align-items: center;
  padding: 10px 20px;
  border-radius: 8px;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo.logo-p {
  position: relative;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo.logo-p p {
  position: absolute;
  top: -10px;
  right: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo .blink_logo {
  width: 250px;
}
.build-ecomm-page-css .banner .wrapper .logo-section .flex-second .logo .olm_logo {
  width: 65px;
}
.build-ecomm-page-css .banner .wrapper .hero-copy {
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
  z-index: 10;
}
.build-ecomm-page-css .banner .wrapper .hero-copy a {
  display: block;
  margin: 0 auto;
}
.build-ecomm-page-css .banner .wrapper .hero-copy h2 {
  font-size: 4rem;
  font-family: "DM Sans Bold";
  line-height: 1;
  text-align: center;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .hero-copy h2 {
    font-size: 2rem;
  }
}
.build-ecomm-page-css .banner .wrapper .para {
  position: relative;
  z-index: 10;
  font-family: "DM Sans Regular";
  font-size: 20px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .para {
    font-size: 14px;
  }
}
.build-ecomm-page-css .banner .wrapper .btn {
  position: relative;
  z-index: 10;
  display: inline-block;
  font-size: 1.5rem;
  font-family: "DM Sans Regular";
  background-color: black;
  color: #e977c1;
  padding: 15px 30px;
  border: 1px solid black;
  border-radius: 50px;
  margin: 20px 0;
  margin: auto;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .banner .wrapper .btn {
    font-size: 16px;
    padding: 10px 30px;
  }
}
.build-ecomm-page-css .banner .wrapper .btn:hover {
  background-color: transparent;
  color: black;
  transition: 0.5s;
}
.build-ecomm-page-css .why_us .wrapper {
  padding: 4rem 0;
}
.build-ecomm-page-css .why_us .wrapper .flex-logo-wrapper {
  margin-top: 4rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 50px;
  column-gap: 50px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper .flex-logo-wrapper {
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2rem;
    gap: 10px;
  }
}
.build-ecomm-page-css .why_us .wrapper .logo-copy-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f1f1f3;
  padding: 30px;
  text-align: center;
  border-radius: 10px;
  gap: 10px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper .logo-copy-item {
    padding: 15px;
    gap: 5px;
  }
}
.build-ecomm-page-css .why_us .wrapper .logo-copy-item img {
  width: 80px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper .logo-copy-item img {
    width: 40px;
  }
}
.build-ecomm-page-css .why_us .wrapper h2 {
  font-size: 3rem;
  font-family: "DM Sans Bold";
  margin-bottom: 10px;
  background: linear-gradient(345deg, #e5b400, #e05300, #e977c1, #516beb);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper h2 {
    font-size: 24px;
    text-align: center;
  }
}
.build-ecomm-page-css .why_us .wrapper p {
  font-size: 20px;
  font-family: "DM Sans Regular";
  padding-top: 20px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .why_us .wrapper p {
    font-size: 14px;
    padding-top: 5px;
  }
}
.build-ecomm-page-css .agenda {
  padding: 4rem 0;
  background-color: #f2f2f2;
}
.build-ecomm-page-css .agenda .wrapper .head {
  display: flex;
  align-items: baseline;
  font-size: 20px;
  font-family: "DM Sans Regular";
  margin-bottom: 30px;
  justify-content: space-between;
}
.build-ecomm-page-css .agenda .wrapper h2 {
  color: black;
  font-size: 3rem;
  font-family: "DM Sans Bold";
  text-transform: uppercase;
}
.build-ecomm-page-css .agenda .wrapper .lunch {
  background: linear-gradient(90deg, #e46f2f, #e05301, #e4ad00, #c58403, #ed86ae);
  display: flex;
  padding: 10px 20px;
  justify-content: space-between;
}
.build-ecomm-page-css .agenda .wrapper .lunch .copy {
  padding-left: 50px;
  font-size: 1.1rem;
  font-family: "DM Sans Bold";
  color: white;
  text-transform: uppercase;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .lunch .copy {
    padding-left: 0;
  }
}
.build-ecomm-page-css .agenda .wrapper .lunch .time {
  font-size: 1.1rem;
  font-family: "DM Sans Bold";
  color: white;
  text-transform: uppercase;
  padding-right: 50px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .lunch .time {
    padding-right: 0;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap {
  display: flex;
  flex-wrap: wrap;
  row-gap: 0px;
  column-gap: 2rem;
  padding-bottom: 30px;
  padding-top: 20px;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap {
    flex-direction: column;
    padding-bottom: 20px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card {
  width: 48%;
  display: flex;
  align-items: flex-start;
  padding: 20px 0;
  gap: 20px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card {
    width: 100%;
    padding: 20px 0;
    gap: 10px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .img-wrap img {
  border-radius: 50%;
  width: 100px;
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .name {
  font-size: 20px;
  font-family: "DM Sans Bold";
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .para {
  font-size: 20px;
  font-family: "DM Sans Regular";
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position {
  display: flex;
  gap: 14px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position {
    flex-direction: column;
    gap: 5px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position .copy {
  font-family: "DM Sans Regular";
  color: #6d6d6d;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position .copy {
    font-size: 13px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position .time {
  font-family: "DM Sans Bold";
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .position .time {
    font-size: 14px;
  }
}
.build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .tag {
  font-size: 16px;
  font-family: "DM Sans Bold";
  background: linear-gradient(345deg, #facc35, #ee2a23, #f58121);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "DM Sans Bold";
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .card-wrap .card .info .tag {
    font-size: 12px;
  }
}
.build-ecomm-page-css .agenda .wrapper .center-tag {
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .center-tag {
    padding-bottom: 0px;
  }
}
.build-ecomm-page-css .agenda .wrapper .center-tag .position {
  display: flex;
  gap: 3rem;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .center-tag .position {
    flex-direction: column;
    align-items: center;
    gap: 0;
  }
}
.build-ecomm-page-css .agenda .wrapper .center-tag .position .copy {
  font-family: "DM Sans Regular";
  color: #6d6d6d;
}
.build-ecomm-page-css .agenda .wrapper .center-tag .position .time {
  font-family: "DM Sans Bold";
}
@media (max-width: 767px) {
  .build-ecomm-page-css .agenda .wrapper .center-tag .position .time {
    font-size: 14px;
  }
}
.build-ecomm-page-css .details {
  padding: 4rem 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.build-ecomm-page-css .details .wrapper h2 {
  color: white;
  font-size: 3rem;
  font-family: "DM Sans Bold";
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper h2 {
    font-size: 24px;
    text-align: center;
  }
}
.build-ecomm-page-css .details .wrapper iframe {
  width: 100%;
}
.build-ecomm-page-css .details .wrapper iframe .HMRMj {
  display: none;
}
.build-ecomm-page-css .details .wrapper iframe .HB1eCd-UMrnmb {
  background-color: red;
}
.build-ecomm-page-css .details .wrapper iframe .HB1eCd-UMrnmb .teQAzf {
  width: 100% !important;
}
.build-ecomm-page-css .details .wrapper iframe .HB1eCd-UMrnmb body {
  background-color: transparent !important;
}
.build-ecomm-page-css .details .wrapper iframe .HB1eCd-UMrnmb .D8bnZd {
  background-color: rgba(62, 18, 107, 0) !important;
}
.build-ecomm-page-css .details .wrapper .form_container_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container {
  display: flex;
  gap: 1rem;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .form_container {
    flex-direction: column;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .form_1 {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  flex-grow: 1;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .form_container .form_1 {
    flex-direction: column;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap {
  width: 48%;
  position: relative;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap {
    width: 100%;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap .error_form {
  font-size: 12px;
  color: red;
  position: absolute;
  bottom: -14px;
  margin: 0;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap.field-wrap-2 {
  width: 100%;
  position: relative;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .field-wrap.field-wrap-2 .error_form {
  font-size: 12px;
  color: red;
  position: absolute;
  bottom: 5px;
  margin: 0;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .input_css {
  max-width: 100%;
  width: 100%;
  background-color: #f2f2f2;
  font-size: 16px;
  padding: 18px 10px;
  border-radius: 5px;
  flex-grow: 1;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .form_container .input_css::placeholder {
  color: #9d9d9d;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .form_container .input_css {
    width: 100%;
    padding: 14px 10px;
    font-size: 16px;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .input_css_2 {
  background-color: #f2f2f2;
  font-size: 24px;
  padding: 18px 10px;
  border-radius: 5px;
  font-family: "DM Sans Regular";
}
.build-ecomm-page-css .details .wrapper .form_container_1 .input_css_2::placeholder {
  color: #9d9d9d;
  font-size: 16px;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .input_css_2 {
    padding: 14px 10px;
    font-size: 16px;
  }
}
.build-ecomm-page-css .details .wrapper .form_container_1 .input_css_1 {
  background-color: #f2f2f2;
  font-size: 16px;
  padding: 18px 10px;
  border-radius: 5px;
  font-family: "DM Sans Regular";
  width: 100%;
}
.build-ecomm-page-css .details .wrapper .form_container_1 .input_css_1::placeholder {
  color: #9d9d9d;
  font-size: 16px;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper .form_container_1 .input_css_1 {
    padding: 14px 10px;
    font-size: 16px;
    height: 150px;
  }
}
.build-ecomm-page-css .details .wrapper a {
  display: inline-block;
  font-size: 1.5rem;
  font-family: "DM Sans Regular";
  color: #e977c1;
  padding: 15px 30px;
  border: none;
  border-radius: 50px;
  margin: 40px 0;
  color: white;
  background-color: transparent;
  border: 1px solid white;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .details .wrapper a {
    margin: 30px 0;
    padding: 10px 30px;
    font-size: 17px;
    display: block;
    text-align: center;
    /* margin: auto 0; */
    margin-left: auto;
    margin-right: auto;
    width: -moz-fit-content;
    width: fit-content;
  }
}
.build-ecomm-page-css .details .wrapper a:hover {
  background-color: black;
  color: #e977c1;
  border: 1px solid black;
  transition: 0.5s;
}
.build-ecomm-page-css .footer-ecom {
  padding: 2rem 0;
  position: absolute;
  width: 100%;
  background-color: #f2f2f2;
}
.build-ecomm-page-css .footer-ecom .wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .footer-ecom .wrapper {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
}
.build-ecomm-page-css .footer-ecom .wrapper .logo {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.build-ecomm-page-css .footer-ecom .wrapper .logo img {
  width: 130px;
}
.build-ecomm-page-css .footer-ecom .wrapper .logo p {
  font-family: "DM Sans Medium";
}
.build-ecomm-page-css .footer-ecom .wrapper .email_wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: "DM Sans Regular";
}
.build-ecomm-page-css .footer-ecom .wrapper .email_wrap p {
  font-family: "DM Sans Medium";
}
.build-ecomm-page-css .footer-ecom .wrapper .email_wrap .flex-footer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
@media (max-width: 767px) {
  .build-ecomm-page-css .footer-ecom .wrapper .email_wrap .flex-footer {
    flex-direction: column;
    align-items: center;
  }
}
@media (max-width: 767px) {
  .build-ecomm-page-css .footer-ecom .wrapper .email_wrap {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }
}

.logo-main-css .banner-relative {
  position: relative;
}
.logo-main-css .absolute-copy {
  position: absolute;
  top: 50%;
  color: white;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: "Manrope Bold";
  font-size: 60px;
}
@media (max-width: 767px) {
  .logo-main-css .absolute-copy {
    font-size: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .logo-main-css .absolute-copy {
    font-size: 24px;
  }
}
.logo-main-css .wrapper-logo-row {
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  gap: 100px;
}
.logo-main-css .wrapper-logo-row .grid-logo {
  display: grid;
  grid-template-columns: repeat(3, 3fr);
  gap: 50px;
}
@media (max-width: 767px) {
  .logo-main-css .wrapper-logo-row .grid-logo {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 40px;
  }
}
.logo-main-css .wrapper-logo-row .card-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}
.logo-main-css .wrapper-logo-row .img-box {
  background-color: gray;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  padding: 50px;
  justify-content: center;
  background-color: rgb(248, 248, 248);
  border: 1px solid rgba(0, 0, 0, 0.176);
  border-radius: 6px;
}
.logo-main-css .wrapper-logo-row .btn-dow {
  background-color: rgba(0, 0, 0, 0);
  color: black;
  padding: 6px 12px;
  font-size: 16px;
  border: 1px solid black;
  border-radius: 6px;
}

.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 20px;
}

.not-found-container .container {
  padding: 40px;
  border-radius: 16px;
  max-width: 500px;
  width: 100%;
}

.not-found-container h1 {
  font-size: 3.2rem;
  margin-bottom: 10px;
  font-family: "DM Sans Bold";
  color: #000;
  text-transform: capitalize;
}
@media (max-width: 767px) {
  .not-found-container h1 {
    font-size: 1.5rem;
  }
}

.not-found-container p {
  font-size: 1.1rem;
  margin-bottom: 40px;
  font-family: "Manrope Light";
}

.cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
  text-transform: capitalize;
  font-weight: bold;
  transition: background-color 0.3s ease;
  transition: border 0.3s ease;
  font-family: "Manrope Regular";
  font-size: 26px;
  padding-bottom: 2px;
  border-bottom: 2px solid transparent;
}
.cta-button img {
  width: 20px;
}
@media (max-width: 767px) {
  .cta-button {
    font-size: 1.2rem;
  }
  .cta-button img {
    width: 16px;
  }
}

.cta-button:hover img {
  transform: translate(15px, -15px); /* Move the arrow from bottom left */
  opacity: 0; /* Start with the arrow hidden */
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/main.scss"],"names":[],"mappings":"AACA;EACE,kDAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAIA;EACE,iDAAA;EACA,oHAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAMA;EACE,kDAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AALF;AAQA;EACE,kDAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAPF;AAUA;EACE,kDAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AATF;AAYA;EACE,mDAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAXF;AAcA;EACE,kDAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAbF;AAgBA;EACE,iDAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAfF;AAiBA;EACE,yDAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAhBF;AAmBA;EACE,yDAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAlBF;AAuBA,cAAA;AAaA,UAAA;AAQA;EACE,2BAAA;EACA,sHAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAzCF;AA4CA;EACE,iCAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA3CF;AA8CA;EACE,6BAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA7CF;AAgDA;EACE,gCAAA;EACA,sHAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA/CF;AAkDA;EACE,4BAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAjDF;AAoDA;EACE,+BAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAnDF;AAsDA;EACE,8BAAA;EACA,sHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AArDF;AAwDA,cAAA;AAWA;EACE,8BAAA;EACA,sHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAjEF;AAoEA;EACE,gCAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAnEF;AAsEA;EACE,2BAAA;EACA,sHAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;AArEF;AAwEA;EACE,6BAAA;EACA,sHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAvEF;AA0EA;EACE,6BAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAzEF;AA4EA;EACE,iCAAA;EACA,sHAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA3EF;AA8EA,cAAA;AAYA,WAAA;AA8BA,cAAA;AAEA;;;GAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,cAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AAtHF;;AAyHA,gDAAA;AACA;;;;;;;;;;;EAWE,cAAA;AAtHF;;AAyHA;EACE,cAAA;AAtHF;;AAyHA;;EAEE,gBAAA;AAtHF;;AAyHA;;EAEE,YAAA;AAtHF;;AAyHA;;;;EAIE,WAAA;EACA,aAAA;AAtHF;;AAyHA;EACE,yBAAA;EACA,iBAAA;AAtHF;;AAyHA;EACE,sBAAA;AAtHF;;AAyHA;EASE,qBAAA;AA9HF;AAsHE;EAKE,cAAA;AAxHJ;;AA8HA;;;EAGE,kBAAA;AA3HF;;AAqIA;EACE,WAAA;AAlIF;;AAqIA;EACE,YAAA;AAlIF;;AAqIA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAlIF;;AAqIA;EACE,OAAA;EACA,cAAA;EACA,WAAA;AAlIF;AAoIE;EAEE,WAAA;EACA,cAAA;AAnIJ;AAsIE;EACE,WAAA;AApIJ;;AAwIA;EACE,aAAA;AArIF;;AAwIA;;;EAGE,gBAAA;EACA,gBAAA;AArIF;;AAwIA;EACE,gBAAA;AArIF;;AAwIA;EACE,YAAA;AArIF;;AAwIA,YAAA;AAEA;EACE,mCAAA;EACA,qBAAA;AAtIF;;AAyIA;;EAEE,WAAA;AAtIF;;AAyIA;;;;EAIE,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AAtIF;;AAyIA;;EAEE,uBAAA;EACA,YAAA;AAtIF;;AAyIA;;;;;EAKE,aAAA;AAtIF;;AAyIA;EACE,cAAA;EACA,eAAA;AAtIF;;AAyIA;;;;;;;;EAQE,gBAAA;AAtIF;;AAyIA;EACE,gBAAA;AAtIF;;AAyIA;EACE,cAAA;EACA,eAAA;EACA,YAAA;AAtIF;;AAyIA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAtIF;;AAyIA,YAAA;AACA;EACE,0BAAA;AAtIF;;AAyIA;EACE,yBAAA;AAtIF;;AAyIA;EACE,yBAAA;AAtIF;;AAhLI;EAyTJ;IAEI,wBAAA;EAtIF;AACF;;AA9LI;EAuUJ;IAEI,wBAAA;EAtIF;AACF;;AAhMI;EAyUJ;IAEI,wBAAA;EAtIF;AACF;;AAyIA;EACE,WAAA;EACA,YAAA;AAtIF;;AAyIA;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AAtIF;AAjNI;EAoVJ;IAOI,gBAAA;EAtIF;AACF;AA1NI;EAwVJ;IAWI,WAAA;IACA,eAAA;EArIF;AACF;;AAwIA,aAAA;AAIA;EACE,kBAAA;AAxIF;;AA2IA;EACE,uBAAA;AAxIF;;AA2IA;EACE,uBAAA;EACA,YAAA;AAxIF;;AA0IA;EACE,uBAAA;EACA,YAAA;AAvIF;;AA4IA,kBAAA;AACA;EACE,iBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,sEAAA;EAEA,6BAAA;EACA,YAAA;EACA,WAAA;EAEA,6BAAA;EACA,yBAAA;AA3IF;AAjQI;EAgYJ;IAcI,eAAA;EAzIF;AACF;;AA4IA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAzIF;AA9QI;EAkZJ;IAOI,cAAA;IACA,iBAAA;EAvIF;AACF;;AA0IA;EACE,YAAA;AAvIF;AAxRI;EA8ZJ;IAGI,YAAA;IACA,uCAAA;EArIF;AACF;;AAwIA,uBAAA;AAEA;EACE,aAAA;EACA,mBAAA;AAtIF;AApSI;EAwaJ;IAII,WAAA;IACA,kBAAA;IACA,WAAA;IACA,OAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;EApIF;AACF;AA/SI;EAobF;IAEI,iBAAA;IACA,oBAAA;IACA,WAAA;IACA,aAAA;IACA,uBAAA;EAnIJ;AACF;AAsIE;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AApIJ;AA/TI;EA8bF;IAOI,sBAAA;IACA,mBAAA;IACA,SAAA;EAlIJ;AACF;AAqIM;EACE,yBAAA;AAnIR;AAzUI;EA0cA;IAUI,SAAA;EAvIN;EAkIM;IACE,gBAAA;IACA,eAAA;IACA,kDApnBF;EAofN;AACF;;AAuIA,sBAAA;AAEA;EACE,aAAA;EACA,eAAA;AArIF;AAzVI;EA4dJ;IAII,kBAAA;IACA,cAAA;EAnIF;AACF;;AAsIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAnIF;;AAsIA;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;AAnIF;;AAsIA;EACE,wCAAA;AAnIF;;AAsIA;EACE,UAAA;AAnIF;;AAsIA;EACE,0CAAA;AAnIF;;AAsIA,wBAAA;AAOA;EACE;IACE,kCAAA;EAzIF;EA2IA;IACE,iCAAA;EAzIF;AACF;AA2IA;EAKE,iBAAA;AA7IF;AAvYI;EA+gBJ;IAOI,gBAAA;EA3IF;AACF;AA6IE;EAEE,qBAAA;EACA,kDA9rBI;EA+rBJ,YAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EAWA,+BAAA;AAtJJ;AAuJI;EASE,uBAAA;AA7JN;AAgKE;EACE,yCAAA;AA9JJ;;AAiKA;EACE,eAAA;AA9JF;;AAiKA,2BAAA;AACA;EACE;IAEE,kBAAA;EA/JF;EAkKA;IACE,cAAA;EAhKF;AACF;AAqKA;EACE,iBAAA;AAnKF;AAwKU;EACE,cA7uBL;AAukBP;;AA8KA;EAEE,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAllBA,aAAA;EAqlBA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAzKF;AAjcI;EA6lBJ;IAeI,kBAAA;IACA,qBAAA;IACA,YAAA;EAvKF;AACF;AA0KM;EACE,YAAA;AAxKR;AA6KM;EACE,YAAA;AA3KR;AAgLI;EACE,kDApyBE;EAqyBF,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AA9KN;AArdI;EA8nBA;IAQI,eAAA;IACA,gBAAA;EA7KN;AACF;AAvdI;EA0nBA;IAYI,eAAA;EA3KN;AACF;AA8KI;EACE,kDApzBE;EAqzBF,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AA5KN;AAveI;EA8oBA;IAQI,eAAA;EA3KN;AACF;AAxeI;EA0oBA;IAWI,gBAAA;EAzKN;AACF;AA4KI;EACE,gBAAA;EACA,kDAj0BE;EAk0BF,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AA1KN;AAzfI;EA6pBA;IAQI,kBAAA;IAEA,gBAAA;IACA,eAAA;EAzKN;AACF;AA5fI;EAypBA;IAcI,eAAA;EAvKN;AACF;AA2KE;;;EA7pBA,aAAA;EAkqBE,mBAAA;EACA,uBAAA;EACA,iBAAA;AAtKJ;;AA0KA;EACE,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,+BAAA;AAvKF;;AA0KA;EAGE,iBAAA;AAzKF;AA5hBI;EAksBJ;IAMI,iBAAA;IACA,iBAAA;EAxKF;AACF;AA0KE;EACE,aAAA;EACA,sBAAA;EAEA,kBAAA;AAzKJ;AAviBI;EA4sBF;IAOI,UAAA;IACA,SAAA;EAxKJ;AACF;AA8KM;EACE,aAAA;AA5KR;AAhjBI;EA2tBE;IAUI,UAAA;EAjLR;AACF;AAjjBI;EAutBE;IAiBI,YAAA;IACA,aAAA;EAnLR;AACF;AAqLQ;EACE,iBAAA;AAnLV;AAqLQ;EACE,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kDAz5BF;EA05BE,eAAA;AAnLV;AArkBI;EAmvBI;IAQI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EAlLV;AACF;AAsLM;EACE,gBAAA;EACA,kDAz6BA;EA06BA,iBAAA;EACA,iBAAA;AApLR;AArlBI;EAqwBE;IAOI,eAAA;EAnLR;AACF;AAuLI;EAGE,mBAAA;AAvLN;AA4LM;EACE,kBAAA;AA1LR;AA4LQ;EACE,+EAAA;EAKA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EAGA,aAAA;AAhMV;AAzmBI;EA4xBI;IAeI,+BAAA;IACA,gCAAA;EA9LV;AACF;AAgMQ;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AA9LV;AArnBI;EA+yBI;IAOI,WAAA;IACA,WAAA;EA7LV;AACF;AA3nBI;EAixBA;IA6CI,mBAAA;EA/LN;AACF;AAiMM;EACE,iBAAA;AA/LR;AAsMM;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;AApMR;AAzoBI;EAy0BE;IASI,gBAAA;EArMR;AACF;AAsMQ;EACE,kBAAA;AApMV;AAjpBI;EAo1BI;IAGI,kBAAA;EAlMV;AACF;AAoMQ;EACE,uBAAA;AAlMV;AAoMQ;EACE,eAAA;EACA,kDAjgCF;EAkgCE,gBAAA;EACA,UAAA;AAlMV;AA/pBI;EA61BI;IAMI,eAAA;EAhMV;AACF;AAoMM;EAQE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;AAzMR;AA7qBI;EAw2BE;IAgBI,sBAAA;EAvMR;AACF;AA6MQ;EAEE,mBAAA;EACA,iBAAA;EACA,kDAriCF;EAsiCE,eAAA;EACA,2BAAA;EAAA,sBAAA;AA5MV;AAzrBI;EA+3BI;IASI,eAAA;IACA,eAAA;IACA,iBAAA;IACA,YAAA;EA3MV;AACF;AA8MQ;EACE,eAAA;EACA,kDAnjCF;EAojCE,gBAAA;AA5MV;AAtsBI;EA+4BI;IAKI,eAAA;EA1MV;AACF;AA3sBI;EAw2BE;IAiDI,oBAAA;IACA,gBAAA;IACA,gBAAA;IAEA,YAAA;IAEA,sBAAA;IACA,iBAAA;IACA,aAAA;IACA,yBAAA;IACA,qBAAA;EA5MR;AACF;AAptBI;EAo2BE;IA8DI,YAAA;IACA,aAAA;EA1MR;AACF;AA6MM;EACE,aAAA;EAKA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;AA/MR;AAqNQ;EACE,iBAAA;AAnNV;AAxuBI;EA26BE;IA0BI,YAAA;IACA,UAAA;IACA,iBAAA;EAzNR;AACF;AA3uBI;EAu6BE;IA+BI,YAAA;IACA,aAAA;EAvNR;AACF;AAyNQ;EAEE,mBAAA;EACA,iBAAA;EACA,kDApnCF;EAqnCE,eAAA;AAxNV;AA3vBI;EA88BI;IAQI,eAAA;IACA,eAAA;IACA,iBAAA;IACA,YAAA;EAvNV;AACF;AAyNQ;EACE,eAAA;EACA,kDAhoCF;EAioCE,gBAAA;EACA,UAAA;AAvNV;AAzwBI;EA49BI;IAOI,eAAA;EAtNV;AACF;AAiOI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,sEAAA;EACA,SAAA;EACA,sEAAA;EAEA,gCAAA;EACA,kDA7pCE;EA8pCF,gBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EAEA,sBAAA;EACA,mCAAA;EACA,kBAAA;AAjON;AA/xBI;EA++BA;IAoBI,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,kDAxqCA;IAyqCA,kBAAA;IACA,eAAA;EAhON;AACF;AAryBI;EA2+BA;IA4BI,eAAA;EA9NN;AACF;;AAmOA;EACE,wBAAA;EACA,sBAAA;EACA,4BAAA;AAhOF;;AAkOA;EAEE,gBAAA;AAhOF;AAxzBI;EAshCJ;IAQI,eAAA;IACA,iBAAA;EAlOF;AACF;AAqOE;EACE,eAAA;AAnOJ;AAj0BI;EAmiCF;IAOI,sBAAA;IACA,uBAAA;IACA,MAAA;EArOJ;AACF;AAuOI;EACE,gBAAA;EACA,kDAntCE;EAotCF,iBAAA;EACA,YAAA;AArON;AA90BI;EA+iCA;IAQI,eAAA;IACA,kDA1tCA;EAq/BN;AACF;AAh1BI;EA2iCA;IAYI,eAAA;EAnON;AACF;AAsOI;EACE,eAAA;EACA,kDAnuCE;EAouCF,gBAAA;EACA,eAAA;AApON;AA/1BI;EA+jCA;IAOI,eAAA;EAnON;AACF;AAuOE;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;AArOJ;AA32BI;EA2kCF;IAQI,SAAA;EApOJ;AACF;AA52BI;EAukCF;IAWI,SAAA;EAlOJ;AACF;AAoOI;EACE,eAAA;AAlON;AAqOQ;EACE,aAAA;AAnOV;AAsOQ;EACE,aAAA;AApOV;AA2OM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EAEA,2BAAA;EACA,qBAAA;AA1OR;AA/4BI;EAymCE;IAoBI,cAAA;IACA,aAAA;IACA,UAAA;IACA,aAAA;IACA,sBAAA;EA1OR;AACF;AAp5BI;EAqmCE;IA2BI,YAAA;IACA,aAAA;EAxOR;AACF;AA0OQ;EACE,iBAAA;EACA,cAAA;AAxOV;AA2OQ;EAEE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kDApzCF;EAqzCE,YAAA;EACA,eAAA;AA1OV;AA16BI;EA6oCI;IASI,eAAA;EAxOV;AACF;AA2OQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AAzOV;AA4OQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA1OV;AA6OQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA3OV;AA8OQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA5OV;AAiPI;EACE,eAAA;AA/ON;AAkPQ;EACE,aAAA;AAhPV;AAmPQ;EACE,aAAA;AAjPV;AA2PM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,aAAA;EAEA,2BAAA;EACA,qBAAA;AA1PR;AA99BI;EA2sCE;IAgBI,cAAA;IACA,UAAA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;EAzPR;AACF;AAn+BI;EAusCE;IAuBI,YAAA;IACA,aAAA;EAvPR;AACF;AAyPQ;EACE,iBAAA;EACA,cAAA;AAvPV;AA0PQ;EAEE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kDAl5CF;EAo5CE,YAAA;EACA,eAAA;AA1PV;AAz/BI;EA2uCI;IAUI,eAAA;EAxPV;AACF;AA2PQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AAzPV;AA2PU;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAzPZ;AA6PQ;EACE,0DAAA;EACA,mCAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA3PV;AA8PQ;EACE,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA5PV;AA+PQ;EACE,0DAAA;EACA,mCAAA;EAEA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA9PV;AAmQI;EACE,kBAAA;EACA,gBAAA;EACA,kDAt8CE;EAu8CF,QAAA;EACA,sEAAA;EACA,SAAA;EACA,sEAAA;EAEA,gCAAA;EAIA,YAAA;EACA,UAAA;AArQN;AA1iCI;EAiyCA;IAiBI,eAAA;EApQN;AACF;;AAyQA;EAEE,oBAAA;EAEA,kBAAA;AAxQF;AApjCI;EAwzCJ;IASI,cAAA;EAzQF;AACF;AA6QE;EAGE,WAAA;AA7QJ;AA5jCI;EAs0CF;IAOI,UAAA;EA7QJ;AACF;AAiRM;EACE,aAAA;AA/QR;AAkRM;EACE,aAAA;AAhRR;AAoRI;EACE,eAAA;AAlRN;AA1kCI;EA21CA;IAOI,eAAA;EApRN;AACF;AAuRI;EACE,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,aAAA;EAEA,2BAAA;EACA,qBAAA;EAEA,mBAAA;EAEA,kBAAA;AAxRN;AA6RM;EACE,+EAAA;EAKA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EAGA,aAAA;AAjSR;AAoSM;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;AAlSR;AAqSM;EACE,YAAA;EACA,eAAA;EACA,kDAjjDA;EAkjDA,cAAA;AAnSR;AA7mCI;EA44CE;IAMI,eAAA;EAjSR;AACF;AAoSM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAlSR;AAqSM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAnSR;AAsSM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AApSR;AAuSM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AArSR;AAwSM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAtSR;AAySM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAvSR;AA0SM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAxSR;AA2SM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AAzSR;AA4SM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AA1SR;AA6SM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AA3SR;AA8SM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AA5SR;AA+SM;EACE,YAAA;EACA,aAAA;EACA,0DAAA;AA7SR;AAiTI;EACE,gBAAA;AA/SN;AAjrCI;EA+9CA;IAGI,eAAA;EA7SN;AACF;AAgTI;EACE,iBAAA;AA9SN;AAzrCI;EAs+CA;IAGI,gBAAA;EA5SN;AACF;AA+SI;EACE,iBAAA;AA7SN;AAjsCI;EA6+CA;IAGI,iBAAA;EA3SN;AACF;AA8SI;EACE,iBAAA;AA5SN;AAzsCI;EAo/CA;IAGI,iBAAA;EA1SN;AACF;AA8SE;EACE,eAAA;EACA,0BAAA;AA5SJ;AAltCI;EA4/CF;IAII,0BAAA;EA1SJ;AACF;AA6SE;EACE,gBAAA;EACA,kDA3qDI;EA6qDJ,SAAA;EACA,WAAA;EACA,iBAAA;EAEA,YAAA;EACA,WAAA;AA7SJ;AAhuCI;EAogDF;IAYI,UAAA;IACA,SAAA;IAEA,eAAA;IAEA,kDAvrDE;IAwrDF,eAAA;EA9SJ;AACF;AAruCI;EAggDF;IAqBI,eAAA;EA5SJ;AACF;AA+SE;EACE,gBAAA;EACA,kDApsDI;EAssDJ,aAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EAEA,YAAA;AA/SJ;AAvvCI;EA6hDF;IAYI,WAAA;IACA,eAAA;IACA,YAAA;IACA,kDA9sDE;IA+sDF,eAAA;EA9SJ;AACF;AA5vCI;EAyhDF;IAmBI,eAAA;EA5SJ;AACF;;AAgTA;EACE,aAAA;AA7SF;AAzwCI;EAqjDJ;IAII,cAAA;IACA,WAAA;IACA,eAAA;IAEA,MAAA;IACA,OAAA;IACA,YAAA;IACA,QAAA;IACA,WAAA;IACA,0DAAA;IACA,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,4BAAA;EA7SF;AACF;;AAgTA;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AA7SF;AAlyCI;EA0kDJ;IAQI,uBAAA;EA5SF;AACF;AAvyCI;EAolDA;IAEI,WAAA;IACA,cAAA;IACA,eAAA;IACA,OAAA;IACA,MAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;IAKA,sBAAA;EA5SN;AACF;;AAgTA;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AA7SF;AAmTA;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AAjTF;AA10CI;EAsnDJ;IAOI,0DAAA;IACA,yBAAA;EA/SF;AACF;;AAkTA;EAEE,gBAAA;AAhTF;AAp1CI;EAkoDJ;IAOI,UAAA;IACA,eAAA;EAjTF;AACF;AAmTE;EACE,kDAnzDI;EAozDJ,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EAEA,cAAA;AAlTJ;AAl2CI;EA6oDF;IAUI,eAAA;IACA,mBAAA;IACA,kDA3zDE;IA6zDF,eAAA;IACA,mBAAA;IACA,kDAAA;IACA,cAAA;EAlTJ;AACF;AAz2CI;EAyoDF;IAoBI,eAAA;EAhTJ;AACF;AAmTE;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAjTJ;AAmTI;EACE,qBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAjTN;AAqTI;EACE,WAAA,EAAA,gDAAA;AAnTN;AAsTI;EACE,eAAA;AApTN;AAv4CI;EA0rDA;IAGI,eAAA;EAlTN;AACF;AA54CI;EAqqDF;IA6BI,gBAAA;IACA,SAAA;EAlTJ;AACF;AAmTI;EACE,kDAz2DG;AAwjDT;AAoTI;EAOE,eAAA;AAxTN;AA0TM;EACE,kDAt3DC;EAu3DD,gBAAA;EACA,kBAAA;AAxTR;AA75CI;EAktDE;IAKI,gBAAA;IAEA,eAAA;EAvTR;AACF;AA2TI;EACE,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,kDA54DE;EA64DF,eAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AAzTN;AA4TI;EACE,mBAAA;AA1TN;AA+TI;EACE,aAAA;EACA,eAAA;AA7TN;;AAkUA;EAGE,qBAAA;AAjUF;AAj8CI;EA+vDJ;IAcI,cAAA;IACA,oBAAA;EAxUF;AACF;AA0UE;EACE,gBAAA;EACA,kDAx7DI;EAy7DJ,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAxUJ;AA/8CI;EAixDF;IAWI,mBAAA;IACA,eAAA;IACA,kDAh8DE;IAi8DF,cAAA;IACA,eAAA;IACA,iBAAA;EAzUJ;AACF;AAr9CI;EA6wDF;IAoBI,eAAA;EAxUJ;AACF;AA2UE;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAzUJ;AAp+CI;EAyyDF;IAOI,sBAAA;IACA,SAAA;IACA,eAAA;EAxUJ;AACF;AA0UI;EACE,kDAAA;EACA,aAAA;EAEA,SAAA;AAzUN;AA2UM;EACE,iBAAA;EACA,qBAAA;EACA,kDAh+DA;AAupDR;AAr/CI;EA2zDE;IAKI,eAAA;IACA,mBAAA;EAvUR;AACF;AA0UM;EACE,kDAx+DA;EAy+DA,8BAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;EACA,mBAAA;AAxUR;AA0UQ;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;AAxUV;AAvgDI;EAq0DE;IAcI,eAAA;EAxUR;EAyUQ;IACE,eAAA;EAvUV;AACF;AA2UM;EACE,kDA7/DA;EA8/DA,eAAA;EACA,cAAA;EACA,mBAAA;AAzUR;AArhDI;EA01DE;IAMI,eAAA;EAvUR;AACF;AA0UM;EAEE,kDAxgEA;EAygEA,8BAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;EACA,qBAAA;AAzUR;AA2UQ;EACE,mBAAA;AAzUV;AAqVM;EACE,kDA5hEA;EA6hEA,8BAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;EACA,qBAAA;AAnVR;AAsVM;EACE,kDApiEA;EAqiEA,eAAA;EACA,cAAA;EACA,qBAAA;AApVR;AAuVM;EACE,cAAA;EACA,iBAAA;EACA,kDA7iEA;EA8iEA,kBAAA;AArVR;AAwVM;EACE,kDAljEA;EAmjEA,gBAAA;AAtVR;AA2VE;EACE,aAAA;AAzVJ;AA9jDI;EAs5DF;IAGI,cAAA;EAvVJ;EAyVI;IACE,eAAA,EAAA,kEAAA;EAvVN;EAyVI;IACE,aAAA;EAvVN;EA0VI;IACE,cAAA;IACA,gBAAA;IACA,wBAAA;EAxVN;EA0VI;IACE,aAAA;EAxVN;EA2VI;IACE,kDAAA;IACA,aAAA;IAEA,SAAA;IACA,aAAA;IACA,cAAA;EA1VN;EA2VM;IACE,iBAAA;IACA,qBAAA;IACA,kDAvlEF;EA8vDN;AACF;AA7lDI;EAk7DI;IAKI,eAAA;IACA,mBAAA;EAtVV;AACF;AAnmDI;EA47DI;IACE,kDA/lEF;IAgmEE,8BAAA;IACA,cAAA;IACA,2BAAA;IAAA,sBAAA;IACA,mBAAA;EAtVR;EAwVQ;IACE,mBAAA;IACA,gBAAA;IACA,kBAAA;EAtVV;AACF;AAjnDI;EA47DI;IAcI,eAAA;EArVV;EAsVU;IACE,eAAA;EApVZ;AACF;AAznDI;EAi9DI;IACE,kDApnEF;IAqnEE,eAAA;IACA,cAAA;IACA,mBAAA;EArVR;AACF;AAjoDI;EAi9DI;IAMI,eAAA;EAlVV;AACF;AAtoDI;EA29DI;IAEE,kDA/nEF;IAgoEE,8BAAA;IACA,cAAA;IACA,2BAAA;IAAA,sBAAA;IACA,qBAAA;EAnVR;EAqVQ;IACE,mBAAA;EAnVV;EA+VM;IACE,kDAnpEF;IAopEE,8BAAA;IACA,cAAA;IACA,2BAAA;IAAA,sBAAA;IACA,qBAAA;EA7VR;EAgWM;IACE,kDA3pEF;IA4pEE,eAAA;IACA,cAAA;IACA,qBAAA;EA9VR;EAiWM;IACE,cAAA;IACA,iBAAA;IACA,kDApqEF;IAqqEE,kBAAA;EA/VR;EAkWM;IACE,kDAzqEF;IA0qEE,gBAAA;EAhWR;AACF;;AAsWA;EAEE,kBAAA;EACA,oBAAA;AApWF;AAsWE;EACE,gBAAA;EACA,kDAxrEI;EAyrEJ,iBAAA;EAEA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AArWJ;AAvrDI;EAohEF;IAUI,gBAAA;EAnWJ;AACF;AAxrDI;EAghEF;IAaI,gBAAA;EAjWJ;AACF;AAzrDI;EA4gEF;IAgBI,gBAAA;EA/VJ;AACF;AAkWE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAhWJ;AA3sDI;EAwiEF;IAMI,sBAAA;IACA,SAAA;EA/VJ;AACF;AAgWI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;AA9VN;AA+VM;EACE,kDAztEA;AA43DR;AA1tDI;EAijEA;IASI,SAAA;EA5VN;EA6VM;IACE,eAAA;EA3VR;AACF;AA6VM;EACE,uBAAA;EACA,mBAAA;EACA,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;AA5VR;AA1uDI;EA+jEE;IASI,iBAAA;IACA,aAAA;IACA,mBAAA;IACA,SAAA;EA1VR;AACF;AA2VQ;EACE,0BAAA;EACA,YAAA;EACA,eAAA;EACA,kDAnvEF;AA05DR;AAxvDI;EA6kEI;IAMI,eAAA;EAvVV;AACF;AA4VI;EACE,aAAA;EACA,sBAAA;EAEA,eAAA;EACA,iBAAA;AA3VN;AAnwDI;EAylEA;IAOI,iBAAA;IACA,oBAAA;EAzVN;AACF;AA0VM;EACE,iBAAA;EACA,oBAAA;EACA,2BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AAxVR;AA0VU;EACE,0BAAA;AAxVZ;AA4VQ;EACE,SAAA;EACA,gBAAA;AA1VV;AA2VU;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AAzVZ;AA2VU;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,8BAAA;AAzVZ;AApyDI;EAwnEM;IAQI,SAAA;EAxVZ;AACF;AAyVY;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAvVd;AAwVc;EACE,uBAAA;EACA,mBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,kDA/yER;EAgzEQ,0BAAA;AAvVhB;AAyVc;EACE,kDAnzER;EAozEQ,eAAA;EACA,gBAAA;AAvVhB;AA5zDI;EAkoEQ;IAqBI,SAAA;EAvVd;EAyVc;IACE,eAAA;IACA,gBAAA;EAvVhB;AACF;AA0VY;EACE,kDAl0EN;EAm0EM,eAAA;EACA,gBAAA;AAxVd;AA10DI;EAqqEU;IACE,eAAA;EAxVd;AACF;AA/0DI;EAmmEE;IAyEI,sBAAA;IACA,SAAA;IACA,iBAAA;IACA,oBAAA;EAzVR;AACF;AA6VE;EACE,kBAAA;EACA,cAAA;EACA,0BAAA;EACA,kDA11EI;AA+/DR;AA71DI;EA+gEJ;IA6KI,kBAAA;IACA,iBAAA;EA3VF;EA4VE;IACE,eAAA;IACA,SAAA;IACA,UAAA;EA1VJ;AACF;;AA8VA;EACE,kBAAA;EACA,oBAAA;AA3VF;AA72DI;EAssEJ;IAII,kBAAA;EAzVF;AACF;AA2VI;EACE,aAAA;EACA,sBAAA;AAzVN;AA2VM;EACE,aAAA;EACA,8BAAA;AAzVR;AA2VQ;EACE,mBAAA;AAzVV;AA73DI;EAitEE;IAQI,sBAAA;IACA,uBAAA;EAxVR;EAyVQ;IACE,uBAAA;EAvVV;AACF;AAyVQ;EACE,eAAA;EACA,gBAAA;EACA,kDAp4EF;AA6iER;AA34DI;EA+tEI;IAKI,eAAA;IACA,gBAAA;EArVV;AACF;AAuVQ;EACE,gBAAA;EACA,kDA/4EF;EAg5EE,iBAAA;EACA,yBAAA;AArVV;AAv5DI;EAwuEI;IAOI,eAAA;IAEA,gBAAA;EArVV;AACF;AAz5DI;EAouEI;IAYI,gBAAA;EAnVV;AACF;AA15DI;EAguEI;IAgBI,gBAAA;EAlVV;AACF;AAoVQ;EAEE,iBAAA;EAIA,SAAA;EACA,aAAA;EACA,iBAAA;EAEA,aAAA;EACA,sBAAA;EAiOA,gEAAA;AAvjBV;AAh7DI;EA2vEI;IAcI,iBAAA;IACA,SAAA;EArVV;AACF;AAsVU;EAEE,aAAA;EAGA,4CAAA;EAIA,aAAA;EACA,gBAAA;AA1VZ;AA57DI;EA4wEM;IAYI,UAAA;IACA,sBAAA;IACA,aAAA;EAxVZ;AACF;AA2VY;EACE,iDAr8EP;EAs8EO,eAAA;EACA,kBAAA;AAzVd;AAx8DI;EA8xEQ;IAKI,eAAA;EAvVd;AACF;AAyVY;EACE,kDAz8EN;EA08EM,eAAA;AAvVd;AAj9DI;EAsyEQ;IAII,eAAA;EArVd;AACF;AAuVY;EACE,aAAA;EAEA,gBAAA;AAtVd;AAuVc;EACE,SAAA;AArVhB;AA79DI;EA6yEQ;IAQI,mBAAA;EApVd;AACF;AAsVY;EACE,6DAAA;EACA,gBAAA;EAEA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AArVd;AA1+DI;EAwzEQ;IAUI,6BAAA;EApVd;AACF;AA3+DI;EAozEQ;IAcI,kBAAA;EAnVd;AACF;AA5+DI;EAg0EU;IAEI,gCAAA;EAlVhB;AACF;AAr/DI;EAo0EU;IAKI,iBAAA;EAhVhB;AACF;AAwVY;EACE,sBAAA;AAtVd;AAyVY;EACE,gBAAA;EAGA,gBAAA;AAzVd;AA2VY;EAOE,gBAAA;AA/Vd;AAxgEI;EAg2EQ;IASI,4BAAA;EA7Vd;AACF;AAgWY;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;AA9Vd;AArhEI;EA62EQ;IAQI,kBAAA;IACA,SAAA;IACA,sBAAA;IACA,uBAAA;EA5Vd;AACF;AA+Vc;EACE,eAAA;EACA,kDAhiFR;EAkiFQ,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AA9VhB;AAviEI;EA43EU;IAWI,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;EA5VhB;AACF;AA8Vc;EACE,uBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AA5VhB;AA8Vc;EACE,iBAAA;EACA,eAAA;AA5VhB;AA3jEI;EAq5EU;IAII,uBAAA;IAIA,eAAA;EA7VhB;AACF;AAjkEI;EA23EQ;IAuCI,SAAA;EA7Vd;AACF;AA+VY;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AA7Vd;AA8Vc;EACE,iCAAA,EAGG,oCAAA;EACH,UAAA,EAAA,gCAAA;EACA,gEAAA;AA/VhB;AAhlEI;EAq6EQ;IAcI,QAAA;EA/Vd;AACF;AAiWc;EACE,eAAA;EAEA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAhWhB;AA5lEI;EAs7EU;IAQI,eAAA;IACA,SAAA;IACA,kBAAA;EA9VhB;AACF;AAgWc;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,OAAA;EACA,YAAA,EAAA,gDAAA;EACA,2BAAA;AA9VhB;AAiWc;EACE,WAAA;EACA,mBAAA;AA/VhB;AAjnEI;EA88EU;IAKI,UAAA;EA9VhB;AACF;AAoWgB;EACE,0BAAA,EAGG,iDAAA;EACH,UAAA;AArWlB;AA8WU;EACE,2BAAA;EAKA,gBAAA;AAhXZ;AA9nEI;EAw+EM;IAQI,sBAAA;EA9WZ;AACF;;AA0XA;EACE,kBAAA;EACA,oBAAA;AAvXF;AAxoEI;EA6/EJ;IAII,kBAAA;EArXF;AACF;AAwXI;EACE,aAAA;EACA,sBAAA;AAtXN;AAuXM;EACE,gBAAA;EACA,kDA/qFA;EAgrFA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AArXR;AAzpEI;EAwgFE;IAQI,eAAA;EAnXR;AACF;AA1pEI;EAogFE;IAWI,eAAA;EAjXR;AACF;AAmXM;EACE,aAAA;EACA,YAAA;AAjXR;AAmXM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kDAAA;EACA,kBAAA;AAjXR;AA/qEI;EA0hFE;IASI,sBAAA;IACA,SAAA;IACA,oBAAA;EAhXR;AACF;AAiXQ;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,6BAAA;AA/WV;AA9rEI;EAuiFI;IAQI,8BAAA;IACA,kBAAA;IACA,oBAAA;EA7WV;EA8WU;IACE,mBAAA;EA5WZ;AACF;AA8WU;EACE,kBAAA;AA5WZ;AA8WU;EACE,kDA7tFH;EA8tFG,eAAA;EACA,kBAAA;AA5WZ;AAhtEI;EAyjFM;IAKI,eAAA;EA1WZ;AACF;AA4WU;EACE,kDApuFJ;EAquFI,eAAA;EACA,yBAAA;AA1WZ;AA1tEI;EAikFM;IAKI,eAAA;EAxWZ;AACF;AAyWY;EACE,cAjuFP;AA03EP;AAluEI;EA8kFQ;IACE,iBAAA;EAzWZ;AACF;AA8WI;EACE,gBAAA;AA5WN;AA6WM;EACE,eAAA;EACA,kDA9vFA;EA+vFA,yBAAA;AA3WR;AA/uEI;EAulFE;IAKI,eAAA;EAzWR;AACF;AA2WM;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAzWR;AA1vEI;EA+lFE;IAOI,eAAA;IACA,SAAA;IACA,2BAAA;IACA,gBAAA;IACA,kBAAA;EAxWR;AACF;AAyWQ;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kDAnxFF;EAoxFE,yBAAA;AAvWV;AAwWU;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AAtWZ;AAhxEI;EA4mFI;IAaI,eAAA;IACA,iBAAA;EArWV;AACF;AAuWQ;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kDApyFF;EAqyFE,yBAAA;AArWV;AAsWU;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AApWZ;AAnyEI;EA6nFI;IAaI,eAAA;IACA,iBAAA;EAnWV;AACF;AAsWQ;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AApWV;AAsWQ;EACE,eAAA;EACA,kDAxzFF;EA0zFE,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;AArWV;AAsWU;EACE,WAAA;AApWZ;AA1zEI;EAopFI;IAjoFN,aAAA;IA+oFU,SAAA;IACA,oBAAA;EA/VV;AACF;AAoWQ;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAlWV;AA90EI;EAyqFI;IASI,sBAAA;IACA,uBAAA;IAEA,eAAA;IACA,SAAA;EAjWV;EAkWU;IACE,iBAAA;EAhWZ;AACF;AAmWU;EACE,6DAAA;EACA,mBAAA;AAjWZ;AAmWU;EACE,gBAAA;AAjWZ;AAmWU;EACE,yBAAA;EACA,0DAAA;AAjWZ;AAmWU;EACE,qBAAA;AAjWZ;AAmWU;EACE,WAAA;EACA,kDAj3FJ;EAk3FI,eAAA;EACA,gBAAA;AAjWZ;AA72EI;EA0sFM;IAMI,eAAA;EA/VZ;AACF;AAiWU;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;AA/VZ;AAz3EI;EAmtFM;IAQI,WAAA;EA9VZ;AACF;AAgWY;EACE,aAAA;EACA,kDAl4FN;EAm4FM,eAAA;EACA,gBAAA;EACA,mBAAA;AA9Vd;AAr4EI;EA8tFQ;IAOI,eAAA;EA5Vd;AACF;AA8VY;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AA5Vd;AA+VgB;EACE,iCAAA,EAGG,oCAAA;EACH,UAAA,EAAA,gCAAA;EACA,gEAAA;AAhWlB;AAqWc;EACE,6DAAA;EACA,mBAAA;AAnWhB;AAqWc;EACE,gBAAA;AAnWhB;AAqWc;EACE,WAAA;EACA,aAAA;EACA,qBAAA;AAnWhB;AAsWc;EAEE,0DAAA;AArWhB;AA2Wc;EAEE,0BAAA,EAGG,iDAAA;EACH,UAAA;AA7WhB;AA+Wc;EACE,WAAA;EACA,cAAA;EAEA,gBAAA;EACA,aAAA;EACA,qBAAA;EAEA,mBAAA;AA/WhB;AAiXgB;EACE,WAAA;AA/WlB;AAl7EI;EAgyFY;IAGI,mBAAA;IACA,WAAA;EA7WlB;AACF;AAgXc;EACE,WAAA;EACA,eAAA;EACA,kDA78FR;EA88FQ,gBAAA;AA9WhB;AA97EI;EAwyFU;IAQI,eAAA;EA9WhB;AACF;AAn8EI;EAwuFQ;IA4EI,eAAA;EA7Wd;AACF;AAiXU;EACE,mBAAA;AA/WZ;AAoXQ;EACE,gBAAA;AAlXV;;AAyXA;EACE,kBAAA;EACA,qBAAA;AAtXF;AAn9EI;EAu0FJ;IAII,kBAAA;EApXF;AACF;AAsXI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AApXN;AA79EI;EA80FA;IAKI,sBAAA;IACA,uBAAA;EAlXN;AACF;AAmXM;EACE,kDAz/FA;EA0/FA,eAAA;EACA,gBAAA;AAjXR;AAx+EI;EAs1FE;IAKI,eAAA;IACA,gBAAA;EA/WR;AACF;AAkXI;EACE,gBAAA;EACA,kDAvgGE;EAwgGF,iBAAA;EACA,yBAAA;AAhXN;AAp/EI;EAg2FA;IAMI,eAAA;IACA,gBAAA;EA9WN;AACF;AAt/EI;EA41FA;IAUI,gBAAA;EA5WN;AACF;AAv/EI;EAw1FA;IAaI,gBAAA;EA1WN;AACF;AA6WI;EACE,iBAAA;EACA,aAAA;EACA,qCAAA;EACA,iBAAA;EACA,aAAA;AA3WN;AA3gFI;EAi3FA;IAQI,qCAAA;EA1WN;AACF;AA5gFI;EA62FA;IAaI,qCAAA;IACA,gBAAA;IACA,aAAA;EA1WN;AACF;AA4WI;EACE,SAAA;EACA,gBAAA;AA1WN;AA2WM;EACE,sCAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,yBAAA;EACA,sBAAA,EAAA,mCAAA;EACA,wBAAA;AAzWR;AA4WI;EACE,aAAA;EAEA,kDAljGE;EAmjGF,eAAA;EAEA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;AA5WN;AA8WM;EAEE,oBAAA;EAEA,iCAAA,EAAA,oCAAA;EACA,UAAA,EAAA,gCAAA;EACA,gEAAA;AA9WR;AAjjFI;EAy5FE;IASI,WAAA;IAEA,wBAAA,EAAA,8BAAA;IACA,UAAA;IACA,mBAAA;EA9WR;AACF;AA+WQ;EACE,WAAA;AA7WV;AA5jFI;EA64FA;IAiCI,eAAA;IACA,aAAA;EA9WN;AACF;AAgXI;EACE,2BAAA,EAAA,wBAAA;AA9WN;AArkFI;EAk7FA;IAGI,mBAAA;EA5WN;AACF;AA1kFI;EAw7FA;IAEI,sCAAA;EA5WN;AACF;AA8WI;EACE,aAAA;EACA,kDAAA;AA5WN;AA8WM;EACE,eAAA;AA5WR;AA6WQ;EACE,wBAAA,EAAA,8BAAA;EACA,UAAA,EAAA,kBAAA;AA3WV;AA6WQ;EACE,gBAAA;AA3WV;AA4WU;EACE,sBAAA;AA1WZ;AA+WI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AA7WN;AAiXI;EACE,aAAA;EAEA,kDA5nGE;EA6nGF,eAAA;EACA,gBAAA;AAhXN;AA5mFI;EAu9FA;IAQI,eAAA;IACA,aAAA;EA/WN;AACF;;AAoXA;EACE,gBAAA;AAjXF;AAtnFI;EAs+FJ;IAGI,eAAA;EA/WF;AACF;AAiXE;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AA/WJ;AAjoFI;EA4+FF;IAQI,aAAA;IACA,qCAAA;IACA,gBAAA;EA/WJ;AACF;AAiXM;EACE,YAAA;AA/WR;AAsXM;EACE,YAAA;AApXR;AAuXM;EACE,gBAAA;AArXR;AAsXQ;EACE,cAhqGH;AA4yFP;AAwXM;EACE,gBAAA;AAtXR;AAyXM;EACE,kDAprGC;EAqrGD,eAAA;EAEA,2BAAA;EAAA,sBAAA;EACA,0BAAA;EACA,qBAAA;AAxXR;AA9pFI;EAghGE;IAQI,eAAA;IACA,qBAAA;EAtXR;AACF;AAyXM;EACE,kDAjsGC;EAksGD,eAAA;EAEA,2BAAA;EAAA,sBAAA;EACA,0BAAA;EACA,qBAAA;AAxXR;AA3qFI;EA6hGE;IAQI,eAAA;IACA,qBAAA;EAtXR;AACF;AAyXM;EACE,kDA7sGA;EA8sGA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AAvXR;AAwXQ;EACE,cA1sGH;AAo1FP;AA5rFI;EA0iGE;IAWI,eAAA;EArXR;AACF;AAwXM;EACE,kDA5tGA;EA8tGA,eAAA;EACA,cAAA;EACA,gBAAA;AAvXR;AAvsFI;EAyjGE;IAOI,eAAA;EArXR;AACF;AAwXM;EACE,eAAA;EACA,kDAxuGA;EAyuGA,qBAAA;EACA,yBAAA;EACA,eAAA;AAtXR;AAntFI;EAokGE;IAOI,eAAA;EApXR;AACF;AAqXQ;EACE,cAtuGH;AAm3FP;AA3tFI;EA6kGI;IAGI,YAAA;EAjXV;AACF;AAhuFI;EAqlGE;IAEI,QAAA;EAnXR;AACF;AAruFI;EA0lGE;IAEI,QAAA;EAnXR;AACF;AA1uFI;EA+lGE;IAEI,QAAA;EAnXR;AACF;AA/uFI;EAomGE;IAEI,QAAA;EAnXR;AACF;AAgYA;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;EACA,aAAA;EACA,YAAA;EAEA,sBAAA;AA/XF;AAgYE;EACE,eAAA;EACA,kDAryGI;EAsyGJ,eAAA;EACA,0BAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;AA9XJ;;AAkYA;EACE,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AA/XF;AAnxFI;EA6oGJ;IAOI,kBAAA;EA7XF;AACF;AA+XI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,8BAAA;AA7XN;AA/xFI;EAupGA;IAOI,sBAAA;IACA,uBAAA;IACA,cAAA;IACA,SAAA;EA3XN;AACF;AAnyFI;EAmpGA;IAaI,uBAAA;IACA,sBAAA;EAzXN;AACF;AA0XM;EAEE,kDA90GA;EA+0GA,yBAAA;EACA,gBAAA;EACA,iBAAA;AAzXR;AAnzFI;EAuqGE;IAOI,eAAA;EAvXR;AACF;AApzFI;EAmqGE;IAUI,gBAAA;EArXR;AACF;AArzFI;EA+pGE;IAaI,gBAAA;EAnXR;AACF;AAqXM;EAEE,kDA31GA;EA41GA,eAAA;EACA,gBAAA;AApXR;AAv0FI;EAurGE;IAMI,eAAA;EAlXR;AACF;AAwXI;EACE,YAAA;EACA,kDAx2GE;EAy2GF,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAtXN;AAp1FI;EAosGA;IAQI,eAAA;IACA,UAAA;EApXN;AACF;AAwXE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAtXJ;AAyXI;EACE,mBAAA;EACA,uBAAA;EACA,kDA73GE;EA83GF,iBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAvXN;AAwXM;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;AAtXR;AAyXI;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;AAvXN;AAn3FI;EAktGF;IA6BI,SAAA;IACA,mBAAA;EAxXJ;AACF;AA2XI;EACE,kDAv5GE;AA8hGR;AA53FI;EAovGA;IAII,eAAA;EAxXN;AACF;AA2XI;EACE,aAAA;EACA,SAAA;AAzXN;AAr4FI;EA4vGA;IAKI,QAAA;EAxXN;AACF;AAyXM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAvXR;AAh5FI;EAmwGE;IAOI,gBAAA;EAtXR;AACF;AA2XQ;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kDAv7GF;EAw7GE,eAAA;EAGA,eAAA;AA3XV;AA4XU;EACE,6BAAA;EACA,uBAAA;EACA,mBAAA;AA1XZ;AA4XU;EACE,wCAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AA1XZ;AA4XU;EACE,6BAAA;AA1XZ;AA4XU;EACE,6BAAA;AA1XZ;AA4XU;EACE,YAAA;EACA,6BAAA;AA1XZ;AA4XU;EACE,iBAAA;AA1XZ;AAt7FI;EAgxGI;IAqCI,eAAA;IAEA,eAAA;IACA,gBAAA;EA5XV;AACF;AA8XQ;EACE,kBAAA;EACA,WAAA;AA5XV;AAj8FI;EA2zGI;IAII,eAAA;EA1XV;AACF;AA+XE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AA7XJ;AA58FI;EAq0GF;IAMI,gBAAA;IACA,mBAAA;EA3XJ;AACF;AA4XI;EACE,aAAA;EACA,qCAAA;EACA,UAAA;EACA,aAAA;AA1XN;AA4XM;EACE;IACE,qCAAA;EA1XR;AACF;AA6XM;EACE;IACE,qCAAA;EA3XR;AACF;AA8XM;EACE;IACE,0BAAA;EA5XR;AACF;AAv+FI;EA80GA;IAyBI,SAAA;EA5XN;AACF;AAx+FI;EA00GA;IA4BI,8BAAA;EA1XN;AACF;AAsdE;EACE,kDA1mHI;EA2mHJ,eAAA;EACA,iBAAA;EACA,mBAAA;AApdJ;AAv/FI;EAu8GF;IAOI,gBAAA;IACA,eAAA;EAndJ;AACF;AAudI;EACE,aAAA;AArdN;AAhgGI;EAo9GA;IAGI,SAAA;EAndN;AACF;AAqdM;EACE,kBAAA;EACA,kDA9nHA;EA+nHA,eAAA;AAndR;AA1gGI;EA09GE;IAKI,eAAA;IACA,kBAAA;EAjdR;AACF;AAqdM;EACE,eAAA;EACA,oBAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AAndR;AAodQ;EAEE,iCAAA,EAGG,oCAAA;EACH,UAAA,EAAA,gCAAA;EACA,gEAAA;AAtdV;AA9hGI;EA6+GI;IASI,cAAA;EApdV;AACF;AAqdU;EACE,WAAA;AAndZ;AAtiGI;EAw/GM;IAGI,WAAA;EAjdZ;AACF;AAodQ;EACE,mBAAA;AAldV;AAmdU;EACE,WAAA;AAjdZ;AAodQ;EACE,cAAA;EAEA,YAAA;EACA,aAAA;AAndV;AAtjGI;EAq+GE;IAuCI,YAAA;IACA,eAAA;IACA,oBAAA;EAldR;AACF;AAqdM;EACE,WAAA;EACA,6DAAA;EAEA,aAAA;EACA,yBAAA;EACA,mBAAA;AApdR;AAsdQ;EACE,gCAAA;AApdV;AAwdM;EACE,gBAAA;AAtdR;AA4dM;EACE,sBAAA;AA1dR;AA8dM;EACE,yBAAA;AA5dR;AA6dQ;EAEE,0BAAA,EAGG,iDAAA;EACH,UAAA;AA/dV;AAplGI;EAm9GF;IAsGI,UAAA;EAjeJ;AACF;AArlGI;EA+8GF;IAyGI,eAAA;EA/dJ;AACF;AAgeI;EACE,gBAAA;AA9dN;AAieI;EACE,gBAAA;AA/dN;AAkeI;EACE,SAAA;EACA,kDA1uHE;EA2uHF,eAAA;EACA,gBAAA;AAheN;AA1mGI;EAskHA;IASI,eAAA;IACA,gBAAA;EAjeN;AACF;AAmeI;EACE,kDAtvHE;EAuvHF,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AAjeN;AAseI;EAGE,YAAA,EAAA,mBAAA;EAEA,kBAAA,EAAA,oBAAA;EACA,eAAA,EAAA,6BAAA;AAveN;AAweM;EACE,WAAA;EACA,yBAAA;EAEA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAveR;AAxoGI;EAomHE;IAaI,WAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;EAreR;AACF;AAueM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAreR;AA5pGI;EAunHE;IAYI,WAAA;IACA,UAAA;IACA,YAAA;EAneR;AACF;AA2eE;EACE,8BAAA;AAzeJ;AA4eE;EACE,kDArzHI;EAszHJ,eAAA;AA1eJ;;AA+eE;EACE,aAAA;AA5eJ;;AAgfE;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AA7eJ;AA5qGI;EAspHF;IAKI,iBAAA;EA3eJ;AACF;AAzrGI;EA8pHF;IASI,mBAAA;IACA,kBAAA;IACA,oBAAA;IACA,WAAA;EA1eJ;AACF;AA2eI;EAEE,SAAA;AA1eN;AA4eM;EACE,sDAAA;EACA,WAAA;EACA,YAAA;AA1eR;AAzsGI;EA4qHA;IAUI,sBAAA;IACA,SAAA;EAzeN;AACF;AA0eM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAxeR;AAxtGI;EAyrHE;IASI,SAAA;EAteR;AACF;AAweQ;EACE,eAAA;EACA,kDAz2HF;EA02HE,gBAAA;AAteV;AAluGI;EAqsHI;IAKI,eAAA;EApeV;AACF;AAseQ;EACE,eAAA;EACA,kDAj3HF;EAk3HE,cAAA;AApeV;AA5uGI;EA6sHI;IAKI,eAAA;EAleV;AACF;AAseI;EACE,SAAA;EAEA,cAAA;AAreN;AArvGI;EAutHA;IAMI,aAAA;EApeN;AACF;AAseI;EACE,eAAA;EACA,kDAp4HE;AAg6GR;AA9vGI;EAguHA;IAII,eAAA;EAleN;AACF;AAoeI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAleN;AAmeM;EACE,kDA94HA;EA+4HA,0BAAA;AAjeR;AAoeI;EACE,eAAA;EACA,kDAp5HE;AAk7GR;AAoeI;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,gBAAA;AAneN;AAqeM;EACE,uBAAA;EACA,8CAAA;AAneR;AAqeM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AAneR;AAueI;EACE,kDAz6HE;EA06HF,eAAA;EACA,gBAAA;AAreN;AApyGI;EAswHA;IAMI,eAAA;EApeN;AACF;AAseI;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;AApeN;AAhzGI;EA+wHA;IAOI,eAAA;IACA,SAAA;IACA,gBAAA;EAleN;AACF;AAmeM;EAEE,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AAleR;AAmeQ;EACE,uBAAA;AAjeV;AAmeQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,wBAAA;EACA,wCAAA;EACA,eAAA;AAjeV;AAmeQ;EACE,YAAA;AAjeV;AA70GI;EA0xHE;IAuBI,aAAA;EAheR;AACF;AAweE;EACE,uBAAA;EACA,eAAA;AAteJ;AAt1GI;EA0zHF;IAII,iBAAA;IACA,oBAAA;EApeJ;AACF;AAqeI;EACE,iBAAA;EACA,aAAA;EAEA,UAAA;EACA,2BAAA;AApeN;AAl2GI;EAi0HA;IAOI,SAAA;IACA,8BAAA;EAleN;AACF;AAmeM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AAjeR;AAmeQ;EACE,kDAp/HF;EAs/HE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAleV;AAr3GI;EAi1HI;IAQI,eAAA;EAheV;AACF;AAkeQ;EACE,kDA//HF;EAggIE,YAAA;EACA,eAAA;EACA,gBAAA;AAheV;AAh4GI;EA41HI;IAMI,eAAA;IACA,eAAA;EA9dV;AACF;AAieM;EACE,SAAA;AA/dR;AAoeE;EACE,0DAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,eAAA;EACA,oBAAA;AAleJ;AAj5GI;EA62HF;IAQI,iBAAA;IACA,oBAAA;EAheJ;AACF;AAkeI;EACE,kDA5hIE;EA6hIF,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAheN;AA95GI;EAy3HA;IAOI,eAAA;IACA,mBAAA;EA9dN;AACF;AAgeI;EAIE,kBAAA;AAjeN;AAkeM;EAEE,eAAA;AAjeR;AAmeM;EACE,aAAA;EAEA,gBAAA;AAleR;AAoeQ;EACE,WAAA;AAleV;AA2eE;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;AAzeJ;AAt7GI;EA45HF;IAKI,iBAAA;IACA,oBAAA;EAveJ;AACF;AAweI;EACE,iBAAA;AAteN;AAweQ;EACE,eAAA;EACA,aAAA;EAEA,uBAAA;AAveV;AAp8GI;EAu6HI;IAMI,sBAAA;IACA,eAAA;IACA,aAAA;IACA,uBAAA;EAreV;AACF;AAseU;EACE,mBAAA;AApeZ;AAseU;EACE,WAAA;AApeZ;AAqeY;EACE,kDA1lIN;EA2lIM,eAAA;EAEA,uBAAA;EAAA,kBAAA;AAped;AAv9GI;EAu7HQ;IAMI,eAAA;EAled;AACF;AAseU;EACE,SAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AApeZ;AAseY;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAped;AAx+GI;EAw8HQ;IASI,QAAA;IACA,WAAA;EAred;AACF;AAuec;EACE,eAAA;EACA,kDAznIR;EA6nIQ,kBAAA;EACA,gBAAA;AAxehB;AAoegB;EACE,YAAA;AAlelB;AAv/GI;EAq9HU;IASI,eAAA;IACA,gBAAA;IACA,gBAAA;EAnehB;EAoegB;IACE,WAAA;EAlelB;AACF;AAqec;EACE,eAAA;EACA,kDA1oIR;EA4oIQ,YAAA;AApehB;AAtgHI;EAs+HU;IAOI,iBAAA;EAnehB;AACF;AAqec;EA79HZ,aAAA;EA+9Hc,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,cA7oIR;AA8qHR;AAiegB;EACE,eAAA;AA/dlB;AA1hHI;EAg/HU;IAYI,uBAAA;EA9dhB;AACF;AAieY;EACE,kDAnqIN;EAoqIM,gBAAA;EACA,eAAA;EACA,YAAA;AA/dd;AAriHI;EAggIQ;IAMI,eAAA;IACA,eAAA;EA7dd;AACF;AAgeY;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,yBAAA;AA9dd;AAjjHI;EA2gIQ;IAOI,WAAA;IACA,gBAAA;IAEA,mBAAA;IACA,SAAA;EA9dd;AACF;AAzjHI;EAyhIU;IAGI,SAAA;EA/dhB;AACF;AAmeY;EACE;IACE,qCAAA;IACA,SAAA;EAjed;AACF;AAoeY;EACE;IACE,qCAAA;EAled;AACF;AAqeY;EACE;IACE,qCAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;IACA,uBAAA;EAned;AACF;AAqeY;EACE,aAAA;EACA,qCAAA;EACA,oBAAA;EACA,SAAA;AAned;AAxlHI;EAujIQ;IAOI,aAAA;IACA,qCAAA;IACA,SAAA;IACA,gBAAA;IACA,kBAAA;IAEA,SAAA;EAned;AACF;AAoec;EACE;IACE,qCAAA;IACA,SAAA;EAlehB;AACF;AAqec;EACE;IACE,qCAAA;EAnehB;AACF;AAsec;EACE;IACE,qCAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;EApehB;AACF;AA6eE;EACE,eAAA;AA3eJ;AAxnHI;EAkmIF;IAGI,eAAA;EAzeJ;AACF;AA4eM;EACE,kDA5wIA;EA6wIA,eAAA;EACA,mBAAA;EACA,kBAAA;AA1eR;AAnoHI;EAymIE;IAMI,eAAA;EAxeR;AACF;AA0eM;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAxeR;AA7oHI;EAknIE;IAKI,qCAAA;IAEA,SAAA;EAveR;AACF;AAyeQ;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AAveV;AAyeU;EACE,6DAAA;AAveZ;AA6eU;EACE,gBAAA;AA3eZ;AA6eU;EAGE,0DAAA;AA7eZ;AA+eU;EACE,qBAAA;AA7eZ;AAgfU;EAEE,mBAAA;AA/eZ;AAkfY;EACE,eAAA;EACA,kDA7zIN;EA8zIM,eAAA;AAhfd;AA5qHI;EAypIQ;IAKI,eAAA;EA9ed;AACF;AAgfY;EACE,kDAp0IN;EAq0IM,eAAA;EACA,gBAAA;EACA,kBAAA;AA9ed;AAvrHI;EAiqIQ;IAMI,eAAA;IACA,kBAAA;EA5ed;AACF;AA8eY;EACE,kDA90IN;EA+0IM,eAAA;EACA,8BAAA;EACA,2BAAA;EAAA,sBAAA;AA5ed;AAgfY;EACE,WAAA;EACA,iCAAA,EAGG,oCAAA;EACH,UAAA,EAAA,gCAAA;EACA,gEAAA;AAjfd;AAzsHI;EA4rIQ;IAEI,WAAA;IACA,mBAAA;EAjfd;AACF;AAsfY;EACE,0BAAA,EAGG,iDAAA;EACH,UAAA;AAvfd;;AAggBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AA7fF;AAggBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,+CAAA;EACA,4CAAA;AA9fJ;AAigBE;EACE,QAAA;AA/fJ;AAigBE;EACE,QAAA;AA/fJ;;AAmgBA;EACE;IACE,oBAAA;EAhgBF;EAkgBA;IACE,yBAAA;EAhgBF;AACF;AAmgBA;EACE,iDA95IK;EA+5IL,0BAAA;AAjgBF;;AAogBA;EACE,SAAA;EACA,uCAAA;EACA,UAAA;AAjgBF;;AAogBA;EACE,UAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,mBAAA;EACA,0BAAA;EACA,+CAAA;AAjgBF;;AAogBA;EACE,UAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,mBAAA;EACA,mBAAA;AAjgBF;AAvxHI;EA+wIJ;IAYI,YAAA;IACA,UAAA;IACA,WAAA;IACA,+BAAA;EAhgBF;AACF;;AAmgBA;EACE;IACE,wCAAA;IACA,YAAA;EAhgBF;EAkgBA;IACE,uCAAA;IACA,YAAA;EAhgBF;EAkgBA;IACE,wCAAA;IACA,YAAA;EAhgBF;AACF;AAmgBA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAjgBF;AAogBE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;AAlgBJ;AAogBE;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;AAlgBJ;;AAsgBA;EAEE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AApgBF;AA30HI;EA00IJ;IASI,gBAAA;IACA,gBAAA;IACA,qBAAA;IACA,kBAAA;EApgBF;AACF;;AAugBA;EACE;IACE,4BAAA;EApgBF;EAsgBA;IACE,UAAA;IACA,2BAAA;EApgBF;EAsgBA;IACE,UAAA;EApgBF;AACF;AAugBA;EACE,wBAAA;AArgBF;;AAwgBA;EACE,kBAAA;EACA,oBAAA;AArgBF;AAx2HI;EA22IJ;IAII,kBAAA;IACA,oBAAA;EAngBF;AACF;AAogBE;EAcE,aAAA;EACA,mBAAA;EACA,8BAAA;AA/gBJ;AAggBI;EACE,gBAAA;EACA,kDAvhJE;EAwhJF,yBAAA;EACA,iBAAA;EACA,mBAAA;AA9fN;AA13HI;EA23IE;IACE,eAAA;IACA,mBAAA;EA9fN;AACF;AAmgBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kDAziJE;AAwiIR;AAogBE;EACE,iBAAA;EAx3IF,aAAA;EA03IE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AA9fJ;AAkgBI;EAj4IF,aAAA;EAs4II,uBAAA;EACA,SAAA;EACA,8BAAA;EACA,oBAAA;AA/fN;AAigBM;EACE,mBAAA;AA/fR;AAkgBM;EACE,SAAA;AAhgBR;AAmgBM;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAjgBR;AAogBM;EACE,YAAA;AAlgBR;AAmgBQ;EACE,gBAAA;EACA,kBAAA;AAjgBV;AAqgBM;EACE,6DAAA;EACA,mBAAA;AAngBR;AAp7HI;EAq7IE;IAII,kBAAA;EAjgBR;AACF;AAmgBM;EACE,gBAAA;AAjgBR;AAmgBM;EAEE,yBAAA;EACA,0DAAA;AAlgBR;AAogBM;EACE,qBAAA;AAlgBR;AAqgBM;EACE,kDA3mJA;EA4mJA,eAAA;EACA,gBAAA;AAngBR;AAx8HI;EAw8IE;IAKI,eAAA;EAjgBR;AACF;AAmgBM;EACE,kDAnnJA;EAonJA,eAAA;AAjgBR;AAj9HI;EAo5IA;IAmEI,mBAAA;IACA,SAAA;IACA,oBAAA;IACA,0BAAA;EAlgBN;AACF;AAz9HI;EA04IF;IAoFI,gBAAA;IACA,aAAA;EAjgBJ;AACF;AAuhBA,cAAA;AACA;;EAEE,aAAA;AArhBF;;AAwhBA;EACE,eAAA;AArhBF;;AAwhBA;EACE,yCAAA;EACA,YAAA;EACA,iBAAA;EAEA,eAAA;EACA,kDAxqJM;EAyqJN,yBAAA;EACA,UAAA;EAEA,wBAAA;EACA,eAAA;AAvhBF;AAwhBE;EAEE,YAAA;AAvhBJ;;AA2hBA;EACE,kBAAA;EAhgJA,aAAA;EAkgJA,gBAAA;EACA,uBAAA;AAphBF;AAlgII;EAkhJJ;IAMI,gBAAA;EAlhBF;AACF;;AAqhBA;EACE,sBAAA;EACA,uBAAA;AAlhBF;AAmhBE;EACE,aAAA;AAjhBJ;;AAqhBA;EACE,WAAA;EACA,YAAA;AAlhBF;;AAqhBA;EACE,yBAAA;AAlhBF;AAmhBE;EACE,YAAA;AAjhBJ;;AAqhBA,sBAAA;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAnhBF;AAriII;EAkjJJ;IAWI,gBAAA;IACA,gBAAA;IACA,mBAAA;IACA,aAAA;EAphBF;AACF;AAshBE;EACE,kBAAA;EAMA,mBAAA;EACA,eAAA;EACA,sBAAA;AAzhBJ;AA2hBI;EACE,WAAA;AAzhBN;AAgiBI;EAQE,gBAAA;EACA,kDAjwJE;EAkwJF,eAAA;AAriBN;AA3jII;EAslJA;IAaI,WAAA;IACA,SAAA;IACA,eAAA;IACA,kDAxwJA;IAywJA,eAAA;EApiBN;AACF;AAwiBE;EACE,gBAAA;EACA,kDAnxJI;EAoxJJ,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAtiBJ;AA5kII;EA4mJF;IASI,eAAA;IACA,kDAxxJE;IAyxJF,eAAA;EAriBJ;AACF;AA/kII;EAwmJF;IAeI,eAAA;EApiBJ;AACF;;AAwiBA;EACE,gBAAA;AAriBF;;AAyiBE;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AAtiBJ;AAlmII;EAqoJF;IAWI,gBAAA;EA1iBJ;AACF;AA4iBE;EACE,eAAA;AA1iBJ;AA1mII;EAmpJF;IAGI,eAAA;EAxiBJ;AACF;AA/mII;EAwpJA;IAEI,YAAA;EAviBN;AACF;AAyiBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAviBN;AA0iBI;EACE,aAAA;EACA,mBAAA;AAxiBN;AA0iBM;EACE,eAAA;EACA,kDA50JC;EA60JD,kBAAA;EACA,kBAAA;EACA,cAAA;AAxiBR;AApoII;EAuqJE;IAOI,eAAA;EAtiBR;AACF;AA0iBI;EACE,cAAA;AAxiBN;AA2iBI;;EAEE,8BA5wJK;EA6wJL,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAziBN;AA4iBI;EACE,uBAAA;EACA,kBAAA;EACA,iBAAA;AA1iBN;AA1pII;EAisJA;IAKI,cAAA;IACA,eAAA;EAxiBN;AACF;AA2iBI;EAGE,6BAAA;EACA,yNAAA;EAWA,YAAA;AArjBN;AAwjBI;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAtjBN;AAwjBM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;AAtjBR;AAyjBM;EACE,4CAAA;AAvjBR;AA0jBM;EACE,UAAA;AAxjBR;AA2jBM;EACE,8CAAA;AAzjBR;AA6jBI;EACE;IACE,eAAA;IACA,UAAA;IACA,QAAA;IACA,WAAA;IACA,uBAAA;IACA,sBAAA;IACA,mBAAA;IACA,aAAA;IACA,wCAAA;IACA,yBAAA;EA3jBN;EA6jBM;IAEE,kBAAA;IACA,MAAA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;IACA,uBAAA;IACA,SAAA;IACA,UAAA;EA5jBR;EAgkBI;IACE,aAAA;EA9jBN;AACF;AAikBE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AA/jBJ;AAkkBE;EACE,qBAAA;EACA,yNAAA;EAYA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA3kBJ;AAilBM;EACE,gBAAA;EACA,+BA94JI;EA+4JJ,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AA/kBR;AAjvII;EA0zJE;IAQI,kBAAA;IAEA,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EA9kBR;AACF;AAtvII;EAszJE;IAgBI,eAAA;IACA,kBAAA;IACA,iBAAA;EA5kBR;AACF;AA8kBM;EAEE,aAAA;EACA,qCAAA;EACA,SAAA;AA7kBR;AAtwII;EA+0JE;IAQI,aAAA;IACA,qCAAA;IACA,SAAA;EA7kBR;AACF;AA+kBM;EACE,aAAA;EACA,SAAA;AA7kBR;AAjxII;EA41JE;IAII,mBAAA;IACA,sBAAA;EA3kBR;AACF;AA6kBM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3kBR;AA4kBQ;EAEE,8BAj8JC;EAk8JD,cAAA;EACA,eAAA;AA3kBV;AA8kBM;EACE,cAAA;EACA,8BAx8JG;EAy8JH,iBAAA;EACA,eAAA;EACA,gBAAA;AA5kBR;AA5yII;EAm3JE;IAOI,gBAAA;IACA,eAAA;IACA,kBAAA;EA1kBR;AACF;AA4kBM;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;AA1kBR;AAxzII;EA+3JE;IAKI,gBAAA;EAxkBR;AACF;AA0kBM;EACE,8BA39JG;EA49JH,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AAxkBR;AA0kBM;EACE,8BAr+JG;EAs+JH,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,6BAAA;EACA,yNAAA;EAWA,YAAA;EACA,uBAAA;AAplBR;AAulBM;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AArlBR;AAv1II;EAy6JE;IAKI,sBAAA;IACA,oBAAA;EAnlBR;AACF;AAqlBQ;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,yNAAA;AAnlBV;AAn2II;EAk7JI;IAiBI,aAAA;EA5lBV;AACF;AA8lBQ;EACE,WAAA;AA5lBV;AA+lBQ;EAGE,gBAAA;EAEA,mBAAA;EACA,aAAA;EACA,sBAAA;AAhmBV;AAomBU;EAKE,kBAAA;EAEA,WAAA;AAvmBZ;AA6mBU;EAEE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AA5mBZ;AA33II;EAk+JM;IASI,QAAA;EA5mBZ;EA8mBY;IACE,kBAAA;EA5mBd;AACF;AAgnBU;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;EACA,QAAA;AA9mBZ;AA14II;EAm/JM;IAOI,aAAA;IACA,qCAAA;EA5mBZ;AACF;AA+mBU;EACE,+BAllKA;EAmlKA,eAAA;EACA,gBAAA;EACA,gBAAA;AA7mBZ;AA+mBU;EACE,UAAA;EACA,gBAAA;AA7mBZ;AAgnBU;EAEE,uBAAA;EAEA,UAAA;AAhnBZ;AAmnBU;EACE,kBAAA;EACA,+BArmKA;EAsmKA,YAAA;EACA,eAAA;EACA,oBAAA;AAjnBZ;AAwnBU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtnBZ;AAwnBU;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtnBZ;AA/6II;EAkiKM;IAMI,aAAA;IACA,sBAAA;EArnBZ;AACF;AAwnBU;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAnoKA;EAooKA,eAAA;AAtnBZ;AA57II;EA6iKM;IAOI,eAAA;EApnBZ;AACF;AAsnBU;EAEE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,8BAjlKA;AA49IZ;AAwnBU;;EAEE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,8BA5lKA;AAs+IZ;AAynBU;EACE,YAAA,EAAA,2BAAA;EAEA,eAAA,EAAA,cAAA;EACA,YAAA,EAAA,6BAAA;EACA,8BApmKA;EAqmKA,0BAAA;AAxnBZ;AA4nBU;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BA9qKA;AAojJZ;AAl+II;EAulKM;IAOI,eAAA;EAxnBZ;AACF;AA2nBU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,8CAAA;AAznBZ;AAh/II;EAkmKM;IASI,YAAA;EAvnBZ;AACF;AA0nBU;EACE,yBAAA;EACA,qBAAA;AAxnBZ;AA2nBU;EACE,iBAAA;AAznBZ;AA4nBU;EACE,UAAA;EACA,eAAA;EACA,SAAA;AA1nBZ;AA6nBU;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AA3nBZ;AA8nBU;EACE,yBAAA;AA5nBZ;AA+nBU;EACE,kBAAA;EAGA,kBAAA;AA/nBZ;AAlhJI;EA6oKM;IAOI,kBAAA;IACA,iBAAA;EA9nBZ;AACF;AAioBU;EACE,aAAA;AA/nBZ;AAqoBU;EACE,cAAA;EACA,+BApvKA;EAqvKA,eAAA;EACA,mBAAA;AAnoBZ;AAjiJI;EAgqKM;IAMI,eAAA;EAjoBZ;AACF;AAmoBU;EACE,cAAA;EACA,8BA9vKD;EA+vKC,eAAA;EACA,mBAAA;AAjoBZ;AA5iJI;EAyqKM;IAMI,eAAA;EA/nBZ;AACF;AAkoBU;EACE,uBAAA;EACA,kBAAA;EACA,4BAzwKD;EA0wKC,eAAA;EAEA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAjoBZ;AAooBU;EACE,yBAAA;AAloBZ;AAwoBI;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AAtoBN;AAyoBM;EACE,kBAAA;EACA,uBAAA;AAvoBR;AA9kJI;EAysKA;IAeI,WAAA;EAtoBN;AACF;AAyoBI;EACE,kBAAA;AAvoBN;AAyoBM;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AAvoBR;AA3lJI;EA+tKE;IAKI,gBAAA;EAroBR;AACF;AAwoBM;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtoBR;AAyoBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;AAvoBR;AAyoBM;EACE,YAAA;AAvoBR;AA2oBI;EACE,kBAAA;AAzoBN;AA0oBM;EACE,kBAAA;AAxoBR;AA0oBM;EACE,eAAA;EACA,iBAAA;EACA,+BAv1KI;AA+sJZ;AA7nJI;EAkwKE;IAKI,eAAA;IACA,iBAAA;EAtoBR;AACF;AAwoBM;EACE,gBAAA;EACA,eAAA;EACA,kDAj7KC;EAk7KD,iBAAA;AAtoBR;AA0oBI;EACE,iBAAA;AAxoBN;AA5oJI;EAmxKA;IAGI,gBAAA;EAtoBN;AACF;AAuoBM;EAEE,aAAA;EACA,uBAAA;AAtoBR;AAwoBM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAtoBR;AAwoBM;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAtoBR;AAwoBQ;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAp4KC;EAq4KD,kBAAA;AAtoBV;AA5qJI;EA4yKI;IAQI,eAAA;IACA,gBAAA;EApoBV;AACF;AAsoBQ;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAh5KC;EAi5KD,kBAAA;AApoBV;AA1rJI;EAwzKI;IAQI,eAAA;IACA,gBAAA;EAloBV;AACF;AAuoBI;EACE,kBAAA;AAroBN;AAsoBM;EACE,iBAAA;EACA,YAAA;AApoBR;AAsoBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AApoBR;AA7sJI;EA60KE;IAMI,sBAAA;EAloBR;AACF;AAooBM;EACE,SAAA;AAloBR;AAooBM;EACE,SAAA;AAloBR;AAooBM;EACE,eAAA;EACA,iBAAA;EACA,+BAj7KI;AA+yJZ;AA7tJI;EA41KE;IAKI,iBAAA;EAhoBR;AACF;AAkoBM;EACE,eAAA;EACA,kDAzgLC;EA0gLD,iBAAA;EAEA,YAAA;AAjoBR;AAmoBM;EACE,gBAAA;EACA,eAAA;EACA,8BAj8KG;EAk8KH,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;AAloBR;AAsoBI;EACE,gBAAA;EACA,qBAAA;EACA,wDAAA;AApoBN;AAtvJI;EAu3KA;IAKI,cAAA;IACA,qBAAA;IACA,yDAAA;EAloBN;AACF;AAmoBM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAjoBR;AAlwJI;EAg4KE;IAKI,cAAA;EA/nBR;AACF;AAioBM;EACE,+BA39KI;EA49KJ,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AA/nBR;AA/wJI;EAw4KE;IAQI,eAAA;IACA,gBAAA;IACA,mBAAA;EA7nBR;AACF;AA+nBM;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AA7nBR;AA9xJI;EAq5KE;IAQI,gBAAA;IACA,cAAA;IACA,WAAA;IACA,kBAAA;IACA,cAAA;IACA,SAAA;IAEA,SAAA;IACA,MAAA;IACA,6BAAA;IACA,aAAA;EA5nBR;AACF;AA8nBM;EACE,iBAAA;AA5nBR;AA8nBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AA5nBR;AAtzJI;EA66KE;IAOI,eAAA;IACA,WAAA;EA1nBR;AACF;AA4nBM;EACE,cAAA;AA1nBR;AA4nBM;EACE,cAAA;AA1nBR;AA4nBM;;EAEE,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA,EAAA,gCAAA;EACA,QAAA;EACA,2BAAA,EAAA,sBAAA;EACA,WAAA,EAAA,8BAAA;EACA,eAAA;AA1nBR;AAgoBM;EACE,0DAAA;AA9nBR;AAl1JI;EA+8KE;IAGI,WAAA;IACA,WAAA;EA5nBR;AACF;AAp1JI;EA28KE;IAOI,YAAA;EA1nBR;AACF;AA6nBM;EACE,0DAAA;AA3nBR;AAh2JI;EA09KE;IAGI,WAAA;IACA,UAAA;EAznBR;AACF;AAl2JI;EAs9KE;IAOI,WAAA;EAvnBR;AACF;AAynBM;;EAEE,eAAA;EACA,iBAAA;EACA,8BA3jLG;EA4jLH,gBAAA;EACA,cAAA;AAvnBR;AAn3JI;EAo+KE;;IAQI,kBAAA;EApnBR;AACF;AAsnBM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAtkLG;EAukLH,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AApnBR;AAn4JI;EA++KE;IAUI,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;EAlnBR;AACF;AAsnBI;EACE,eAAA;AApnBN;AAunBM;EACE,eAAA;EACA,iBAAA;EACA,+BA1lLI;EA2lLJ,kBAAA;AArnBR;AAp5JI;EAqgLE;IAMI,eAAA;IACA,iBAAA;EAnnBR;AACF;AAsnBM;EACE,eAAA;EACA,iBAAA;EACA,+BArmLI;EAsmLJ,kBAAA;EACA,mBAAA;AApnBR;AAunBM;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AArnBR;AAz6JI;EAwhLE;IASI,4BAAA;EApnBR;AACF;AAsnBM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;AArnBR;AAunBM;EACE,eAAA;EACA,+BA/nLI;EAgoLJ,iBAAA;AArnBR;AAz7JI;EA2iLE;IAKI,iBAAA;EAnnBR;AACF;AAqnBM;EACE,eAAA;EACA,+BAvoLI;EAwoLJ,iBAAA;AAnnBR;AAunBI;EACE,iBAAA;AArnBN;AAsnBM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAlpLI;EAmpLJ,kBAAA;EACA,mBAAA;AApnBR;AA98JI;EA4jLE;IAQI,eAAA;IACA,gBAAA;EAlnBR;AACF;AAonBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAlnBR;AAqnBM;EACE,aAAA;EACA,WAAA;EAGA,kBAAA;AArnBR;AAj+JI;EAilLE;IAQI,sBAAA;EApnBR;AACF;AAunBM;EACE,UAAA;AArnBR;AAz+JI;EA6lLE;IAGI,WAAA;EAnnBR;AACF;AAsnBM;EACE,kBAAA;AApnBR;AAunBM;EACE,UAAA;AArnBR;AAp/JI;EAwmLE;IAGI,WAAA;EAnnBR;AACF;AAsnBM;EAEE,aAAA;EACA,iBAAA;EACA,oBAAA;EAKA,YAAA;EACA,kBAAA;AAznBR;AA2nBM;EACE,eAAA;EACA,+BA/sLI;EAgtLJ,iBAAA;EACA,cAAA;EACA,mBAAA;AAznBR;AA2nBM;EACE,eAAA;EACA,8BAvtLG;EAwtLH,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAznBR;AA4nBM;EACE,+CAAA;EACA,UAAA,EAAA,sDAAA;AA1nBR;AA4nBM;EACE,8CAAA,EAAA,sDAAA;EACA,UAAA,EAAA,sDAAA;AA1nBR;AA4nBM;EACE,8CAAA,EAAA,sDAAA;EACA,UAAA,EAAA,sDAAA;AA1nBR;AA6nBM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;AA3nBR;AA6nBM;EACE,SAAA;EACA,WAAA;EACA,2BAAA;EACA,WAAA;AA3nBR;AA8nBM;EACE,SAAA;EACA,WAAA;EACA,2BAAA;EACA,MAAA;EACA,WAAA;AA5nBR;AA8nBM;EACE,mBAAA;AA5nBR;AA+nBM;EACE,mBAAA;AA7nBR;AAvjKI;EAmrLE;IAGI,kBAAA;IACA,+CAAA;EA3nBR;AACF;AA6nBM;EACE,oBAAA;AA3nBR;AAhkKI;EA0rLE;IAGI,aAAA;EAznBR;AACF;AA4nBM;EACE,yBAAA;EACA,YAAA;AA1nBR;AA4nBM;EACE,yBAAA;EACA,YAAA;AA1nBR;AA7kKI;EA6sLF;IAEI,iBAAA;EA9nBJ;AACF;AAioBE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/nBJ;AAioBE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;AA/nBJ;AAjmKI;EAytLF;IAUI,8BAAA;IACA,SAAA;EA9nBJ;AACF;AA+nBI;EACE,SAAA;AA7nBN;AAgoBI;EACE,gBAAA;EACA,eAAA;EACA,8BAh0LK;EAi0LL,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;AA/nBN;AAkoBE;;EAEE,SAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhoBJ;AA3nKI;EAqvLF;;IAQI,kBAAA;IACA,SAAA;EA7nBJ;AACF;AA+nBE;EACE,gBAAA;AA7nBJ;AA+nBE;EAEE,kBAAA;EACA,WAAA;EAEA,UAAA;EACA,cAAA;AA/nBJ;AAioBI;EACE,eAAA;EACA,iBAAA;EACA,+BAj2LM;AAkuKZ;AAhpKI;EA4wLA;IAKI,eAAA;IACA,iBAAA;EA7nBN;AACF;AA+nBI;EACE,eAAA;EACA,kDA17LG;EA27LH,iBAAA;EAEA,YAAA;AA9nBN;AA5pKI;EAqxLA;IAOI,eAAA;IACA,gBAAA;EA5nBN;AACF;AA+nBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;AA7nBJ;AA3qKI;EAiyLF;IASI,YAAA;IACA,aAAA;EA3nBJ;AACF;AA7qKI;EA6xLF;IAaI,YAAA;IACA,aAAA;EAznBJ;AACF;AA2nBI;EACE,0DAAA;AAznBN;AA2nBI;EACE,0DAAA;AAznBN;AA2nBI;EACE,0DAAA;AAznBN;AA2nBI;EACE,0DAAA;AAznBN;AA2nBI;EACE,0DAAA;AAznBN;AA8tBE;EACE,iBAAA;AA5tBJ;AA8tBI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BA//LM;AAmyKZ;AAjtKI;EAu6LA;IASI,eAAA;IACA,gBAAA;EA3tBN;AACF;AA8tBI;EACE,UAAA;EACA,cAAA;AA5tBN;AA+tBI;EACE,wCAAA;EACA,mBAAA;EACA,mBAAA;AA7tBN;AAguBI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;EACA,yBAAA;AA9tBN;AAguBM;EACE,eAAA;EACA,WAAA;AA9tBR;AArvKI;EAg8LA;IAuBI,aAAA;IACA,QAAA;EA9tBN;EA+tBM;IACE,eAAA;IACA,iBAAA;EA7tBR;AACF;AAiuBI;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AA/tBN;AAiuBM;EACE,kBAAA;AA/tBR;AAkuBM;EACE,8BAlkMG;AAk2KX;AA/wKI;EAg+LA;IAmBI,eAAA;EAhuBN;AACF;AAmuBI;EAEE,8BA5kMK;EA6kML,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAluBN;AAquBI;EACE,kBAAA,EAAA,yDAAA;AAnuBN;AAuuBE;EACE,kBAAA;AAruBJ;AAjyKI;EAqgMF;IAGI,iBAAA;EAnuBJ;AACF;AAlyKI;EAigMF;IAMI,kBAAA;EAjuBJ;AACF;AAkuBI;EACE,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAhuBN;AAlzKI;EA6gMA;IAOI,sBAAA;IACA,aAAA;EA9tBN;AACF;AAguBM;EACE,8BA5mMG;EA6mMH,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AA9tBR;AAguBM;EACE,8BAnnMG;EAonMH,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AA9tBR;AAt0KI;EA+hME;IAOI,eAAA;EA5tBR;AACF;AAiuBE;EACE,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0DAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AA/tBJ;AAt1KI;EA4iMF;IAWI,0DAAA;IACA,2BAAA;IACA,wBAAA;IACA,4BAAA;IACA,oBAAA;IACA,gBAAA;EA7tBJ;AACF;AA8tBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA5tBN;AAr2KI;EA8jMA;IAOI,sBAAA;IACA,SAAA;EA5tBN;AACF;AA8tBM;EACE,8BA5lMI;EA6lMJ,eAAA;EACA,YAAA;AA5tBR;AA+tBI;EACE,YAAA;AA7tBN;AAn3KI;EA+kMA;IAGI,YAAA;EA3tBN;AACF;AA6tBI;EACE,aAAA;EACA,mBAAA;AA3tBN;AA4tBM;EACE,cAAA;AA1tBR;AA/3KI;EAqlMA;IAQI,sBAAA;IACA,SAAA;EA1tBN;AACF;AA4tBI;EACE,eAAA;EACA,kDAtwMG;EAuwMH,kBAAA;EACA,kBAAA;EACA,YAAA;AA1tBN;AA54KI;EAimMA;IAOI,eAAA;EAxtBN;AACF;AA2tBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AAztBN;AA0tBM;EACE,YAAA;AAxtBR;AA95KI;EA4mMA;IAaI,YAAA;EAvtBN;AACF;AA0tBI;EACE,YAAA;EACA,eAAA;EACA,kDAnyMG;EAoyMH,iBAAA;EACA,kBAAA;EAEA,YAAA;AAztBN;AA36KI;EA6nMA;IAWI,eAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,YAAA;EAztBN;AACF;;AA6tBA;EACE,eAAA;AA1tBF;AA4tBI;EACE,iDA5zMC;EA6zMD,eAAA;EACA,kBAAA;EACA,oBAAA;AA1tBN;AA4tBI;EACE,kDAj0ME;EAk0MF,eAAA;AA1tBN;AA4tBI;EACE,2BAhrMG;EAirMH,eAAA;EACA,cAAA;AA1tBN;AA4tBI;EACE,8BAvrMM;EAwrMN,eAAA;EACA,cAAA;AA1tBN;;AAuuBE;EACE,gBAAA;EACA,cAAA;EACA,UAAA;AApuBJ;AA/8KI;EAgrMF;IAMI,UAAA;IACA,gBAAA;IACA,cAAA;EAnuBJ;AACF;AA19KI;EAorMF;IAYI,YAAA;IAEA,cAAA;EAnuBJ;AACF;AAsuBE;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AApuBJ;AAj+KI;EAksMF;IAMI,UAAA;IACA,gBAAA;IACA,cAAA;EAnuBJ;AACF;AA5+KI;EAssMF;IAYI,YAAA;IAEA,cAAA;EAnuBJ;AACF;AAsuBE;EACE,0DAAA;EACA,sBAAA;EA3CA,4BAAA;EACA,2BAAA;AAxrBJ;AAquBI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAnuBN;AAhgLI;EA6tMA;IASI,oBAAA;IACA,iBAAA;EAluBN;AACF;AAouBM;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AAluBR;AA5gLI;EA0uME;IAOI,YAAA;IACA,YAAA;IACA,kBAAA;IACA,QAAA;EAjuBR;AACF;AAmuBQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAjuBV;AAmuBU;EACE,eAAA;AAjuBZ;AAouBU;EACE,kBAAA;EACA,2BAzxMH;EA0xMG,eAAA;EACA,gBAAA;AAluBZ;AAziLI;EAuwMM;IAOI,eAAA;EAjuBZ;AACF;AAsuBM;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EAAA,kBAAA;AApuBR;AAsuBQ;EACE,eAAA;EACA,kBAAA;EACA,8BAjzME;EAkzMF,eAAA;EACA,kBAAA;AApuBV;AA7jLI;EA4xMI;IAQI,oBAAA;EAnuBV;AACF;AAsuBQ;EArxMN,aAAA;EAuxMQ,oBAAA;EACA,SAAA;AAhuBV;AAkuBU;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAjuBZ;AAmuBY;EACE,kBAAA;AAjuBd;AAmuBc;EACE,kBAAA;EACA,UAAA;EAEA,UAAA;EACA,gCAAA;EACA,eAAA;AAluBhB;AAsuBY;EACE,YAAA;AApuBd;AAuuBY;EACE,WAAA;AAruBd;AA2uBM;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAzuBR;AA2uBQ;EACE,cAAA;EACA,cAAA;AAzuBV;AA4uBQ;EACE,eAAA;EACA,2BA12MD;EA42MC,cAAA;EACA,kBAAA;AA3uBV;AAlnLI;EAw1MI;IAQI,eAAA;EA1uBV;AACF;AA8uBM;EACE,kBAAA;EACA,WAAA;EACA,8BA13MI;EA23MJ,eAAA;AA5uBR;AA7nLI;EAq2ME;IAOI,eAAA;EA3uBR;AACF;AA8uBM;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,8BAv4MI;EAw4MJ,uBAAA;EACA,cAl4MC;EAm4MD,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AA5uBR;AAhpLI;EAg3ME;IAeI,eAAA;IACA,kBAAA;EA3uBR;AACF;AA6uBQ;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;AA3uBV;AAkvBI;EACE,eAAA;AAhvBN;AAkvBM;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,aAAA;EACA,gBAAA;AAhvBR;AArqLI;EAg5ME;IAOI,qCAAA;IACA,gBAAA;IAEA,SAAA;EA/uBR;AACF;AAivBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AA/uBR;AAtrLI;EA65ME;IAUI,aAAA;IACA,QAAA;EA7uBR;AACF;AA8uBQ;EACE,WAAA;AA5uBV;AA/rLI;EA06MI;IAGI,WAAA;EA1uBV;AACF;AA6uBM;EACE,eAAA;EACA,2BAn8MC;EAo8MD,mBAAA;EACA,uEAAA;EACA,6BAAA;EACA,oCAAA;AA3uBR;AA5sLI;EAi7ME;IASI,eAAA;IACA,kBAAA;EA1uBR;AACF;AA6uBM;EACE,eAAA;EACA,8BAn9MI;EAo9MJ,iBAAA;AA3uBR;AAvtLI;EA+7ME;IAMI,eAAA;IACA,gBAAA;EA1uBR;AACF;AA+uBE;EAEE,eAAA;EACA,yBAAA;AA9uBJ;AAivBM;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,8BAx+MI;EAy+MJ,mBAAA;EACA,8BAAA;AA/uBR;AAkvBM;EACE,YAAA;EACA,eAAA;EACA,2BA9+MC;EA++MD,yBAAA;AAhvBR;AAuvBM;EAEE,+EAAA;EAr9MN,aAAA;EA89MM,kBAAA;EACA,8BAAA;AAzvBR;AA2vBQ;EACE,kBAAA;EACA,iBAAA;EACA,2BAvgND;EAwgNC,YAAA;EACA,yBAAA;AAzvBV;AAhwLI;EAo/MI;IAQI,eAAA;EAxvBV;AACF;AA2vBQ;EACE,iBAAA;EACA,2BAlhND;EAmhNC,YAAA;EACA,yBAAA;EACA,mBAAA;AAzvBV;AA5wLI;EAggNI;IAQI,gBAAA;EAxvBV;AACF;AA4vBM;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,8BAAA;AA1vBR;AA1xLI;EA6gNE;IAUI,sBAAA;IACA,oBAAA;EAzvBR;AACF;AA2vBQ;EAGE,UAAA;EA3gNR,aAAA;EA6gNQ,uBAAA;EACA,eAAA;EACA,SAAA;AAvvBV;AA3yLI;EA2hNI;IAUI,WAAA;IACA,eAAA;IACA,SAAA;EAtvBV;AACF;AA+vBY;EACE,kBAAA;EACA,YAAA;AA7vBd;AAiwBU;EApiNR,aAAA;EAuiNU,6BAAA;EACA,WAAA;EACA,8BAAA;EACA,sBAAA;AA5vBZ;AA8vBY;EACE,eAAA;EACA,2BAjlNL;AAq1LT;AA+vBY;EACE,eAAA;EACA,8BAxlNF;AA21LZ;AAgwBY;EAtjNV,aAAA;EAwjNY,SAAA;AA1vBd;AAj1LI;EAykNQ;IAKI,sBAAA;IACA,QAAA;EAzvBd;AACF;AA2vBc;EACE,8BArmNJ;EAsmNI,cAAA;AAzvBhB;AA31LI;EAklNU;IAKI,eAAA;EAxvBhB;AACF;AA2vBc;EACE,2BA5mNP;AAm3LT;AAn2LI;EA2lNU;IAII,eAAA;EAxvBhB;AACF;AA4vBY;EACE,eAAA;EACA,2BAtnNL;EAunNK,8DAAA;EACA,6BAAA;EACA,oCAAA;EAEA,2BA3nNL;AAg4LT;AAh3LI;EAomNQ;IAUI,eAAA;EA1vBd;AACF;AAgwBM;EACE,iBAAA;EACA,oBAAA;AA9vBR;AAz3LI;EAqnNE;IAKI,mBAAA;EA7vBR;AACF;AA+vBQ;EA1mNN,aAAA;EA4mNQ,SAAA;AAzvBV;AAt4LI;EA6nNI;IAKI,sBAAA;IACA,mBAAA;IACA,MAAA;EAxvBV;AACF;AA0vBU;EACE,8BA1pNA;EA2pNA,cAAA;AAxvBZ;AA2vBU;EACE,2BA7pNH;AAo6LT;AAp5LI;EA4oNM;IAII,eAAA;EAxvBZ;AACF;AA+vBE;EACE,eAAA;EACA,0DAAA;EACA,sBAAA;EA5eA,4BAAA;EACA,2BAAA;AAhRJ;AA+vBM;EACE,YAAA;EACA,eAAA;EACA,2BAlrNC;EAmrND,mBAAA;AA7vBR;AAt6LI;EA+pNE;IAOI,eAAA;IACA,kBAAA;EA5vBR;AACF;AA+vBM;EACE,WAAA;AA7vBR;AA8vBQ;EACE,aAAA;AA5vBV;AA8vBQ;EACE,qBAAA;AA5vBV;AA6vBU;EACE,sBAAA;AA3vBZ;AA6vBU;EACE,wCAAA;AA3vBZ;AA6vBU;EACE,iDAAA;AA3vBZ;AAgwBM;EA3qNJ,aAAA;EA6qNM,sBAAA;EACA,SAAA;AA1vBR;AA4vBQ;EAhrNN,aAAA;EAkrNQ,SAAA;AAtvBV;AA/8LI;EAmsNI;IAKI,sBAAA;EArvBV;AACF;AAuvBU;EAxrNR,aAAA;EA0rNU,eAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;AAjvBZ;AA/9LI;EA2sNM;IAQI,sBAAA;EAhvBZ;AACF;AAmvBU;EACE,UAAA;EACA,kBAAA;AAjvBZ;AAx+LI;EAutNM;IAKI,WAAA;EAhvBZ;AACF;AAkvBY;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAhvBd;AAmvBY;EACE,WAAA;EACA,kBAAA;AAjvBd;AAmvBc;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAjvBhB;AAsvBU;EACE,eAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EAEA,YAAA;AArvBZ;AAuvBY;EACE,cAAA;AArvBd;AA3gMI;EAqvNM;IAeI,WAAA;IACA,kBAAA;IACA,eAAA;EArvBZ;AACF;AAyvBQ;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAlyNE;AA2iMZ;AAyvBU;EACE,cAAA;EACA,eAAA;EACA,sBAAA;AAvvBZ;AA9hMI;EA2wNI;IAcI,kBAAA;IACA,eAAA;EAvvBV;AACF;AA0vBQ;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BArzNE;EAszNF,WAAA;AAxvBV;AA0vBU;EACE,cAAA;EACA,eAAA;EACA,sBAAA;AAxvBZ;AAjjMI;EA8xNI;IAeI,kBAAA;IACA,eAAA;IACA,aAAA;EAxvBV;AACF;AA4vBM;EACE,qBAAA;EACA,iBAAA;EACA,8BAz0NI;EA00NJ,cAn0NC;EAo0ND,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EAEA,YAAA;EACA,6BAAA;EACA,uBAAA;AA3vBR;AArkMI;EAozNE;IAeI,cAAA;IACA,kBAAA;IACA,eAAA;IACA,cAAA;IACA,kBAAA;IACA,oBAAA;IACA,iBAAA;IACA,kBAAA;IACA,uBAAA;IAAA,kBAAA;EA1vBR;AACF;AA4vBQ;EACE,uBAAA;EACA,cA31ND;EA41NC,uBAAA;EACA,gBAAA;AA1vBV;AAgwBE;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EAEA,yBAAA;AA/vBJ;AAiwBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AA/vBN;AAtmMI;EA+1NA;IASI,sBAAA;IACA,SAAA;IACA,mBAAA;EA9vBN;AACF;AAgwBM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA9vBR;AA+vBQ;EACE,YAAA;AA7vBV;AA+vBQ;EACE,6BAt4NC;AAyoMX;AAiwBM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8BA/4NI;AAgpMZ;AAgwBQ;EACE,6BAh5NC;AAkpMX;AAgwBQ;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AA9vBV;AAtoMI;EAi4NI;IAKI,sBAAA;IACA,mBAAA;EA5vBV;AACF;AA5oMI;EAy3NE;IAmBI,sBAAA;IACA,SAAA;IACA,mBAAA;EA5vBR;AACF;;AAmwBE;EACE,kBAAA;AAhwBJ;AAkwBE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;EACA,2BA5+NI;EA6+NJ,eAAA;AAhwBJ;AAhqMI;EAy5NF;IASI,eAAA;EA9vBJ;AACF;AAjqMI;EAq5NF;IAYI,eAAA;EA5vBJ;AACF;AA8vBE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AA5vBJ;AA6vBI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AA3vBN;AArrMI;EA66NA;IAMI,qCAAA;IACA,eAAA;EA1vBN;AACF;AA4vBI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AA1vBN;AA4vBI;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,oCAAA;EACA,sCAAA;EACA,kBAAA;AA1vBN;AA4vBI;EACE,kCAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;AA1vBN;;AA+vBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EAEA,kBAAA;EACA,aAAA;AA7vBF;;AAgwBA;EAEE,aAAA;EACA,mBAAA;EAEA,gBAAA;EACA,WAAA;AA/vBF;;AAkwBA;EACE,iBAAA;EACA,mBAAA;EACA,2BA1/NO;EA2/NP,WAAA;EACA,0BAAA;AA/vBF;AA7uMI;EAu+NJ;IAOI,iBAAA;EA7vBF;AACF;;AAgwBA;EACE,iBAAA;EAEA,mBAAA;EACA,4BAvkOO;AAy0MT;;AAiwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EAIA,qBAAA;EACA,0BAAA;EAEA,iBAAA;EACA,sCAAA;EACA,4BAAA;EACA,8BA1lOS;EA2lOT,eAAA;EACA,mBAAA;EACA,oCAAA;AAlwBF;AAmwBE;EACE,WAAA;AAjwBJ;AA3wMI;EAy/NJ;IAsBI,iBAAA;EAhwBF;EAiwBE;IACE,WAAA;EA/vBJ;AACF;;AAuwBE;EACE,iCAAA,EAAA,oCAAA;EACA,UAAA,EAAA,gCAAA;EACA,gEAAA;AApwBJ","sourcesContent":["// //\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Black\";\n  src: url(\"../fonts/NeueHaasDisplay-Black.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Black.woff\") format(\"woff\");\n  font-weight: 900;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Bold\";\n  src: url(\"../fonts/NeueHaasDisplay-Bold.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Light\";\n  src: url(\"../fonts/NeueHaasDisplay-Light.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Mediu\";\n  src: url(\"../fonts/NeueHaasDisplay-Mediu.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Mediu.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Roman\";\n  src: url(\"../fonts/NeueHaasDisplay-Roman.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Roman.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro XXThin\";\n  src: url(\"../fonts/NeueHaasDisplay-XXThin.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-XXThin.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro XThin\";\n  src: url(\"../fonts/NeueHaasDisplay-XThin.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-XThin.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro Thin\";\n  src: url(\"../fonts/NeueHaasDisplay-Thin.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-Thin.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro light italic\";\n  src: url(\"../fonts/NeueHaasDisplay-LightItalic.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-LightItalic.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display Pro roman italic\";\n  src: url(\"../fonts/NeueHaasDisplay-RomanItalic.woff2\") format(\"woff2\"),\n    url(\"../fonts/NeueHaasDisplay-RomanItalic.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: italic;\n  font-display: swap;\n}\n\n// ad-accounts\n\n/* VARIABLES */\n\n$black: \"Neue Haas Grotesk Display Pro Black\";\n$bold: \"Neue Haas Grotesk Display Pro Bold\";\n$light: \"Neue Haas Grotesk Display Pro Light\";\n$lightItalic: \"Neue Haas Grotesk Display Pro light italic\";\n$medium: \"Neue Haas Grotesk Display Pro Mediu\";\n$roman: \"Neue Haas Grotesk Display Pro Roman\";\n$romanItalic: \"Neue Haas Grotesk Display Pro roman italic\";\n$xxthin: \"Neue Haas Grotesk Display Pro XXThin\";\n$xthin: \"Neue Haas Grotesk Display Pro XThin\";\n$thin: \"Neue Haas Grotesk Display Pro Thin\";\n\n/* Color */\n$Yellow: #e5b400;\n$Orange: #e05300;\n$Pink: #e977c1;\n$Blue: #516beb;\n$grayC: #808080;\n\n// ad-accounts\n@font-face {\n  font-family: \"Manrope Bold\";\n  src: url(\"../fonts/Manrope-Bold.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Extralight\";\n  src: url(\"../fonts/Manrope-ExtraLight.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-ExtraLight.woff\") format(\"woff\");\n  font-weight: 200;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Medium\";\n  src: url(\"../fonts/Manrope-Medium.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Extrabold\";\n  src: url(\"../fonts/Manrope-ExtraBold.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-ExtraBold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Light\";\n  src: url(\"../fonts/Manrope-Light.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Semibold\";\n  src: url(\"../fonts/Manrope-SemiBold.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-SemiBold.woff\") format(\"woff\");\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Manrope Regular\";\n  src: url(\"../fonts/Manrope-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/Manrope-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* VARIABLES */\n\n$Mregular: \"Manrope Regular\";\n$Msemibold: \"Manrope Semibold\";\n$Mlight: \"Manrope Light\";\n$Mextrabold: \"Manrope Extrabold\";\n$Mmedium: \"Manrope Medium\";\n$Mextralight: \"Manrope Extralight\";\n$Mbold: \"Manrope Bold\";\n\n// ecom\n@font-face {\n  font-family: \"DM Sans Regular\";\n  src: url(\"../fonts/DMSans-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans MedItalic\";\n  src: url(\"../fonts/DMSans-MediumItalic.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-MediumItalic.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans Bold\";\n  src: url(\"../fonts/DMSans-Bold.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans Italic\";\n  src: url(\"../fonts/DMSans-Italic.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-Italic.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans Medium\";\n  src: url(\"../fonts/DMSans-Medium.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"DM Sans BoldItalic\";\n  src: url(\"../fonts/DMSans-BoldItalic.woff2\") format(\"woff2\"),\n    url(\"../fonts/DMSans-BoldItalic.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: italic;\n  font-display: swap;\n}\n\n/* VARIABLES */\n\n$DMregular: \"DM Sans Regular\";\n$DMmedium: \"DM Sans Medium\";\n$DMbold: \"DM Sans Bold\";\n$DMitalic: \"DM Sans Italic\";\n$DMiditalic: \"DM Sans MedItalic\";\n$DMbolditalic: \"DM Sans BoldItalic\";\n\n$DmPink: #e977c1;\n//\n\n/* MIXINS */\n\n@mixin mq($size) {\n  @if $size==xs {\n    @media (max-width: 320px) {\n      @content;\n    }\n  } @else if $size==mobile {\n    @media (max-width: 767px) {\n      @content;\n    }\n  } @else if $size==tab {\n    @media only screen and (min-width: 768px) and (max-width: 1024px) {\n      @content;\n    }\n  } @else if $size==desktop {\n    @media only screen and (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin flexbox {\n  display: -webkit-box; // old\n  display: -moz-box; // old\n  display: -ms-flexbox; // ie\n  display: -webkit-flex; // new\n  display: flex; // new\n}\n\n/* RESET CSS */\n\n/* http://meyerweb.com/eric/tools/css/reset/\n     v2.0 | 20110126\n     License: none (public domain)\n  */\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  color: inherit;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n* {\n  box-sizing: border-box;\n}\n\na {\n  &,\n  &:hover,\n  &:active,\n  &:visited,\n  &:focus {\n    color: inherit;\n  }\n\n  text-decoration: none;\n}\n\ni,\nem,\n.italic-text {\n  font-style: italic;\n}\n\nb,\nstrong,\nth,\n.bold-text {\n  //font-weight: bold;\n}\n\n.left {\n  float: left;\n}\n\n.right {\n  float: right;\n}\n\n.wrap-clear::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.clearfix {\n  zoom: 1;\n  display: table;\n  clear: both;\n\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n}\n\n:focus {\n  outline: none;\n}\n\ninput,\nbutton,\ntextarea {\n  border-radius: 0;\n  appearance: none;\n}\n\nselect {\n  border-radius: 0;\n}\n\ntextarea {\n  resize: none;\n}\n\n/* COMMONS */\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  letter-spacing: 0.6px;\n}\n\nol,\nul {\n  margin: 0px;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  -webkit-appearance: none;\n  outline: none;\n  border-radius: 0;\n  background-color: transparent;\n}\n\ninput,\ntextarea {\n  background: transparent;\n  border: none;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus,\nbutton:focus,\na:focus {\n  outline: none;\n}\n\na {\n  color: inherit;\n  cursor: pointer;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\nh1,\nh2,\nh3,\nh4 {\n  line-height: 1.4;\n}\n\np {\n  line-height: 1.6;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.slick-slider.reverse {\n  transform: rotate(180deg);\n}\n\n.slick-slider.reverse .slick-slide {\n  transform: rotate(180deg);\n}\n\n.hidden-lg {\n  @include mq(desktop) {\n    display: none !important;\n  }\n}\n\n.hidden-xs {\n  @include mq(mobile) {\n    display: none !important;\n  }\n}\n\n.hidden-md {\n  @include mq(tab) {\n    display: none !important;\n  }\n}\n\n.img-responsive {\n  width: 100%;\n  height: auto;\n}\n\n.container {\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 90%;\n  // padding: 0 15px;\n\n  @include mq(tab) {\n    max-width: 768px;\n  }\n\n  @include mq(mobile) {\n    width: 100%;\n    padding: 0 20px;\n  }\n}\n\n/* MAIN CSS */\n$hero_color: #6a69f1;\n$header-text-color: transparent;\n\nmain {\n  position: relative;\n}\n\nbody {\n  scroll-behavior: smooth;\n}\n\n.dark-footer {\n  background-color: black;\n  color: white;\n}\n.white-footer {\n  background-color: white;\n  color: black;\n}\n\n//\n\n/* Header styles */\n.header {\n  padding: 16px 0px;\n  position: fixed;\n  top: 0px;\n  left: 50%;\n  /* position the left edge of the element at the middle of the parent */\n\n  transform: translate(-50%, 0);\n  z-index: 100;\n  width: 100%;\n\n  background-color: transparent;\n  transition: all 0.3s ease;\n  @include mq(mobile) {\n    padding: 10px 0;\n  }\n}\n\n.header-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  @include mq(mobile) {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n}\n\n.logo img {\n  width: 140px;\n  @include mq(mobile) {\n    width: 130px;\n    /* Adjust according to your logo size */\n  }\n}\n\n/* Desktop nav styles */\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  @include mq(mobile) {\n    width: 100%;\n    position: absolute;\n    top: -100vh;\n    left: 0;\n    background-color: rgb(233, 228, 228);\n    display: flex;\n    flex-direction: column;\n  }\n  .wrap-links {\n    @include mq(mobile) {\n      padding-top: 80px;\n      padding-bottom: 80px;\n      width: 100%;\n      height: 100vh;\n      background-color: white;\n    }\n  }\n\n  ul {\n    display: flex;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    gap: 52px;\n    @include mq(mobile) {\n      flex-direction: column;\n      align-items: center;\n      gap: 20px;\n    }\n\n    li {\n      a {\n        transition: all 0.3s ease;\n      }\n      @include mq(mobile) {\n        a {\n          line-height: 1.4;\n          font-size: 26px;\n          font-family: $roman;\n        }\n        margin: 0;\n      }\n    }\n  }\n}\n\n/* Mobile nav styles */\n\n.menu-icon {\n  display: none;\n  cursor: pointer;\n  @include mq(mobile) {\n    position: relative;\n    z-index: 20000;\n  }\n}\n\n.hamburger {\n  width: 30px;\n  height: 21px;\n  position: relative;\n}\n\n.hamburger span {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: #000;\n  margin-bottom: 6px;\n  transition: transform 0.3s, opacity 0.3s;\n}\n\n.hamburger.open span:nth-child(1) {\n  transform: translateY(8px) rotate(45deg);\n}\n\n.hamburger.open span:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger.open span:nth-child(3) {\n  transform: translateY(-8px) rotate(-45deg);\n}\n\n/* Sliding menu styles */\n\n// .nav-links ul li a {\n//   color: #000;\n//   font-size: 18px;\n// }\n\n@keyframes italicAnimation {\n  0% {\n    font-variation-settings: \"ital\" 12;\n  }\n  100% {\n    font-variation-settings: \"ital\" 0;\n  }\n}\nli {\n  // margin-right: 32px;\n\n  // display: flex;\n  // min-width: 85px;\n  text-align: right;\n  @include mq(mobile) {\n    min-width: unset;\n  }\n\n  a {\n    // color: $header-text-color;\n    text-decoration: none;\n    font-family: $roman;\n    color: black;\n    font-size: 18px;\n    transition: all 0.3s ease;\n    display: block;\n    // transform: none;\n    // // min-width: 75px;\n    // // width: clamp(fit-content, fit-content + 10px);\n    // transition: 0.2s;\n    // transition: transform 0.3s, font-style 0.3s;\n    // letter-spacing: 0.3px;\n    // // margin-right: 33px;\n    // animation-duration: 0.5s;\n    // animation-iteration-count: 1;\n    // animation-fill-mode: forwards;\n    transition: transform 0.2s ease;\n    &:hover {\n      //text-decoration: underline;\n      // color: white;\n      // font-family: $romanItalic;\n      // transform: none;\n      // letter-spacing: 0.3px;\n      // transform: skewX(-10deg);\n      // font-variation-settings: \"slnt\" -10;\n      // margin-left: -2px;\n      transform: skew(-15deg);\n    }\n  }\n  a:not(:hover) {\n    animation-name: italics-animation-reverse;\n  }\n}\nli:last-child {\n  margin-right: 0;\n}\n\n/* Media query for mobile */\n@media (max-width: 768px) {\n  .nav-links {\n    // display: none;\n    text-align: center;\n  }\n\n  .menu-icon {\n    display: block;\n  }\n}\n//\n//\n\n.header.scroll-top {\n  background: white;\n  .header-wrapper {\n    .nav-links {\n      ul li {\n        a {\n          &:hover {\n            color: $Blue;\n          }\n        }\n      }\n    }\n  }\n}\n\n#hero {\n  // background-image: url('../images/hero_bg.png');\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 100vh;\n  width: 100vw;\n  position: relative;\n  overflow: hidden;\n\n  @include flexbox();\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  @include mq(mobile) {\n    padding-top: 160px;\n    padding-bottom: 100px;\n    height: auto;\n  }\n  .headings {\n    .top-copy-container {\n      p {\n        color: white;\n        // mix-blend-mode: exclusion;\n      }\n    }\n    .head-copy-container {\n      h1 {\n        color: white;\n        // mix-blend-mode: exclusion;\n      }\n    }\n\n    p {\n      font-family: $light;\n      text-align: center;\n      font-size: 100px;\n      line-height: 1;\n      text-transform: lowercase;\n\n      @include mq(mobile) {\n        font-size: 40px;\n        line-height: 1.1;\n      }\n      @include mq(tab) {\n        font-size: 70px;\n      }\n    }\n\n    h1 {\n      font-family: $light;\n      text-align: center;\n      font-size: 200px;\n      line-height: 1;\n      text-transform: lowercase;\n\n      @include mq(mobile) {\n        font-size: 60px;\n      }\n      @include mq(tab) {\n        font-size: 140px;\n      }\n    }\n\n    .bottom-copy {\n      margin-top: 2rem;\n      font-family: $roman;\n      font-size: 20px;\n      z-index: 10;\n      text-align: center;\n      color: black;\n      @include mq(mobile) {\n        text-align: center;\n\n        margin-top: 20px;\n        font-size: 13px;\n      }\n      @include mq(tab) {\n        font-size: 26px;\n      }\n    }\n  }\n\n  .top-copy-container,\n  .bottom-copy-container,\n  .head-copy-container {\n    // overflow: hidden;\n    @include flexbox();\n    align-items: center;\n    justify-content: center;\n    line-height: 100%;\n  }\n}\n\n.image-at-cursor {\n  position: absolute;\n  pointer-events: none;\n  z-index: 1000;\n  transition: transform 0.3s ease;\n}\n\n#about {\n  // padding: 6rem 0;\n\n  padding-top: 20px;\n\n  @include mq(mobile) {\n    padding-bottom: 0;\n    padding-top: 70px;\n  }\n\n  .about-wrapper {\n    display: flex;\n    flex-direction: column;\n    // gap: 14rem;\n    position: relative;\n\n    @include mq(mobile) {\n      gap: 180px;\n      gap: 2rem;\n    }\n    .top-img-wrap {\n      // display: flex;\n      // justify-content: space-between;\n      // align-items: center;\n\n      .about-image {\n        padding: 15px;\n        // width: 430px;\n        // height: 298px;\n        // overflow: hidden;\n        // display: flex;\n        // justify-content: space-between;\n        // align-items: flex-start;\n\n        @include mq(mobile) {\n          padding: 0;\n          // max-width: 200px;\n          // height: 130px;\n          // border-radius: 10px;\n          // padding: 10px;\n        }\n        @include mq(tab) {\n          width: 350px;\n          height: 240px;\n        }\n\n        img {\n          object-fit: cover;\n        }\n        p {\n          background-color: white;\n          border-radius: 20px;\n          padding: 0px 10px;\n          font-family: $roman;\n          font-size: 14px;\n\n          @include mq(mobile) {\n            font-size: 10px;\n            line-height: 100%;\n            padding: 3px 10px;\n            font-size: 10px;\n            line-height: 100%;\n            padding: 3px 0px;\n          }\n        }\n      }\n\n      .intro {\n        max-width: 500px;\n        font-family: $roman;\n        font-size: 1.5rem;\n        line-height: 1.25;\n\n        @include mq(mobile) {\n          font-size: 1rem;\n        }\n      }\n    }\n\n    .about-image {\n      // max-width: 430px;\n      // height: 298px;\n      border-radius: 30px;\n      // display: flex;\n      // justify-content: flex-start;\n      // align-items: flex-start;\n\n      .img-wrap {\n        position: relative;\n\n        .black-overlay {\n          background: linear-gradient(\n            0deg,\n            rgb(0 0 0 / 80%) 0%,\n            rgba(0, 0, 0, 0) 100%\n          );\n          position: absolute;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          height: 40%;\n          // border-bottom-left-radius: 15px;\n          // border-bottom-right-radius: 15px;\n          padding: 10px;\n          @include mq(mobile) {\n            border-bottom-left-radius: 10px;\n            border-bottom-right-radius: 10px;\n          }\n        }\n        .copy-below {\n          position: absolute;\n          bottom: 15px;\n          right: 10px;\n          color: white;\n\n          @include mq(mobile) {\n            bottom: 5px;\n            right: 10px;\n          }\n        }\n      }\n\n      @include mq(mobile) {\n        // flex-direction: column;\n        border-radius: 10px;\n      }\n\n      img {\n        object-fit: cover;\n        // border-radius: 15px;\n        @include mq(mobile) {\n          // border-radius: 10px;\n        }\n      }\n\n      &.about-image-top {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        flex-direction: column;\n\n        @include mq(mobile) {\n          // background-size: cover;\n          // position: static;\n          max-width: 200px;\n        }\n        img {\n          margin-bottom: 0px;\n          @include mq(mobile) {\n            margin-bottom: 0px;\n          }\n        }\n        p {\n          background-color: unset;\n        }\n        .copy-below {\n          font-size: 20px;\n          font-family: $roman;\n          line-height: 1.2;\n          left: 10px;\n          @include mq(mobile) {\n            font-size: 14px;\n          }\n        }\n      }\n\n      &.about-image-center {\n        // max-width: 400px;\n        // padding: 15px;\n        // width: 430px;\n        // height: 298px;\n        // position: absolute;\n        // right: 0px;\n        // top: 230px;\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        flex-direction: column;\n        align-self: flex-end;\n        justify-content: flex-end;\n        align-items: flex-end;\n        @include mq(mobile) {\n          flex-direction: column;\n        }\n\n        img {\n          // width: 100%;\n        }\n\n        p {\n          // background-color: white;\n          border-radius: 20px;\n          padding: 0px 10px;\n          font-family: $roman;\n          font-size: 14px;\n          max-width: fit-content;\n\n          @include mq(mobile) {\n            font-size: 10px;\n            font-size: 10px;\n            line-height: 100%;\n            padding: 0px;\n          }\n        }\n\n        .copy-below {\n          font-size: 20px;\n          font-family: $roman;\n          line-height: 1.2;\n          @include mq(mobile) {\n            font-size: 14px;\n          }\n        }\n\n        @include mq(mobile) {\n          align-self: flex-end;\n          position: static;\n          max-width: 200px;\n          // height: 130px;\n          padding: 0px;\n          // border-radius: 10px;\n          background-size: cover;\n          margin-top: -10px;\n          display: flex;\n          justify-content: flex-end;\n          align-items: flex-end;\n        }\n        @include mq(tab) {\n          width: 350px;\n          height: 240px;\n        }\n      }\n\n      &.about-image-bottom {\n        padding: 15px;\n        // width: 430px;\n        // height: 298px;\n        // border-radius: 30px;\n        // display: flex;\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        flex-direction: column;\n\n        @include mq(mobile) {\n          // flex-direction: column;\n        }\n\n        img {\n          object-fit: cover;\n        }\n\n        @include mq(mobile) {\n          // max-width: 200px;\n          // height: 130px;\n          // border-radius: 10px;\n          // padding: 10px;\n          // background-size: cover;\n          // position: static;\n          width: 200px;\n          padding: 0;\n          margin-top: -10px;\n        }\n        @include mq(tab) {\n          width: 350px;\n          height: 240px;\n        }\n\n        p {\n          // background-color: white;\n          border-radius: 20px;\n          padding: 0px 10px;\n          font-family: $roman;\n          font-size: 14px;\n\n          @include mq(mobile) {\n            font-size: 10px;\n            font-size: 10px;\n            line-height: 100%;\n            padding: 0px;\n          }\n        }\n        .copy-below {\n          font-size: 20px;\n          font-family: $roman;\n          line-height: 1.2;\n          left: 10px;\n\n          @include mq(mobile) {\n            font-size: 14px;\n          }\n        }\n      }\n\n      p {\n        @include mq(desktop) {\n          // display: none;\n        }\n      }\n    }\n\n    .center-copy {\n      width: 100%;\n      position: absolute;\n      top: 50%;\n      /* position the top  edge of the element at the middle of the parent */\n      left: 50%;\n      /* position the left edge of the element at the middle of the parent */\n\n      transform: translate(-50%, -50%);\n      font-family: $light;\n      font-size: 100px;\n      z-index: 50;\n      line-height: 1;\n      color: white;\n      // mix-blend-mode: exclusion;\n      will-change: transform;\n      -webkit-font-smoothing: antialiased;\n      text-align: center;\n\n      @include mq(mobile) {\n        font-size: 34px;\n        position: static;\n        transform: unset;\n        font-family: $roman;\n        margin-bottom: 0px;\n        font-size: 40px;\n      }\n      @include mq(tab) {\n        font-size: 60px;\n      }\n    }\n  }\n}\n\n.back-constant {\n  background-position: top;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n#work {\n  // padding: 6rem 0;\n  padding: 120px 0;\n\n  // padding-top: 40px;\n  // padding-bottom: 40px;\n\n  @include mq(mobile) {\n    padding: 40px 0;\n    padding-top: 80px;\n    // padding-bottom: 40px;\n  }\n\n  .work-copy {\n    max-width: 100%;\n    // display: flex;\n\n    // margin-bottom: 40px;\n\n    @include mq(mobile) {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0;\n    }\n\n    h3 {\n      font-size: 100px;\n      font-family: $roman;\n      line-height: 100%;\n      color: white;\n      // mix-blend-mode: exclusion;\n\n      @include mq(mobile) {\n        font-size: 34px;\n        font-family: $roman;\n      }\n      @include mq(tab) {\n        font-size: 60px;\n      }\n    }\n\n    p {\n      font-size: 1rem;\n      font-family: $roman;\n      line-height: 1.4;\n      font-size: 18px;\n\n      @include mq(mobile) {\n        font-size: 15px;\n      }\n    }\n  }\n\n  .sliders-wrap {\n    z-index: 7;\n    position: relative;\n    display: flex;\n    gap: 90px;\n    flex-direction: column;\n\n    @include mq(mobile) {\n      gap: 3rem;\n    }\n    @include mq(tab) {\n      gap: 80px;\n    }\n\n    .work-slider-top {\n      max-width: 100%;\n\n      .slick-slider {\n        .slick-prev {\n          display: none;\n        }\n\n        .slick-next {\n          display: none;\n        }\n\n        .slick-list {\n        }\n      }\n\n      .card-item {\n        width: 360px;\n        height: 250px;\n        margin: 0 80px;\n        overflow: hidden;\n        border-radius: 10px;\n        position: relative;\n        display: flex;\n        justify-content: end;\n        align-items: flex-start;\n        padding: 10px;\n        background-size: cover;\n        background-position: center;\n        background-repeat: no-repeat;\n        //\n        justify-content: flex-start;\n        align-items: flex-end;\n        // 29july\n\n        @include mq(mobile) {\n          margin: 0 30px;\n          padding: 10px;\n          width: 90%;\n          height: 150px;\n          background-size: cover;\n        }\n        @include mq(tab) {\n          width: 320px;\n          height: 220px;\n        }\n\n        img {\n          object-fit: cover;\n          display: block;\n        }\n\n        p {\n          // background-color: rgb(0, 0, 0);\n          line-height: 1.2;\n          padding: 1px 10px;\n          border-radius: 20px;\n          font-family: $roman;\n          color: white;\n          font-size: 22px;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n\n        &.card-1 {\n          background-image: url(\"../images/social.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-2 {\n          background-image: url(\"../images/video.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-3 {\n          background-image: url(\"../images/games2.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-4 {\n          background-image: url(\"../images/ads2.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n      }\n    }\n\n    .work-slider-bottom {\n      max-width: 100%;\n\n      .slick-slider {\n        .slick-prev {\n          display: none;\n        }\n\n        .slick-next {\n          display: none;\n        }\n        .slick-slide {\n          @include mq(mobile) {\n            // margin-right: 15px;\n            // margin-left: 15px;\n          }\n        }\n      }\n\n      .card-item {\n        width: 360px;\n        height: 250px;\n        margin: 0 80px;\n        overflow: hidden;\n        border-radius: 10px;\n        position: relative;\n        display: flex;\n        justify-content: end;\n        align-items: flex-start;\n        padding: 10px;\n\n        justify-content: flex-start;\n        align-items: flex-end;\n\n        @include mq(mobile) {\n          margin: 0 10px;\n          width: 90%;\n          height: 150px;\n          background-size: cover;\n          padding: 10px;\n        }\n        @include mq(tab) {\n          width: 320px;\n          height: 220px;\n        }\n\n        img {\n          object-fit: cover;\n          display: block;\n        }\n\n        p {\n          // background-color: white;\n          line-height: 1.2;\n          padding: 1px 10px;\n          border-radius: 20px;\n          font-family: $roman;\n          // 29july\n          color: white;\n          font-size: 22px;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n\n        &.card-1 {\n          background-image: url(\"../images/web.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n\n          p {\n            background-color: white;\n            line-height: 1.2;\n            padding: 0px 10px;\n            border-radius: 8px;\n          }\n        }\n\n        &.card-2 {\n          background-image: url(\"../images/metaverse.png\");\n          background-color: rgb(100, 98, 124);\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-3 {\n          background-image: url(\"../images/ads.png\");\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n\n        &.card-4 {\n          background-image: url(\"../images/animation-&-motion-graphics.png\");\n          background-color: rgb(100, 98, 124);\n\n          background-position: top;\n          background-size: cover;\n          background-repeat: no-repeat;\n        }\n      }\n    }\n\n    .work_heading {\n      position: absolute;\n      font-size: 11rem;\n      font-family: $roman;\n      top: 50%;\n      /* position the top  edge of the element at the middle of the parent */\n      left: 50%;\n      /* position the left edge of the element at the middle of the parent */\n\n      transform: translate(-50%, -50%);\n      //z-index: -1;\n\n      // mix-blend-mode: exclusion;\n      color: white;\n      z-index: 1;\n\n      @include mq(mobile) {\n        font-size: 3rem;\n      }\n    }\n  }\n}\n\n#team {\n  // padding: 100px 0;\n  pointer-events: none;\n\n  position: relative;\n  // padding-top: 40px;\n  @include mq(mobile) {\n    // padding-top: 0;\n    // padding: 40px;\n    padding: 0px 0;\n    // padding-bottom: 50px;\n    // margin-bottom: 50px;\n  }\n\n  .team-slider {\n    // padding-top: 40px;\n    // padding-bottom: 40px;\n    z-index: 10;\n\n    @include mq(mobile) {\n      // padding-top: 20px;\n      padding: 0;\n      // padding-bottom: 20px;\n    }\n\n    .slick-slider {\n      .slick-prev {\n        display: none;\n      }\n\n      .slick-next {\n        display: none;\n      }\n    }\n\n    .slick-slide {\n      padding: 0 20px;\n\n      img {\n        // border-radius: 15px;\n      }\n      @include mq(mobile) {\n        padding: 0 15px;\n      }\n    }\n\n    .team-card {\n      background-position: center;\n      background-size: cover;\n      background-repeat: no-repeat;\n      display: flex;\n\n      justify-content: flex-start;\n      align-items: flex-end;\n      // padding: 10px;\n      border-radius: 15px;\n      // height: 350px;\n      position: relative;\n      @include mq(mobile) {\n        // height: 210px;\n      }\n\n      .black-overlay {\n        background: linear-gradient(\n          0deg,\n          rgb(0 0 0 / 80%) 0%,\n          rgba(0, 0, 0, 0) 100%\n        );\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        height: 40%;\n        // border-bottom-left-radius: 15px;\n        // border-bottom-right-radius: 15px;\n        padding: 10px;\n      }\n\n      .team-name {\n        position: absolute;\n        margin-bottom: 15px;\n        margin-left: 15px;\n      }\n\n      p {\n        color: white;\n        font-size: 19px;\n        font-family: $roman;\n        line-height: 1;\n        @include mq(mobile) {\n          font-size: 16px;\n        }\n      }\n\n      &.team-card-0 {\n        width: 130px;\n        height: 350px;\n        background-image: url(\"../images/Rikki.jpg\");\n      }\n\n      &.team-card-1 {\n        width: 130px;\n        height: 350px;\n        background-image: url(\"../images/Dia.jpg\");\n      }\n\n      &.team-card-2 {\n        width: 150px;\n        height: 400px;\n        background-image: url(\"../images/Dooj.jpg\");\n      }\n\n      &.team-card-3 {\n        width: 130px;\n        height: 350px;\n        background-image: url(\"../images/Khushboo.jpg\");\n      }\n\n      &.team-card-4 {\n        width: 110px;\n        height: 400px;\n        background-image: url(\"../images/Michell.jpg\");\n      }\n\n      &.team-card-5 {\n        width: 140px;\n        height: 350px;\n        background-image: url(\"../images/Prerna.jpg\");\n      }\n\n      &.team-card-6 {\n        width: 140px;\n        height: 400px;\n        background-image: url(\"../images/Dia.jpg\");\n      }\n\n      &.team-card-7 {\n        width: 200px;\n        height: 500px;\n        background-image: url(\"../images/Dooj.jpg\");\n      }\n\n      &.team-card-8 {\n        width: 120px;\n        height: 400px;\n        background-image: url(\"../images/Khushboo.jpg\");\n      }\n\n      &.team-card-9 {\n        width: 140px;\n        height: 400px;\n        background-image: url(\"../images/Michell.jpg\");\n      }\n\n      &.team-card-10 {\n        width: 130px;\n        height: 400px;\n        background-image: url(\"../images/Prerna.jpg\");\n      }\n\n      &.team-card-11 {\n        width: 120px;\n        height: 400px;\n        background-image: url(\"../images/Rikki.jpg\");\n      }\n    }\n\n    .m-50 {\n      margin-top: 50px;\n      @include mq(mobile) {\n        margin-top: 0px;\n      }\n    }\n\n    .m-100 {\n      margin-top: 100px;\n      @include mq(mobile) {\n        margin-top: 30px;\n      }\n    }\n\n    .m-150 {\n      margin-top: 150px;\n      @include mq(mobile) {\n        margin-top: 120px;\n      }\n    }\n\n    .m-200 {\n      margin-top: 200px;\n      @include mq(mobile) {\n        margin-top: 140px;\n      }\n    }\n  }\n\n  .designation {\n    margin-top: 6px;\n    font-size: 13px !important;\n    @include mq(mobile) {\n      font-size: 10px !important;\n    }\n  }\n\n  .overlapped-copy-top {\n    font-size: 100px;\n    font-family: $light;\n    // position: absolute;\n    top: 0rem;\n    left: 200px;\n    line-height: 100%;\n    // mix-blend-mode: exclusion;\n    color: white;\n    z-index: 10;\n\n    @include mq(mobile) {\n      left: 20px;\n      top: 4rem;\n\n      font-size: 34px;\n      // top: 40px;\n      font-family: $roman;\n      font-size: 40px;\n    }\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n\n  .overlapped-copy-bottom {\n    font-size: 100px;\n    font-family: $light;\n    // position: absolute;\n    bottom: -4rem;\n    right: 200px;\n    text-align: right;\n    line-height: 100%;\n    // mix-blend-mode: exclusion;\n    color: white;\n\n    @include mq(mobile) {\n      right: 20px;\n      font-size: 2rem;\n      bottom: 0rem;\n      font-family: $roman;\n      font-size: 40px;\n    }\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n}\n\n.zIndex-box {\n  display: none;\n\n  @include mq(mobile) {\n    display: block;\n    width: 100%;\n    position: fixed;\n    //height: 120vh;\n    top: 0;\n    left: 0;\n    bottom: -20%;\n    right: 0;\n    z-index: -1;\n    background-image: url(\"../images/Mobile-BG.jpg\");\n    background-repeat: repeat-y;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n  }\n}\n\n.home-page {\n  background-image: url(\"../images/hero_bg.png\");\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n\n  @include mq(mobile) {\n    background-image: unset;\n    //background-repeat: repeat-y;\n    &:before {\n      @include mq(mobile) {\n        content: \"\";\n        display: block;\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        z-index: -10;\n        // background: url(\"../images/Mobile-BG.jpg\") no-repeat center center;\n        -webkit-background-size: cover;\n        -moz-background-size: cover;\n        -o-background-size: cover;\n        background-size: cover;\n      }\n    }\n  }\n}\n.home-page-all {\n  background-image: url(\"../images/hero_bg.png\");\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  @include mq(mobile) {\n    // background-image: url(\"../images/Mobile-BG.jpg\");\n    // background-repeat: repeat;\n  }\n}\n.work-page {\n  background-image: url(\"../images/hero_bg.png\");\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  @include mq(mobile) {\n    background-image: url(\"../images/Mobile-BG.jpg\");\n    background-repeat: repeat;\n  }\n}\n\n#awards {\n  // padding: 6rem 0;\n  padding: 135px 0;\n\n  // padding-top: 10rem;Updated\n\n  @include mq(mobile) {\n    padding: 0;\n    padding: 80px 0;\n  }\n\n  .awards-heading {\n    font-family: $light;\n    font-size: 100px;\n    text-align: center;\n    margin-bottom: 4rem;\n    color: white;\n    // mix-blend-mode: exclusion;\n    line-height: 1;\n\n    @include mq(mobile) {\n      font-size: 34px;\n      margin-bottom: 2rem;\n      font-family: $roman;\n\n      font-size: 40px;\n      margin-bottom: 2rem;\n      font-family: \"Neue Haas Grotesk Display Pro Roman\";\n      line-height: 1;\n    }\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n\n  .awards-wrapper {\n    max-width: 900px;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5rem;\n\n    .custom-tooltip {\n      background-color: red;\n      color: #fff;\n      padding: 10px;\n      border-radius: 5px;\n      font-size: 14px;\n      // box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n    }\n\n    .custom-tooltip-arrow {\n      color: #333; /* Matches the background color of the tooltip */\n    }\n\n    .slick-slide {\n      padding: 0 40px;\n      @include mq(mobile) {\n        padding: 0 20px;\n      }\n    }\n\n    @include mq(mobile) {\n      max-width: unset;\n      gap: 20px;\n    }\n    #tooltip {\n      font-family: $medium;\n    }\n\n    .tooltip {\n      // position: relative;\n      // display: inline-block;\n      // // border-bottom: 1px dotted black;\n      // display: flex;\n      // flex-direction: column-reverse;\n      // align-items: flex-end;\n      max-width: 83px;\n\n      p {\n        font-family: $medium;\n        margin-top: 10px;\n        text-align: center;\n        @include mq(mobile) {\n          margin-top: 12px;\n\n          font-size: 12px;\n        }\n      }\n    }\n\n    .tooltip .tooltiptext {\n      visibility: hidden;\n      width: fit-content;\n      white-space: nowrap;\n      background-color: black;\n      color: #fff;\n      text-align: center;\n      border-radius: 6px;\n      padding: 5px 5px;\n      bottom: 120%;\n      left: 50%;\n      /* margin-left: -60px; */\n      font-family: $roman;\n      font-size: 14px;\n      transform: translate(-50%, 0%);\n      /* Position the tooltip */\n      position: absolute;\n      z-index: 1;\n    }\n\n    .tooltip:hover .tooltiptext {\n      visibility: visible;\n    }\n  }\n\n  .award-slider {\n    .slick-track {\n      display: flex;\n      padding: 0 10px;\n    }\n  }\n}\n\n#offices {\n  // padding: 6rem 0;\n  // padding: 80px 0;\n  padding-bottom: 120px;\n\n  // .adr-slider-mobile {\n  //   display: none;\n  //   @include mq(mobile) {\n  //     display: block;\n  //   }\n  // }\n\n  @include mq(mobile) {\n    // padding-top: 0;\n    padding: 0px 0;\n    padding-bottom: 50px;\n  }\n\n  .offices-heading {\n    max-width: 900px;\n    font-family: $light;\n    font-size: 100px;\n    line-height: 1;\n    margin-bottom: 4rem;\n    color: white;\n    // mix-blend-mode: exclusion;\n    // text-align: ;\n\n    @include mq(mobile) {\n      margin-bottom: 2rem;\n      font-size: 34px;\n      font-family: $roman;\n      line-height: 1;\n      font-size: 40px;\n      text-align: start;\n      // padding: 0;\n    }\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n\n  .card-wrapper {\n    max-width: 900px;\n    display: flex;\n    justify-content: center;\n    gap: 4rem;\n\n    @include mq(mobile) {\n      flex-direction: column;\n      gap: 30px;\n      padding: 0 70px;\n    }\n\n    .card {\n      background-color: #ffffff91;\n      padding: 30px;\n      // border-radius: 10px;\n      flex: 1 1 0px;\n\n      .city {\n        font-size: 2.5rem;\n        margin-bottom: 1.2rem;\n        font-family: $roman;\n        @include mq(mobile) {\n          font-size: 26px;\n          margin-bottom: 10px;\n        }\n      }\n\n      .adj {\n        font-family: $roman;\n        border-bottom: 1px solid black;\n        line-height: 1;\n        max-width: fit-content;\n        margin-bottom: 10px;\n\n        &.adj1 {\n          border-bottom: none;\n          line-height: 1.3;\n          margin-bottom: 3px;\n        }\n\n        @include mq(mobile) {\n          font-size: 12px;\n          &.adj1 {\n            font-size: 14px;\n          }\n        }\n      }\n\n      .location {\n        font-family: $roman;\n        font-size: 21px;\n        line-height: 1;\n        margin-bottom: 10px;\n        @include mq(mobile) {\n          font-size: 17px;\n        }\n      }\n\n      .our-location {\n        // font-size: 10px;\n        font-family: $roman;\n        border-bottom: 1px solid black;\n        line-height: 1;\n        max-width: fit-content;\n        margin-bottom: 0.5rem;\n\n        &.hgb {\n          border-bottom: none;\n        }\n      }\n\n      // .adr {\n      //   font-family: $roman;\n      //   font-weight: 500;\n      //   font-size: 17px;\n      //   line-height: 1.1;\n      //   margin-bottom: 2rem;\n      // }\n\n      .lets {\n        font-family: $roman;\n        border-bottom: 1px solid black;\n        line-height: 1;\n        max-width: fit-content;\n        margin-bottom: 0.5rem;\n      }\n\n      .name {\n        font-family: $roman;\n        font-size: 21px;\n        line-height: 1;\n        margin-bottom: 1.4rem;\n      }\n\n      .post {\n        line-height: 1;\n        font-size: 1.2rem;\n        font-family: $roman;\n        margin-bottom: 5px;\n      }\n\n      .email {\n        font-family: $roman;\n        line-height: 80%;\n      }\n    }\n  }\n\n  .adr-slider-mobile {\n    display: none;\n    @include mq(mobile) {\n      display: block;\n      // padding: 0 70px;\n      .slick-list {\n        padding: 0 50px; /* Optional: Adjust padding to control visibility of side slides */\n      }\n      .slick-track {\n        display: flex;\n      }\n\n      .slick-slide {\n        margin: 0 20px;\n        max-width: 300px;\n        transform: translateZ(0);\n      }\n      .swiper-wrapper {\n        display: flex;\n      }\n\n      .card {\n        background-color: #ffffff91;\n        padding: 30px;\n        // border-radius: 10px;\n        flex: 1 1 0px;\n        height: 290px;\n        margin: 0 20px;\n        .city {\n          font-size: 2.5rem;\n          margin-bottom: 1.2rem;\n          font-family: $roman;\n          @include mq(mobile) {\n            font-size: 26px;\n            margin-bottom: 10px;\n          }\n        }\n\n        .adj {\n          font-family: $roman;\n          border-bottom: 1px solid black;\n          line-height: 1;\n          max-width: fit-content;\n          margin-bottom: 10px;\n\n          &.adj1 {\n            border-bottom: none;\n            line-height: 1.3;\n            margin-bottom: 3px;\n          }\n\n          @include mq(mobile) {\n            font-size: 12px;\n            &.adj1 {\n              font-size: 14px;\n            }\n          }\n        }\n\n        .location {\n          font-family: $roman;\n          font-size: 21px;\n          line-height: 1;\n          margin-bottom: 10px;\n          @include mq(mobile) {\n            font-size: 17px;\n          }\n        }\n\n        .our-location {\n          // font-size: 10px;\n          font-family: $roman;\n          border-bottom: 1px solid black;\n          line-height: 1;\n          max-width: fit-content;\n          margin-bottom: 0.5rem;\n\n          &.hgb {\n            border-bottom: none;\n          }\n        }\n\n        // .adr {\n        //   font-family: $roman;\n        //   font-weight: 500;\n        //   font-size: 17px;\n        //   line-height: 1.1;\n        //   margin-bottom: 2rem;\n        // }\n\n        .lets {\n          font-family: $roman;\n          border-bottom: 1px solid black;\n          line-height: 1;\n          max-width: fit-content;\n          margin-bottom: 0.5rem;\n        }\n\n        .name {\n          font-family: $roman;\n          font-size: 21px;\n          line-height: 1;\n          margin-bottom: 1.4rem;\n        }\n\n        .post {\n          line-height: 1;\n          font-size: 1.2rem;\n          font-family: $roman;\n          margin-bottom: 5px;\n        }\n\n        .email {\n          font-family: $roman;\n          line-height: 80%;\n        }\n      }\n    }\n  }\n}\n\n#news {\n  // padding: 6rem 0;\n  padding-top: 200px;\n  padding-bottom: 60px;\n\n  .news-heading {\n    font-size: 180px;\n    font-family: $roman;\n    line-height: 100%;\n    // color: white;\n    text-transform: uppercase;\n    line-height: 0.8;\n    padding-bottom: 10px;\n    margin-left: -5px;\n    @include mq(mobile) {\n      line-height: 1.4;\n    }\n    @include mq(tab) {\n      font-size: 100px;\n    }\n    @include mq(desktop) {\n      font-size: 140px;\n    }\n  }\n\n  .news-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n\n    @include mq(mobile) {\n      flex-direction: column;\n      gap: 20px;\n    }\n    .filter-wrapper {\n      display: flex;\n      align-items: center;\n      gap: 1.5rem;\n      align-self: flex-end;\n      .label {\n        font-family: $roman;\n      }\n      @include mq(mobile) {\n        gap: 10px;\n        span {\n          font-size: 14px;\n        }\n      }\n      .select-div {\n        border: 1px black solid;\n        border-radius: 50px;\n        padding: 4px 20px;\n        // padding-left: 15px;\n        display: flex;\n        align-items: center;\n        gap: 2rem;\n        @include mq(mobile) {\n          padding: 4px 14px;\n          display: flex;\n          align-items: center;\n          gap: 10px;\n        }\n        select {\n          text-transform: capitalize;\n          border: none;\n          font-size: 20px;\n          font-family: $roman;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n\n    &.news-one {\n      display: flex;\n      flex-direction: column;\n      // gap: 30px;\n      padding: 20px 0;\n      padding-top: 17px;\n      @include mq(mobile) {\n        padding-top: 14px;\n        padding-bottom: 40px;\n      }\n      .news-individual {\n        padding-top: 60px;\n        padding-bottom: 60px;\n        border-top: black 1px solid;\n        display: flex;\n        gap: 2rem;\n        transition: all 0.3s ease;\n        &:hover {\n          p.copy {\n            text-decoration: underline;\n          }\n        }\n\n        .news-image {\n          flex: 1;\n          overflow: hidden;\n          .news-img-class {\n            border-radius: 20px;\n            overflow: hidden;\n            width: 100%;\n          }\n          &.news-image-copy {\n            flex: 2;\n            display: flex;\n            align-items: flex-start;\n            flex-direction: column;\n            justify-content: space-between;\n            // padding: 20px 0;\n            @include mq(mobile) {\n              gap: 20px;\n            }\n            .award-copy-wrap {\n              display: flex;\n              flex-direction: column;\n              align-items: flex-start;\n              gap: 40px;\n              .award {\n                border: 1px black solid;\n                border-radius: 50px;\n                padding: 3px 20px;\n                // padding-left: 15px;\n                text-align: center;\n                font-family: $roman;\n                text-transform: capitalize;\n              }\n              .copy {\n                font-family: $roman;\n                font-size: 26px;\n                line-height: 1.4;\n              }\n\n              @include mq(mobile) {\n                gap: 20px;\n\n                .copy {\n                  font-size: 18px;\n                  line-height: 1.4;\n                }\n              }\n            }\n            .date {\n              font-family: $roman;\n              font-size: 18px;\n              line-height: 1.1;\n            }\n            @include mq(mobile) {\n              .date {\n                font-size: 16px;\n              }\n            }\n          }\n        }\n        @include mq(mobile) {\n          flex-direction: column;\n          gap: 20px;\n          padding-top: 40px;\n          padding-bottom: 20px;\n        }\n      }\n    }\n  }\n  .show-more {\n    text-align: center;\n    display: block;\n    text-decoration: underline;\n    font-family: $roman;\n  }\n\n  @include mq(mobile) {\n    padding-top: 140px;\n    padding-bottom: 0;\n    .news-heading {\n      font-size: 60px;\n      margin: 0;\n      padding: 0;\n    }\n  }\n}\n\n#initatives {\n  padding-top: 200px;\n  padding-bottom: 60px;\n  @include mq(mobile) {\n    padding-top: 140px;\n  }\n  .initatives-wrapper {\n    .initatives-flex {\n      display: flex;\n      flex-direction: column;\n\n      .flex-item {\n        display: flex;\n        justify-content: space-between;\n\n        &.flx-center {\n          align-items: center;\n        }\n        @include mq(mobile) {\n          flex-direction: column;\n          align-items: flex-start;\n          &.flx-center {\n            align-items: flex-start;\n          }\n        }\n        .it-copy {\n          font-size: 23px;\n          line-height: 1.4;\n          font-family: $roman;\n          @include mq(mobile) {\n            font-size: 22px;\n            line-height: 1.3;\n          }\n        }\n        .it-heading {\n          font-size: 180px;\n          font-family: $light;\n          line-height: 100%;\n          text-transform: lowercase;\n          // margin-bottom: 50px;\n          @include mq(mobile) {\n            font-size: 60px;\n            // margin-bottom: 20px;\n            line-height: 1.4;\n          }\n          @include mq(tab) {\n            font-size: 100px;\n            // margin-bottom: 20px;\n          }\n          @include mq(desktop) {\n            font-size: 140px;\n          }\n        }\n        &.flex-item-it {\n          // border-top: 1px black solid;\n          padding-top: 50px;\n          // display: flex;\n          // flex-wrap: wrap;\n          // justify-content: space-between;\n          gap: 20px;\n          row-gap: 40px;\n          min-height: 340px;\n\n          display: flex;\n          flex-direction: column;\n\n          @include mq(mobile) {\n            padding-top: 20px;\n            gap: 40px;\n          }\n          .it-card {\n            // flex-basis: calc(50% - 20px);\n            display: flex;\n            // flex-direction: column;\n            // gap: 20px;\n            background: rgba(255, 255, 255, 0.568627451);\n            // border-radius: 30px;\n            // border-bottom-left-radius: 15px;\n            // border-top-left-radius: 15px;\n            height: 380px;\n            overflow: hidden;\n            @include mq(mobile) {\n              flex: auto;\n              flex-direction: column;\n              height: unset;\n              // border-radius: 15px;\n            }\n\n            h3 {\n              font-family: $bold;\n              font-size: 35px;\n              margin-bottom: 0px;\n              @include mq(mobile) {\n                font-size: 24px;\n              }\n            }\n            p {\n              font-family: $roman;\n              font-size: 20px;\n              @include mq(mobile) {\n                font-size: 16px;\n              }\n            }\n            .img-wrap {\n              display: flex;\n              // border-radius: 30px;\n              overflow: hidden;\n              img {\n                flex: 1;\n              }\n              @include mq(mobile) {\n                border-radius: 20px;\n              }\n            }\n            .hover-image-container {\n              transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n              border-radius: 0;\n\n              flex: 70%;\n              margin-bottom: 0;\n              display: flex;\n              align-items: center;\n\n              @include mq(mobile) {\n                border-bottom-right-radius: 0;\n              }\n\n              @include mq(tab) {\n                align-items: unset;\n              }\n              img {\n                @include mq(desktop) {\n                  transition: all 0.2s ease-in-out;\n                }\n                @include mq(tab) {\n                  object-fit: cover;\n                }\n              }\n            }\n\n            &:hover .discr {\n              // animation: upToDown 0.45s;\n              // transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n            }\n            &:hover img {\n              transform: scale(1.02);\n            }\n\n            .hover-image-container:nth-child(even) {\n              border-radius: 0;\n              // border-top-right-radius: ;\n              // border-bottom-right-radius: 15px;\n              overflow: hidden;\n            }\n            .hover-image-container:nth-child(odd) {\n              // border-radius: 0;\n              // border-top-right-radius: 0;\n              // border-bottom-right-radius: 0;\n\n              // border-top-left-radius: 0px;\n              // border-bottom-left-radius: 0px;\n              overflow: hidden;\n              @include mq(mobile) {\n                border-bottom-left-radius: 0;\n              }\n            }\n\n            .copy-wrapper {\n              padding: 30px 40px;\n              flex: 30%;\n              display: flex;\n              flex-direction: column;\n              justify-content: space-between;\n              align-items: flex-start;\n              @include mq(mobile) {\n                padding: 20px 20px;\n                gap: 40px;\n                flex-direction: column;\n                align-items: flex-start;\n              }\n            }\n            .top-copy {\n              .tags-container {\n                font-size: 16px;\n                font-family: $roman;\n                // background-color: white;\n                border: 1px black solid;\n                padding: 5px 18px;\n                border-radius: 50px;\n                width: max-content;\n                color: black;\n                margin-bottom: 10px;\n                @include mq(mobile) {\n                  font-size: 14px;\n                  padding: 5px 15px;\n                  margin-bottom: 10px;\n                  width: max-content;\n                }\n              }\n              .tag {\n                background-color: black;\n                width: fit-content;\n                color: white;\n                padding: 3px 10px;\n                border-radius: 50px;\n                margin-bottom: 20px;\n              }\n              .copy-discription {\n                line-height: 1.25;\n                font-size: 17px;\n                @include mq(mobile) {\n                  text-overflow: ellipsis;\n                  // text-overflow: ellipsis;\n                  // overflow: hidden;\n                  // white-space: nowrap;\n                  font-size: 13px;\n                }\n              }\n\n              @include mq(mobile) {\n                flex: 1;\n              }\n            }\n            .more {\n              display: flex;\n              align-items: flex-end;\n              gap: 10px;\n              img {\n                transform: translate(\n                  -10px,\n                  10px\n                ); /* Move the arrow from bottom left */\n                opacity: 0; /* Start with the arrow hidden */\n                transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n              }\n\n              @include mq(mobile) {\n                gap: 5px;\n              }\n\n              p {\n                font-size: 16px;\n                // border-bottom: 1px solid black;\n                padding-bottom: 2px;\n                line-height: 1;\n                width: max-content;\n                position: relative;\n                @include mq(mobile) {\n                  font-size: 13px;\n                  flex: 2 0;\n                  width: max-content;\n                }\n              }\n              p::after {\n                content: \"\";\n                position: absolute;\n                width: 0;\n                height: 2px;\n                background: black;\n                left: 0;\n                bottom: -1px; /* Adjust to position underline closer to text */\n                transition: width 0.3s ease;\n              }\n\n              img {\n                width: 10px;\n                padding-bottom: 5px;\n\n                @include mq(mobile) {\n                  width: 7px;\n                }\n              }\n            }\n\n            &:hover {\n              .more {\n                img {\n                  transform: translate(\n                    0,\n                    0\n                  ); /* Move to original position and reset rotation */\n                  opacity: 1;\n                }\n                p::after {\n                  // width: 100%;\n                }\n              }\n            }\n          }\n          /* Apply flex-direction: row-reverse; to every second .it-card */\n          .it-card:nth-child(even) {\n            flex-direction: row-reverse;\n            // border-top-left-radius: 15px;\n            // border-bottom-left-radius: 15px;\n            // border-top-right-radius: 15px;\n            // border-bottom-right-radius: 15px;\n            overflow: hidden;\n            @include mq(mobile) {\n              flex-direction: column;\n            }\n          }\n          // .it-card:nth-child(odd) {\n          //   border-radius: 15px;\n          //   overflow: hidden;\n          // }\n        }\n      }\n    }\n  }\n}\n\n#contact-page {\n  padding-top: 200px;\n  padding-bottom: 60px;\n  @include mq(mobile) {\n    padding-top: 140px;\n  }\n\n  .contact-wrapper {\n    .world-contact-map {\n      display: flex;\n      flex-direction: column;\n      .heading-contact {\n        font-size: 100px;\n        font-family: $light;\n        line-height: 100%;\n        text-transform: lowercase;\n        margin-bottom: 50px;\n        text-align: center;\n        @include mq(mobile) {\n          font-size: 40px;\n        }\n        @include mq(tab) {\n          font-size: 60px;\n        }\n      }\n      .world-map {\n        width: 1180px;\n        margin: auto;\n      }\n      .info-card {\n        margin-top: 4rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: #ffffff91;\n        padding: 30px 30px;\n        // border-radius: 20px;\n        @include mq(mobile) {\n          flex-direction: column;\n          gap: 20px;\n          align-items: stretch;\n        }\n        .card-item {\n          flex: 1;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          flex-direction: column;\n          border-right: 1px solid black;\n          @include mq(mobile) {\n            border-bottom: 1px solid black;\n            border-right: none;\n            padding-bottom: 20px;\n            &:last-child {\n              border-bottom: none;\n            }\n          }\n          &:last-child {\n            border-right: none;\n          }\n          h4 {\n            font-family: $medium;\n            font-size: 24px;\n            margin-bottom: 5px;\n            @include mq(mobile) {\n              font-size: 20px;\n            }\n          }\n          a {\n            font-family: $roman;\n            font-size: 18px;\n            transition: all 0.2s ease;\n            @include mq(mobile) {\n              font-size: 14px;\n            }\n            &:hover {\n              color: $Blue;\n            }\n          }\n\n          @include mq(mobile) {\n            &:last-child {\n              padding-bottom: 0;\n            }\n          }\n        }\n      }\n    }\n    .our-offices {\n      margin-top: 50px;\n      .office-head {\n        font-size: 90px;\n        font-family: $light;\n        text-transform: lowercase;\n        @include mq(mobile) {\n          font-size: 40px;\n        }\n      }\n      .filter {\n        display: flex;\n        gap: 30px;\n        margin-top: 40px;\n        margin-bottom: 60px;\n        @include mq(mobile) {\n          // flex-direction: column;\n          flex-wrap: wrap;\n          gap: 10px;\n          justify-content: flex-start;\n          margin-top: 20px;\n          margin-bottom: 0px;\n        }\n        .timezone-filter {\n          border: 1px solid rgba(19, 19, 19, 0.737);\n          padding: 10px 40px;\n          border-radius: 30px;\n          font-size: 18px;\n          font-family: $roman;\n          transition: all 0.3s ease;\n          &:hover {\n            background: white;\n            color: black;\n            border: 1px solid white;\n          }\n          @include mq(mobile) {\n            font-size: 14px;\n            padding: 8px 18px;\n          }\n        }\n        .reset-timezones {\n          border: 1px solid rgba(19, 19, 19, 0.737);\n          padding: 10px 40px;\n          border-radius: 30px;\n          font-size: 18px;\n          font-family: $roman;\n          transition: all 0.3s ease;\n          &:hover {\n            background: white;\n            color: black;\n            border: 1px solid white;\n          }\n          @include mq(mobile) {\n            font-size: 14px;\n            padding: 8px 35px;\n          }\n        }\n\n        .timezone-filter.active {\n          background: white;\n          color: black;\n          border: 1px solid white;\n        }\n        .reset-timezones {\n          font-size: 18px;\n          font-family: $roman;\n          // text-decoration: underline;\n          align-self: center;\n          transition: all 0.2s ease;\n          background-color: white;\n          color: black;\n          border: white 1px solid;\n          &:hover {\n            color: gray;\n          }\n          @include mq(mobile) {\n            @include flexbox();\n            flex: 1;\n            justify-content: end;\n          }\n        }\n      }\n\n      .adress-wrapper {\n        .address-item {\n          display: none;\n          padding: 80px 0;\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          border-bottom: black solid 1px;\n          gap: 20px;\n          @include mq(mobile) {\n            flex-direction: column;\n            align-items: flex-start;\n\n            padding: 40px 0;\n            gap: 20px;\n            &:last-child {\n              padding-bottom: 0;\n            }\n          }\n\n          .hover-image-container {\n            transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n            border-radius: 15px;\n          }\n          &:hover .hover-image-container {\n            border-radius: 0;\n          }\n          &:hover .address-item {\n            animation: upToDown 0.45s;\n            transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n          }\n          &:hover img {\n            transform: scale(1.1);\n          }\n          .city {\n            flex: 1.3;\n            font-family: $light;\n            font-size: 80px;\n            line-height: 0.8;\n            @include mq(mobile) {\n              font-size: 32px;\n            }\n          }\n          .adress {\n            flex: 2;\n            display: flex;\n            align-items: flex-start;\n            flex-direction: column;\n            align-items: stretch;\n\n            @include mq(mobile) {\n              width: 100%;\n            }\n\n            h4 {\n              display: none;\n              font-family: $roman;\n              font-size: 20px;\n              font-weight: 600;\n              margin-bottom: 10px;\n              @include mq(mobile) {\n                font-size: 18px;\n              }\n            }\n            .adr-tag-wrap {\n              display: flex;\n              justify-content: space-between;\n              align-items: flex-end;\n\n              .icon {\n                img {\n                  transform: translate(\n                    -30px,\n                    30px\n                  ); /* Move the arrow from bottom left */\n                  opacity: 0; /* Start with the arrow hidden */\n                  transition: transform 0.3s ease-in-out,\n                    opacity 0.3s ease-in-out;\n                }\n              }\n\n              .hover-image-container {\n                transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n                border-radius: 15px;\n              }\n              &:hover .hover-image-container {\n                border-radius: 0;\n              }\n              .rolling-copy-wrap {\n                width: 100%;\n                display: flex;\n                align-items: flex-end;\n                // padding-right: 10px;\n              }\n              &:hover .text {\n                // animation: upToDown 0.45s;\n                transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n              }\n              &:hover .icon {\n                // animation: upToDown 0.45s;\n                // transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n              }\n              &:hover img {\n                // transform: scale(1.1);\n                transform: translate(\n                  0,\n                  0\n                ); /* Move to original position and reset rotation */\n                opacity: 1;\n              }\n              .icon {\n                flex: 0.1;\n                display: block;\n                // transform: rotate(-45deg);\n                font-weight: 400;\n                display: flex;\n                justify-content: flex;\n                // padding-right: 5px;\n                padding-bottom: 8px;\n\n                img {\n                  width: 20px;\n                  @include mq(mobile) {\n                    padding-bottom: 5px;\n                    width: 14px;\n                  }\n                }\n              }\n              .text {\n                flex: 1.2;\n                font-size: 30px;\n                font-family: $roman;\n                line-height: 1.2;\n                // text-align: center;\n\n                @include mq(mobile) {\n                  font-size: 22px;\n                }\n              }\n              @include mq(mobile) {\n                font-size: 16px;\n              }\n            }\n          }\n\n          &:last-child {\n            border-bottom: none;\n          }\n        }\n      }\n      .filter-applied {\n        .address-item {\n          border-bottom: 0;\n        }\n      }\n    }\n  }\n}\n\n#people {\n  padding-top: 200px;\n  padding-bottom: 150px;\n  @include mq(mobile) {\n    padding-top: 140px;\n  }\n  .people-wrapper {\n    .people-head-wrap {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      @include mq(mobile) {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n      p {\n        font-family: $roman;\n        font-size: 23px;\n        line-height: 1.4;\n        @include mq(mobile) {\n          font-size: 21px;\n          line-height: 1.3;\n        }\n      }\n    }\n    .contact-heading {\n      font-size: 180px;\n      font-family: $light;\n      line-height: 100%;\n      text-transform: lowercase;\n      @include mq(mobile) {\n        font-size: 60px;\n        line-height: 1.4;\n      }\n      @include mq(tab) {\n        font-size: 100px;\n      }\n      @include mq(desktop) {\n        font-size: 140px;\n      }\n    }\n\n    .people-card-wrapper {\n      padding-top: 50px;\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      column-gap: 100px;\n      row-gap: 65px;\n\n      @include mq(mobile) {\n        grid-template-columns: repeat(1, 1fr);\n        // column-gap: 35px;\n        // row-gap: 65px;\n      }\n      @include mq(tab) {\n        grid-template-columns: repeat(3, 1fr);\n        column-gap: 35px;\n        row-gap: 65px;\n      }\n    }\n    .img-wrap {\n      flex: 1;\n      overflow: hidden;\n      img {\n        transition: transform 0.3s ease-in-out; /* Smooth scaling transition */\n        transform: scale(1); /* Start at normal size */\n        will-change: transform; /* Optimize for smooth animations */\n        transform-origin: center;\n      }\n    }\n    .name {\n      padding: 20px;\n      // margin-top: 16px;\n      font-family: $roman;\n      font-size: 28px;\n      // line-height: 100%;\n      display: flex;\n      align-items: flex-end;\n      justify-content: space-between;\n      line-height: 1.1;\n      gap: 10px;\n\n      .arrow-png {\n        // display: none;\n        padding-bottom: 12px;\n        // width: 50px;\n        transform: translate(-30px, 30px); /* Move the arrow from bottom left */\n        opacity: 0; /* Start with the arrow hidden */\n        transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n\n        @include mq(mobile) {\n          width: 20px;\n          // opacity: 1;\n          transform: translateY(0); /* Move to original position */\n          opacity: 1;\n          padding-bottom: 4px;\n        }\n        img {\n          width: 50px;\n        }\n      }\n\n      @include mq(mobile) {\n        font-size: 18px;\n        padding: 10px;\n      }\n    }\n    .reverse {\n      flex-direction: row-reverse; /* Apply reverse order */\n      @include mq(mobile) {\n        flex-direction: row;\n      }\n    }\n    .reverse-mobile {\n      @include mq(mobile) {\n        flex-direction: row-reverse !important;\n      }\n    }\n    .people-card {\n      display: flex;\n      background-color: rgba(255, 255, 255, 0.568627451);\n\n      &:hover {\n        cursor: pointer;\n        .arrow-png {\n          transform: translateY(0); /* Move to original position */\n          opacity: 1; /* Fully visible */\n        }\n        .img-wrap {\n          overflow: hidden;\n          img {\n            transform: scale(1.03);\n          }\n        }\n      }\n    }\n    .people-info {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      // padding: 30px;\n    }\n\n    .designation {\n      padding: 20px;\n\n      font-family: $roman;\n      font-size: 16px;\n      line-height: 1.4;\n      // line-height: 1;\n      @include mq(mobile) {\n        font-size: 12px;\n        padding: 10px;\n      }\n    }\n  }\n}\n\n.footer-home {\n  padding: 100px 0;\n  @include mq(mobile) {\n    padding: 40px 0;\n  }\n\n  .footer-wrapper {\n    max-width: 1100px;\n    display: flex;\n    justify-content: space-between;\n    gap: 2rem;\n\n    @include mq(mobile) {\n      // flex-wrap: wrap;\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      column-gap: 60px;\n    }\n    .internet-logo {\n      img {\n        width: 120px;\n      }\n    }\n\n    .footer-item {\n      // flex: 1 1 0px;\n\n      img {\n        width: 130px;\n      }\n\n      a {\n        line-height: 1.2;\n        &:hover {\n          color: $Blue;\n        }\n      }\n\n      h4 {\n        line-height: 1.2;\n      }\n\n      .head {\n        font-family: $medium;\n        font-size: 15px;\n        // border-bottom: 1px solid black;\n        max-width: fit-content;\n        text-transform: capitalize;\n        margin-bottom: 0.5rem;\n        @include mq(mobile) {\n          font-size: 13px;\n          margin-bottom: 0.3rem;\n        }\n      }\n\n      .head-b {\n        font-family: $medium;\n        font-size: 16px;\n        // border-bottom: 1px solid black;\n        max-width: fit-content;\n        text-transform: capitalize;\n        margin-bottom: 0.5rem;\n        @include mq(mobile) {\n          font-size: 13px;\n          margin-bottom: 0.3rem;\n        }\n      }\n\n      .email {\n        font-family: $roman;\n        margin-bottom: 1rem;\n        font-size: 16px;\n        display: block;\n        transition: all 0.2s ease;\n        cursor: pointer;\n        &:hover {\n          color: $Blue;\n        }\n        @include mq(mobile) {\n          font-size: 13px;\n        }\n      }\n\n      .city {\n        font-family: $roman;\n        // margin-bottom: 0.3rem;\n        font-size: 16px;\n        display: block;\n        line-height: 1.6;\n        @include mq(mobile) {\n          font-size: 13px;\n        }\n      }\n\n      .link {\n        font-size: 16px;\n        font-family: $roman;\n        margin-bottom: 0.3rem;\n        transition: all 0.2s ease;\n        cursor: pointer;\n        @include mq(mobile) {\n          font-size: 13px;\n        }\n        &:hover {\n          color: $Blue;\n          @include mq(mobile) {\n            color: unset;\n          }\n        }\n      }\n\n      &.order-2 {\n        @include mq(mobile) {\n          order: 1;\n        }\n      }\n      &.order-3 {\n        @include mq(mobile) {\n          order: 0;\n        }\n      }\n      &.order-0 {\n        @include mq(mobile) {\n          order: 0;\n        }\n      }\n      &.order-1 {\n        @include mq(mobile) {\n          order: 2;\n        }\n      }\n\n      @include mq(mobile) {\n        // display: flex;\n      }\n    }\n  }\n}\n\n//\n//\n//\n.cursor-circle {\n  position: fixed;\n  content: \"drag\";\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  top: 0;\n  left: 0;\n  background-color: rgb(185, 181, 181);\n  z-index: 1000;\n  cursor: none;\n  // pointer-events: none;\n  will-change: transform;\n  &::after {\n    content: \"drag\";\n    font-family: $roman;\n    font-size: 15px;\n    text-transform: capitalize;\n    left: 50%;\n    top: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.work-page {\n  padding-top: 200px;\n  padding-bottom: 80px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  @include mq(mobile) {\n    padding-top: 140px;\n  }\n  .work-wrapper {\n    .work-banner {\n      display: flex;\n      align-items: center;\n      margin-bottom: 50px;\n      gap: 110px;\n      justify-content: space-between;\n      @include mq(mobile) {\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 0px 0;\n        gap: 20px;\n      }\n      @include mq(tab) {\n        align-items: flex-start;\n        flex-direction: column;\n      }\n      h2 {\n        // flex: 1.5;\n        font-family: $light;\n        text-transform: lowercase;\n        font-size: 180px;\n        line-height: 0.85;\n        @include mq(mobile) {\n          font-size: 60px;\n        }\n        @include mq(tab) {\n          font-size: 100px;\n        }\n        @include mq(desktop) {\n          font-size: 140px;\n        }\n      }\n      p {\n        // flex: 1;\n        font-family: $roman;\n        font-size: 23px;\n        line-height: 1.4;\n        @include mq(mobile) {\n          font-size: 16px;\n        }\n      }\n    }\n  }\n\n  .work-ct {\n    .total-slide {\n      color: black;\n      font-family: $roman;\n      position: absolute;\n      right: 0;\n      top: -65px;\n      font-size: 20px;\n      @include mq(mobile) {\n        font-size: 15px;\n        top: -50px;\n      }\n    }\n  }\n\n  .select-ct {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    // margin-bottom: 100px;\n\n    .btn-filter {\n      border-radius: 50px;\n      border: 1px solid black;\n      font-family: $roman;\n      padding: 7px 20px;\n      cursor: pointer;\n      font-size: 18px;\n      color: black;\n      &:hover {\n        border: white;\n        background-color: white;\n        color: black;\n        border: 1px solid white;\n      }\n    }\n    .btn-filter.active {\n      background-color: white;\n      color: black;\n      border: 1px solid white;\n    }\n\n    @include mq(mobile) {\n      // flex-direction: column;\n      gap: 10px;\n      margin-bottom: 20px;\n      // align-items: stretch;\n    }\n\n    .label-select {\n      font-family: $roman;\n\n      @include mq(mobile) {\n        font-size: 13px;\n      }\n    }\n\n    .select-wrapper {\n      display: flex;\n      gap: 20px;\n      @include mq(mobile) {\n        // flex-wrap: wrap;\n        gap: 5px;\n      }\n      li {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n\n        @include mq(mobile) {\n          padding: 5px 0px;\n\n          // padding-left: 10px;\n          // padding-right: 10px;\n        }\n\n        .custom-select {\n          min-width: 180px;\n          max-width: 200px;\n          border: none;\n          outline: none;\n          font-family: $roman;\n          font-size: 16px;\n          // text-align: center;\n\n          cursor: pointer;\n          .css-13cymwt-control {\n            background-color: transparent;\n            border: 1px solid black;\n            border-radius: 50px;\n          }\n          .css-t3ipsp-control {\n            background-color: transparent !important;\n            border-color: black !important;\n            border-radius: 50px;\n            box-shadow: none;\n          }\n          .css-b62m3t-container {\n            background-color: transparent;\n          }\n          .css-tipsp-control {\n            background-color: transparent;\n          }\n          .css-1xc3v61-indicatorContainer {\n            color: black;\n            background-color: transparent;\n          }\n          .css-1y632ze-singleValue {\n            padding-left: 5px;\n          }\n\n          @include mq(mobile) {\n            // width: 65px;\n            font-size: 13px;\n            // padding-right: 15px;\n            min-width: 90px;\n            max-width: 200px;\n          }\n        }\n        span {\n          position: absolute;\n          right: 10px;\n          @include mq(mobile) {\n            font-size: 10px;\n          }\n        }\n      }\n    }\n  }\n  .work-card {\n    margin-top: 40px;\n    margin-bottom: 40px;\n    position: relative;\n    min-height: 340px;\n    @include mq(mobile) {\n      margin-top: 20px;\n      margin-bottom: 40px;\n    }\n    .card-wrapper {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 120px;\n      row-gap: 60px;\n\n      @media (max-width: 1200px) {\n        &.card-wrapper {\n          grid-template-columns: repeat(2, 1fr);\n        }\n      }\n\n      @media (max-width: 900px) {\n        &.card-wrapper {\n          grid-template-columns: repeat(2, 1fr);\n        }\n      }\n\n      @media (max-width: 600px) {\n        &.card-wrapper {\n          grid-template-columns: 1fr;\n        }\n      }\n\n      @include mq(mobile) {\n        gap: 40px;\n      }\n      @include mq(tab) {\n        justify-content: space-between;\n      }\n      // .card-item {\n      //   // flex: 0 0 280px;\n      //   // height: 450px;\n      //   padding-left: 30px;\n      //   padding-bottom: 30px;\n      //   background-color: white;\n\n      //   .copy-wrap {\n      //     padding-right: 30px;\n      //     margin-top: 40px;\n      //     display: flex;\n      //     align-items: flex-end;\n      //     align-items: flex-start;\n      //     justify-content: space-between;\n\n      //     .img-wrapper {\n      //       // flex: 1.5;\n      //       display: none;\n      //       img {\n      //         width: 90px;\n      //       }\n      //     }\n      //     .rolling-copy-wrap {\n      //       padding-top: 0;\n      //       // flex: 1.2;\n      //       width: 400px;\n      //     }\n      //   }\n\n      //   .hover-image-container {\n      //     flex: 1;\n      //     transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n      //     // border-radius: 15px;\n      //     display: flex;\n      //     justify-content: flex-end;\n      //     aspect-ratio: unset;\n      //   }\n\n      //   &:hover .hover-image-container {\n      //     border-radius: 0;\n      //   }\n      //   &:hover .discr {\n      //     animation: upToDown 0.45s;\n      //     transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n      //   }\n      //   &:hover .hover-img {\n      //     transform: scale(1.05);\n      //   }\n\n      //   &:hover {\n      //     transition: all ease 0.2s;\n      //     .img-wrapper {\n      //       width: 90px;\n      //       display: flex;\n      //       justify-content: flex-end;\n      //       flex-grow: 0;\n      //     }\n      //   }\n\n      //   @include mq(mobile) {\n      //     flex: auto;\n      //   }\n      //   @include mq(tab) {\n      //     flex: 0 0 340px;\n      //   }\n\n      //   .name {\n      //     flex: 1;\n      //     margin-top: 20px;\n      //     font-family: $roman;\n      //     font-size: 22px;\n      //     // padding: 0 20px;\n      //     @include mq(mobile) {\n      //       font-size: 14px;\n      //     }\n      //   }\n      //   .discr {\n      //     font-family: $roman;\n      //     font-size: 40px;\n      //     line-height: 1.2;\n      //     word-wrap: break-word;\n      //     white-space: normal;\n      //   }\n      //   img {\n      //     //border-radius: 20px;\n      //   }\n      // }\n    }\n  }\n\n  //\n  .Slider-heading {\n    font-family: $roman;\n    font-size: 26px;\n    margin-top: 100px;\n    margin-bottom: 20px;\n\n    @include mq(mobile) {\n      margin-top: 50px;\n      font-size: 20px;\n      // margin-bottom: 30px;\n    }\n  }\n  .slider-wrapper {\n    .work-card-wrapper {\n      display: flex;\n      @include mq(mobile) {\n        gap: 10px;\n      }\n\n      .name {\n        padding-left: 20px;\n        font-family: $roman;\n        font-size: 18px;\n        @include mq(mobile) {\n          font-size: 14px;\n          padding-left: 10px;\n        }\n      }\n    }\n    .card-item {\n      .copy-wrap {\n        padding: 0 20px;\n        padding-bottom: 20px;\n        flex: 1;\n        display: flex;\n        height: 130px;\n        align-items: flex-end;\n        justify-content: space-between;\n        .img-wrapper {\n          // flex: 1.5;\n          transform: translate(\n            -30px,\n            30px\n          ); /* Move the arrow from bottom left */\n          opacity: 0; /* Start with the arrow hidden */\n          transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n          @include mq(mobile) {\n            display: block;\n          }\n          img {\n            width: 50px;\n            @include mq(mobile) {\n              width: 30px;\n            }\n          }\n        }\n        .img-wrapper-1 {\n          padding-bottom: 7px;\n          img {\n            width: 50px;\n          }\n        }\n        .rolling-copy-wrap {\n          padding-top: 0;\n          // flex: 1.2;\n          width: 400px;\n          display: flex;\n        }\n        @include mq(mobile) {\n          height: 70px;\n          padding: 0 10px;\n          padding-bottom: 10px;\n        }\n      }\n\n      .hover-image-container {\n        flex: 2.3;\n        transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n        // border-radius: 15px;\n        display: flex;\n        justify-content: flex-end;\n        aspect-ratio: unset;\n\n        .hover-img {\n          transition: all 0.2s ease-in-out;\n        }\n      }\n\n      &:hover .hover-image-container {\n        border-radius: 0;\n      }\n      &:hover .discr {\n        // animation: upToDown 0.45s;\n        // transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n      }\n      &:hover .hover-img {\n        transform: scale(1.02);\n        // transform: scale(1);\n      }\n\n      &:hover {\n        transition: all ease 0.2s;\n        .img-wrapper {\n          // width: 90px;\n          transform: translate(\n            0,\n            0\n          ); /* Move to original position and reset rotation */\n          opacity: 1;\n        }\n      }\n    }\n\n    @include mq(mobile) {\n      flex: auto;\n    }\n    @include mq(tab) {\n      flex: 0 0 340px;\n    }\n    .name-wrap {\n      margin-top: 20px;\n    }\n\n    .category {\n      margin-top: 20px;\n    }\n\n    .name {\n      flex: 1;\n      font-family: $roman;\n      font-size: 34px;\n      line-height: 1.2;\n\n      // padding-left: 30px;\n      // padding: 0 20px;\n      @include mq(mobile) {\n        font-size: 22px;\n        margin-top: 10px;\n      }\n    }\n    .discr {\n      font-family: $roman;\n      font-size: 40px;\n      line-height: 1.2;\n      word-wrap: break-word;\n      white-space: normal;\n    }\n    img {\n      //border-radius: 20px;\n    }\n    button {\n      // background-color: #007bff; /* Blue background */\n      // color: white; /* White text */\n      border: none; /* Remove borders */\n      // padding: 10px 20px; /* Padding */\n      border-radius: 5px; /* Rounded corners */\n      cursor: pointer; /* Change cursor to pointer */\n      &.left-arrow {\n        width: 55px;\n        transform: rotate(180deg);\n        // position: \"absolute\": top: \"-50px\", right: \"100px\"\n        position: absolute;\n        top: -62px;\n        right: 60px;\n        padding: 10px;\n        padding-right: 0;\n        width: 40px;\n        position: absolute;\n        top: -45px;\n        @include mq(mobile) {\n          width: 25px;\n          right: 50px;\n          top: -30px;\n          padding: 5px;\n        }\n      }\n      &.right-arrow {\n        width: 55px;\n        position: absolute;\n        top: -62px;\n        right: 10px;\n        padding: 10px;\n        padding-right: 0;\n        width: 40px;\n        position: absolute;\n        top: -45px;\n        right: 0;\n        @include mq(mobile) {\n          width: 25px;\n          top: -30px;\n          padding: 5px;\n        }\n      }\n    }\n\n    button:hover {\n      // background-color: #0056b3; /* Darker blue on hover */\n    }\n  }\n  .show-more-btn {\n    border-bottom: 1px solid black;\n  }\n\n  .empty-filter-result {\n    font-family: $roman;\n    font-size: 20px;\n  }\n}\n\n.user-card {\n  .card-wrapper {\n    display: flex;\n  }\n}\n.wrapper-player {\n  .player {\n    padding: 5rem 0;\n    padding-top: 140px;\n    width: 90%;\n    @include mq(desktop) {\n      min-height: 100vh;\n    }\n\n    @include mq(mobile) {\n      padding-right: 15px;\n      padding-left: 15px;\n      padding-bottom: 40px;\n      width: 100%;\n    }\n    .player-copy-wrapper {\n      // display: flex;\n      gap: 30px;\n\n      .player-gif {\n        cursor: url(\"../images/Playbutton.png\"), auto;\n        width: 100%;\n        height: auto;\n      }\n      @include mq(mobile) {\n        flex-direction: column;\n        gap: 10px;\n      }\n      .page-copy {\n        flex: 1.2;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        justify-content: center;\n        gap: 10px;\n        margin-bottom: 20px;\n        @include mq(mobile) {\n          gap: 10px;\n        }\n\n        .top-left-copy {\n          font-size: 55px;\n          font-family: $roman;\n          line-height: 1.2;\n          @include mq(mobile) {\n            font-size: 28px;\n          }\n        }\n        .top-bottom-copy {\n          font-size: 22px;\n          font-family: $roman;\n          line-height: 1;\n          @include mq(mobile) {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n    .player-container {\n      flex: 2;\n      // max-width: 860px;\n      margin: 0 auto;\n      // display: flex;\n      @include mq(mobile) {\n        margin: unset;\n      }\n    }\n    .player-head {\n      font-size: 46px;\n      font-family: $roman;\n      @include mq(mobile) {\n        font-size: 30px;\n      }\n    }\n    .nav-work-wrapper {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      a {\n        font-family: $roman;\n        text-decoration: underline;\n      }\n    }\n    .player-para {\n      font-size: 24px;\n      font-family: $roman;\n    }\n    .player-wrapper-small {\n      position: relative;\n      padding-top: 56.25%;\n      background: #000;\n      // border-radius: 10px;\n      overflow: hidden;\n      // margin-top: 20px;\n      .spinner span {\n        border: 3px solid white;\n        border-right-color: rgba(119, 119, 119, 0.702);\n      }\n      .react-player {\n        position: absolute;\n        top: 0;\n        left: 0;\n      }\n    }\n\n    .copy-thumbnail {\n      font-family: $roman;\n      font-size: 22px;\n      margin-top: 20px;\n      @include mq(mobile) {\n        // text-align: center;\n        font-size: 16px;\n      }\n    }\n    .video-thumbnails {\n      margin-top: 20px;\n      gap: 20px;\n      display: flex;\n      justify-content: flex-start;\n      cursor: pointer;\n      @include mq(mobile) {\n        flex-wrap: wrap;\n        gap: 10px;\n        margin-top: 10px;\n      }\n      .thumbnail-item {\n        // border-radius: 10px;\n        overflow: hidden;\n        max-width: 140px;\n        border: 1px solid transparent;\n        transition: all 0.3s ease;\n        position: relative;\n        &:hover {\n          border: 1px solid white;\n        }\n        .vimeo-play-icon {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          transition: all 0.3 ease;\n          color: #ffffffc2;\n          font-size: 24px;\n        }\n        &:hover .vimeo-play-icon {\n          color: white;\n        }\n        @include mq(mobile) {\n          flex: 0 0 24%;\n        }\n      }\n      .thumbnail-item.active {\n        // border: 1px solid white;\n      }\n    }\n  }\n\n  .video-details {\n    background-color: white;\n    padding: 64px 0;\n    @include mq(mobile) {\n      padding-top: 40px;\n      padding-bottom: 40px;\n    }\n    .video-detail-wrapper {\n      max-width: 1110px;\n      display: flex;\n\n      gap: 130px;\n      flex-direction: row-reverse;\n      @include mq(mobile) {\n        gap: 50px;\n        flex-direction: column-reverse;\n      }\n      .detail-item {\n        display: flex;\n        flex-direction: column;\n        flex: 1.2;\n        gap: 2rem;\n        // display: flex;\n        .client {\n          font-family: $roman;\n          // border-bottom: 1px solid black;\n          width: max-content;\n          line-height: 1;\n          margin-bottom: 5px;\n          font-size: 30px;\n          @include mq(mobile) {\n            font-size: 28px;\n          }\n        }\n        .work-title {\n          font-family: $roman;\n          color: black;\n          font-size: 17px;\n          margin-top: 12px;\n          @include mq(mobile) {\n            font-size: 16px;\n            margin-top: 7px;\n          }\n        }\n      }\n      .detail-item-2 {\n        flex: 2;\n      }\n    }\n  }\n\n  .shoot-image {\n    background-image: url(\"../images/hero_bg.png\");\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    padding: 64px 0;\n    padding-bottom: 6rem;\n    @include mq(mobile) {\n      padding-top: 40px;\n      padding-bottom: 40px;\n    }\n\n    .head-copy {\n      font-family: $roman;\n      font-size: 60px;\n      margin-bottom: 32px;\n      line-height: 1;\n      text-align: center;\n      @include mq(mobile) {\n        font-size: 40px;\n        margin-bottom: 20px;\n      }\n    }\n    .image-wrapper {\n      // display: flex;\n      // flex-wrap: wrap;\n      // gap: 3rem;\n      position: relative;\n      .slick-slide {\n        // margin: 0 20px;\n        padding: 0 20px;\n      }\n      .img-flex-item {\n        flex: 1 0 48%;\n        // border-radius: 20px;\n        overflow: hidden;\n\n        img {\n          width: 100%;\n        }\n        @include mq(mobile) {\n          // border-radius: 10px !important;\n        }\n      }\n    }\n  }\n\n  .all-details {\n    background-color: white;\n    padding: 4rem 0;\n    padding-top: 32px;\n    @include mq(mobile) {\n      padding-top: 20px;\n      padding-bottom: 20px;\n    }\n    .all-details-wrapper {\n      max-width: 1110px;\n      .wrapper-flex {\n        .flex-item-wrapper {\n          padding: 40px 0;\n          display: flex;\n          // border-bottom: 0.5px solid $grayC;\n          align-items: flex-start;\n          @include mq(mobile) {\n            flex-direction: column;\n            padding: 20px 0;\n            row-gap: 10px;\n            align-items: flex-start;\n          }\n          &:last-child {\n            border-bottom: none;\n          }\n          .title {\n            flex: 1.5 0;\n            h4 {\n              font-family: $roman;\n              font-size: 34px;\n              // border-bottom: 1px solid black;\n              width: fit-content;\n              @include mq(mobile) {\n                font-size: 28px;\n              }\n            }\n          }\n\n          .copy {\n            flex: 2;\n            display: flex;\n            justify-content: space-between;\n            flex-wrap: wrap;\n\n            .copy-item {\n              flex: 1 1 28%;\n              display: flex;\n              flex-direction: column;\n              align-items: flex-start;\n\n              @include mq(mobile) {\n                // align-items: center;\n\n                gap: 0px;\n                width: 100%;\n              }\n\n              .copy-head {\n                font-size: 48px;\n                font-family: $roman;\n                img {\n                  width: 100px;\n                }\n                margin-bottom: 5px;\n                line-height: 1.2;\n                @include mq(mobile) {\n                  font-size: 38px;\n                  margin-bottom: 0;\n                  line-height: 1.2;\n                  img {\n                    width: 80px;\n                  }\n                }\n              }\n              .copy-para {\n                font-size: 14px;\n                font-family: $roman;\n                // font-weight: 700;\n                color: black;\n                // text-transform: uppercase;\n                @include mq(mobile) {\n                  text-align: start;\n                }\n              }\n              .copy-meta {\n                @include flexbox();\n                align-items: center;\n                column-gap: 10px;\n                flex-wrap: wrap;\n                justify-content: flex-start;\n                color: $grayC;\n\n                p {\n                  font-size: 14px;\n                }\n                @include mq(mobile) {\n                  justify-content: center;\n                }\n              }\n            }\n            &.copy-text {\n              font-family: $roman;\n              line-height: 1.4;\n              font-size: 20px;\n              color: black;\n              @include mq(mobile) {\n                font-size: 16px;\n                margin-top: 0px;\n              }\n            }\n\n            &.award-mobile {\n              display: grid;\n              grid-template-columns: repeat(3, 1fr);\n              gap: 30px;\n              justify-items: flex-start;\n\n              @include mq(mobile) {\n                width: 100%;\n                margin-top: 20px;\n                // flex-direction: column;\n                align-items: center;\n                gap: 20px;\n              }\n\n              .copy-item {\n                // align-items: center;\n                @include mq(mobile) {\n                  gap: 10px;\n                }\n              }\n            }\n\n            @media (max-width: 1200px) {\n              &.award-mobile {\n                grid-template-columns: repeat(3, 1fr);\n                gap: 30px;\n              }\n            }\n\n            @media (max-width: 900px) {\n              &.award-mobile {\n                grid-template-columns: repeat(2, 1fr);\n              }\n            }\n\n            @media (max-width: 600px) {\n              &.award-mobile {\n                grid-template-columns: repeat(2, 1fr);\n                gap: 20px;\n                row-gap: 30px;\n                width: 100%;\n                align-items: flex-start;\n              }\n            }\n            &.result-mobile {\n              display: grid;\n              grid-template-columns: repeat(3, 1fr);\n              justify-items: start;\n              gap: 30px;\n\n              @include mq(mobile) {\n                display: grid;\n                grid-template-columns: repeat(2, 1fr);\n                gap: 10px;\n                margin-top: 20px;\n                align-self: center;\n                // flex-direction: column;\n                gap: 20px;\n              }\n              @media (max-width: 1200px) {\n                &.result-mobile {\n                  grid-template-columns: repeat(3, 1fr);\n                  gap: 30px;\n                }\n              }\n\n              @media (max-width: 900px) {\n                &.result-mobile {\n                  grid-template-columns: repeat(2, 1fr);\n                }\n              }\n\n              @media (max-width: 600px) {\n                &.result-mobile {\n                  grid-template-columns: repeat(2, 1fr);\n                  gap: 20px;\n                  row-gap: 30px;\n                  width: 100%;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .related-work {\n    padding: 64px 0;\n    @include mq(mobile) {\n      padding: 40px 0;\n    }\n\n    .related-work-wrapper {\n      .head-copy {\n        font-family: $roman;\n        font-size: 60px;\n        margin-bottom: 2rem;\n        text-align: center;\n        @include mq(mobile) {\n          font-size: 40px;\n        }\n      }\n      .wrapper-flex {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 40px;\n        @include mq(mobile) {\n          grid-template-columns: repeat(1, 1fr);\n\n          gap: 40px;\n        }\n\n        .flex-item {\n          flex: 1 0 48%;\n          display: flex;\n          flex-direction: column;\n\n          .hover-image-container {\n            transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n            // border-radius: 15px;\n            @include mq(mobile) {\n              // border-radius: 7px;\n            }\n          }\n          &:hover .hover-image-container {\n            border-radius: 0;\n          }\n          &:hover .discr,\n          &:hover .arrow-wrapper > img {\n            // animation: upToDown 0.45s;\n            transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n          }\n          &:hover img {\n            transform: scale(1.1);\n          }\n\n          .main-image {\n            // border-radius: 15px;\n            margin-bottom: 10px;\n          }\n          .img-title {\n            .name {\n              margin-top: 0px;\n              font-family: $roman;\n              font-size: 16px;\n              @include mq(mobile) {\n                font-size: 14px;\n              }\n            }\n            h4 {\n              font-family: $roman;\n              font-size: 20px;\n              line-height: 1.2;\n              margin-bottom: 5px;\n              @include mq(mobile) {\n                font-size: 22px;\n                margin-bottom: 0px;\n              }\n            }\n            .view-more {\n              font-family: $roman;\n              font-size: 13px;\n              border-bottom: 1px solid black;\n              max-width: fit-content;\n            }\n          }\n          .rolling-copy-wrap {\n            .arrow-png {\n              width: 20px;\n              transform: translate(\n                -10px,\n                10px\n              ); /* Move the arrow from bottom left */\n              opacity: 0; /* Start with the arrow hidden */\n              transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n            }\n            .arrow-png-1 {\n              @include mq(mobile) {\n                width: 20px;\n                padding-bottom: 5px;\n              }\n            }\n          }\n\n          &:hover {\n            .arrow-png {\n              transform: translate(\n                0,\n                0\n              ); /* Move to original position and reset rotation */\n              opacity: 1;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.spinner {\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  // top: 85%;\n\n  span {\n    display: block;\n    width: 30px;\n    height: 30px;\n    border: 3px solid transparent;\n    border-radius: 50%;\n    border-right-color: #000000b3;\n    animation: spinner-anim 0.8s linear infinite;\n  }\n\n  &.spinner-int {\n    top: 85%;\n  }\n  &.spinner-news {\n    top: 85%;\n  }\n}\n\n@keyframes spinner-anim {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.reset-btn {\n  font-family: $bold;\n  text-decoration: underline;\n}\n\n.scroll-down-svg {\n  left: 50%;\n  transform: translateY(0%) rotate(45deg);\n  opacity: 1;\n}\n\n.scroll-down-svg1 {\n  width: 2em;\n  height: 2em;\n  background-color: transparent;\n  z-index: 80;\n  bottom: 40px;\n  position: absolute;\n  border-width: 0 0.25em 0.25em 0;\n  border-style: solid;\n  border-color: rgb(0, 0, 0);\n  animation: scrolldown 1.2s ease-in-out infinite;\n}\n\n.scroll-down-svg2 {\n  width: 2em;\n  height: 2em;\n  background-color: transparent;\n  z-index: 80;\n  bottom: 60px;\n  position: absolute;\n  border-width: 0 0.16em 0.16em 0;\n  border-style: solid;\n  border-color: white;\n  // animation: scrolldown 1.2s ease-in-out infinite 0.15s;\n  @include mq(mobile) {\n    bottom: 20px;\n    width: 1em;\n    height: 1em;\n    border-width: 0 0.14em 0.14em 0;\n  }\n}\n\n@keyframes scrolldown {\n  0% {\n    transform: translateY(20%) rotate(45deg);\n    opacity: 0.7;\n  }\n  50% {\n    transform: translateY(0%) rotate(45deg);\n    opacity: 0.1;\n  }\n  100% {\n    transform: translateY(20%) rotate(45deg);\n    opacity: 0.7;\n  }\n}\n\n.hover-image-container {\n  position: relative;\n  margin-bottom: 10px;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  // border-radius: 15px;\n  // background: #e4e4e4;\n  &::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: #e5e5e5;\n    opacity: 0;\n    transition: 0.4s ease all;\n  }\n  .main-image {\n    transition: 0.4s ease all;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n\n.rolling-copy-wrap {\n  // padding-top: 40px;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  // padding-right: 20px;\n\n  @include mq(mobile) {\n    padding-top: 5px;\n    padding-top: 5px;\n    align-items: flex-end;\n    padding-right: 5px;\n  }\n}\n\n@keyframes upToDown {\n  49% {\n    transform: translateY(-100%);\n  }\n  50% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  51% {\n    opacity: 1;\n  }\n}\n\n.divider {\n  border-bottom: 1px solid;\n}\n\n#news {\n  padding-top: 200px;\n  padding-bottom: 60px;\n  @include mq(mobile) {\n    padding-top: 120px;\n    padding-bottom: 40px;\n  }\n  .news-header {\n    h2 {\n      font-size: 140px;\n      font-family: $roman;\n      text-transform: lowercase;\n      line-height: 100%;\n      margin-bottom: 50px;\n    }\n    @include mq(mobile) {\n      h2 {\n        font-size: 60px;\n        margin-bottom: 20px;\n      }\n    }\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .filter-wrapper {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      font-family: $roman;\n    }\n  }\n  .news-list {\n    min-height: 340px;\n    @include flexbox();\n    gap: 40px;\n    flex-wrap: wrap;\n    margin-top: 60px;\n    row-gap: 60px;\n    // display: grid;\n    // grid-template-columns: repeat(3, 1fr);\n\n    .news-item {\n      @include flexbox();\n      // flex-direction: column;\n      // justify-content: flex-start;\n      // flex-basis: calc(30% - 10px);\n      align-items: flex-start;\n      gap: 35px;\n      border-bottom: 1px solid black;\n      padding-bottom: 40px;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      .tumbnail-img {\n        flex: 1;\n      }\n\n      .copy-wrap {\n        flex: 2.7;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        // flex-grow: 1;\n      }\n      .arrow-wrapper {\n        flex: 0.07;\n        img {\n          padding-top: 2px;\n          padding-right: 2px;\n        }\n      }\n      //\n      .hover-image-container {\n        transition: border-radius 0.9s cubic-bezier(0.23, 1, 0.32, 1);\n        border-radius: 15px;\n        @include mq(mobile) {\n          border-radius: 7px;\n        }\n      }\n      &:hover .hover-image-container {\n        border-radius: 0;\n      }\n      &:hover .news-title,\n      &:hover .arrow-wrapper > img {\n        animation: upToDown 0.45s;\n        transition: translate 0.45s cubic-bezier(0.23, 1, 0.32, 1);\n      }\n      &:hover img {\n        transform: scale(1.1);\n      }\n      //\n      .news-title {\n        font-family: $roman;\n        font-size: 28px;\n        line-height: 1.4;\n        @include mq(mobile) {\n          font-size: 15px;\n        }\n      }\n      .date {\n        font-family: $roman;\n        font-size: 14px;\n        // margin-top: 20px;\n      }\n      @include mq(mobile) {\n        // flex-basis: calc(50% - 10px);\n        flex-direction: row;\n        gap: 10px;\n        padding-bottom: 20px;\n        border-bottom: 0.7px solid;\n      }\n    }\n    @include mq(mobile) {\n      margin-top: 25px;\n      row-gap: 25px;\n    }\n  }\n\n  @media (max-width: 1200px) {\n    .news-list {\n      // grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  @media (max-width: 900px) {\n    .news-list {\n      // grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  @media (max-width: 600px) {\n    .news-list {\n      // grid-template-columns: 1fr;\n    }\n  }\n}\n\n/* LIGHTBOX  */\n.yarl__button.yarl__navigation_next,\n.yarl__button.yarl__navigation_prev {\n  display: none;\n}\n\n.yarl__portal_open {\n  z-index: 100000;\n}\n\n.show-more-button {\n  border: 1px solid rgba(19, 19, 19, 0.737);\n  border: none;\n  padding: 4px 12px;\n  // border-radius: 25px;\n  font-size: 16px;\n  font-family: $roman;\n  transition: all 0.3s ease;\n  padding: 0;\n  // padding-bottom: ;\n  border-bottom: 1px solid;\n  cursor: pointer;\n  &:hover {\n    // background: black;\n    color: white;\n  }\n}\n\n.show-more-wrap {\n  position: relative;\n  @include flexbox();\n  margin-top: 60px;\n  justify-content: center;\n  @include mq(mobile) {\n    margin-top: 25px;\n  }\n}\n\n.react-player {\n  width: 100% !important;\n  height: 100% !important;\n  .Button_module_button__a2d215de {\n    display: none;\n  }\n}\n\n.react-player iframe {\n  width: 100%;\n  height: 100%;\n}\n\n.back-link {\n  transition: all 0.2s ease;\n  &:hover {\n    color: white;\n  }\n}\n\n/* SCATTER ANIMATION */\n\n.scatter-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 770px;\n  position: relative;\n  overflow: unset;\n  // padding-top: 80px;\n  // padding-bottom: 80px;\n\n  @include mq(mobile) {\n    overflow: hidden;\n    padding-top: 0px;\n    padding-bottom: 0px;\n    height: 650px;\n  }\n\n  .image-container {\n    position: absolute;\n    // display: flex;\n    // gap: 5px;\n    // align-items: flex-start;\n    // justify-content: flex-start;\n    // width: 150px;\n    border-radius: 10px;\n    cursor: pointer;\n    flex-direction: column;\n\n    .image {\n      width: 100%;\n      // border-radius: 15px;\n      @include mq(mobile) {\n        // border-radius: 10px;\n      }\n    }\n\n    .text-overlay {\n      // position: absolute;\n      // bottom: 10px;\n      // left: 6px;\n      // // background: rgba(0, 0, 0, 0.6);\n      // color: white;\n      // padding: 2px 5px;\n      // border-radius: 5px;\n      margin-top: 10px;\n      font-family: $roman;\n      font-size: 15px;\n\n      @include mq(mobile) {\n        bottom: 5px;\n        left: 3px;\n        font-size: 10px;\n        font-family: $roman;\n        margin-top: 7px;\n      }\n    }\n  }\n\n  .center-text {\n    font-size: 100px;\n    font-family: $light;\n    line-height: 100%;\n    color: white;\n    text-align: center;\n    z-index: 1;\n\n    @include mq(mobile) {\n      font-size: 34px;\n      font-family: $roman;\n      font-size: 40px;\n    }\n\n    @include mq(tab) {\n      font-size: 60px;\n    }\n  }\n}\n\n.skeleton-wrap span {\n  border-radius: 0;\n}\n\n.add-accounts-page-css {\n  .container-ad {\n    max-width: 1200px;\n    margin: 0 auto;\n    width: 90%;\n    // padding: 0 15px;\n\n    @include mq(tab) {\n      // max-width: 768px;\n    }\n\n    @include mq(mobile) {\n      max-width: 320px;\n    }\n  }\n  header {\n    padding: 52px 0;\n    @include mq(mobile) {\n      padding: 20px 0;\n    }\n    .logo {\n      @include mq(mobile) {\n        width: 120px;\n      }\n    }\n    nav {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n\n    .nav-list {\n      display: flex;\n      align-items: center;\n\n      .nav-item {\n        font-size: 14px;\n        font-family: $medium;\n        margin-right: 31px;\n        letter-spacing: 0%;\n        color: #6e5e7e;\n        @include mq(mobile) {\n          margin-right: 0;\n        }\n      }\n    }\n\n    a {\n      display: block;\n    }\n\n    .login-btn,\n    .getin-btn {\n      font-family: $Mregular;\n      font-size: 15px;\n      line-height: 20px;\n      padding: 12px 25px;\n      border-radius: 40px;\n      letter-spacing: -0.23px;\n    }\n\n    .login-btn {\n      border: 1px solid black;\n      margin-right: 10px;\n      margin-left: 97px;\n      @include mq(mobile) {\n        margin-left: 0;\n        margin-right: 0;\n      }\n    }\n\n    .getin-btn {\n      // border: 1px solid black;\n      // background-color: black;\n      background: rgb(143, 55, 200);\n      background: linear-gradient(\n        0deg,\n        rgba(143, 55, 200, 1) 0%,\n        rgba(159, 63, 181, 1) 8%,\n        rgba(210, 89, 125, 1) 22%,\n        rgba(242, 105, 91, 1) 39%,\n        rgba(255, 112, 78, 1) 51%,\n        rgba(255, 101, 104, 1) 65%,\n        rgba(255, 94, 125, 1) 79%,\n        rgba(255, 143, 107, 1) 98%\n      );\n      color: white;\n    }\n\n    .hamburger-1 {\n      display: none;\n      flex-direction: column;\n      justify-content: space-between;\n      width: 34px;\n      height: 18px;\n      background: none;\n      border: none;\n      cursor: pointer;\n      z-index: 1000;\n\n      .bar {\n        width: 100%;\n        height: 2px;\n        background-color: #5c3688;\n        transition: all 0.3s ease;\n      }\n\n      &.active .bar:nth-child(1) {\n        transform: rotate(45deg) translate(5px, 5px);\n      }\n\n      &.active .bar:nth-child(2) {\n        opacity: 0;\n      }\n\n      &.active .bar:nth-child(3) {\n        transform: rotate(-45deg) translate(5px, -5px);\n      }\n    }\n\n    @media screen and (max-width: 768px) {\n      .nav-list {\n        position: fixed;\n        top: -100%;\n        right: 0;\n        width: 100%;\n        background-color: white;\n        flex-direction: column;\n        align-items: center;\n        padding: 20px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        transition: top 0.4s ease;\n\n        &.active {\n          // top: 52px;\n          padding-top: 100px;\n          top: 0;\n          display: flex;\n          flex-direction: column;\n          height: 100vh;\n          background-color: white;\n          gap: 20px; // Adjust this value based on your header height\n          z-index: 5;\n        }\n      }\n\n      .hamburger-1 {\n        display: flex;\n      }\n    }\n  }\n  .no-scroll {\n    overflow: hidden;\n    height: 100%;\n    position: fixed;\n    width: 100%;\n  }\n\n  .scroll-top-btn {\n    background-color: red;\n    background: linear-gradient(\n      0deg,\n      rgb(143, 55, 200) 0%,\n      rgb(159, 63, 181) 8%,\n      rgb(210, 89, 125) 22%,\n      rgb(242, 105, 91) 39%,\n      rgb(255, 112, 78) 51%,\n      rgb(255, 101, 104) 65%,\n      rgb(255, 94, 125) 79%,\n      rgb(255, 143, 107) 98%\n    );\n    // padding: 20px;\n    font-size: 25px;\n    color: white;\n    width: 50px;\n    height: 50px;\n    border-radius: 50px;\n  }\n\n  // main\n  main {\n    #home {\n      .hero-copy {\n        margin-top: 12px;\n        font-family: $Msemibold;\n        font-size: 57px;\n        line-height: 70px;\n        color: #5c3688;\n        margin-bottom: 40px;\n        @include mq(mobile) {\n          text-align: center;\n\n          font-size: 32px;\n          line-height: 1.2;\n          margin-top: 40px;\n          margin-bottom: 50px;\n        }\n        @include mq(tab) {\n          font-size: 50px;\n          text-align: center;\n          line-height: 70px;\n        }\n      }\n      .services {\n        // display: f;\n        display: grid;\n        grid-template-columns: repeat(2, 2fr);\n        gap: 35px;\n        // gap: 60px;\n        @include mq(mobile) {\n          // flex-direction: column;\n          display: grid;\n          grid-template-columns: repeat(2, 2fr);\n          gap: 35px;\n        }\n      }\n      .wrapper {\n        display: flex;\n        gap: 20px;\n        @include mq(mobile) {\n          align-items: center;\n          flex-direction: column;\n        }\n      }\n      .orange-ring {\n        width: 60px;\n        height: 60px;\n        border: 2px solid #f17380;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        p {\n          // text-align: center;\n          font-family: $Mregular;\n          color: #6e5e7e;\n          font-size: 30px;\n        }\n      }\n      .copy {\n        color: #6e5e7e;\n        font-family: $Mregular;\n        line-height: 28px;\n        font-size: 28px;\n        font-weight: 600;\n        @include mq(mobile) {\n          line-height: 1.2;\n          font-size: 20px;\n          text-align: center;\n        }\n      }\n      .homepage-btn {\n        margin-top: 52px;\n        display: flex;\n        justify-content: center;\n        @include mq(mobile) {\n          margin-top: 40px;\n        }\n      }\n      .login-btn {\n        font-family: $Mregular;\n        font-size: 15px;\n        line-height: 20px;\n        padding: 22px 44px;\n        border: 1px solid black;\n        border-radius: 40px;\n        margin-right: 20px;\n        letter-spacing: -0.23px;\n      }\n      .getin-btn {\n        font-family: $Mregular;\n        font-size: 15px;\n        line-height: 20px;\n        padding: 22px 83px;\n        // border: 1px solid black;\n        border-radius: 40px;\n        // background-color: black;\n        background: rgb(143, 55, 200);\n        background: linear-gradient(\n          0deg,\n          rgba(143, 55, 200, 1) 0%,\n          rgba(159, 63, 181, 1) 8%,\n          rgba(210, 89, 125, 1) 22%,\n          rgba(242, 105, 91, 1) 39%,\n          rgba(255, 112, 78, 1) 51%,\n          rgba(255, 101, 104, 1) 65%,\n          rgba(255, 94, 125, 1) 79%,\n          rgba(255, 143, 107, 1) 98%\n        );\n        color: white;\n        letter-spacing: -0.23px;\n      }\n\n      .wrapper-form-banner {\n        display: flex;\n        gap: 0px;\n        align-items: start;\n        @include mq(mobile) {\n          flex-direction: column;\n          align-items: stretch;\n        }\n\n        .wrapper-form-form {\n          flex: 1;\n          padding: 15px 40px;\n          margin-top: 10px;\n          background: linear-gradient(\n            0deg,\n            rgb(143, 55, 200) 0%,\n            rgb(159, 63, 181) 8%,\n            rgb(210, 89, 125) 22%,\n            rgb(242, 105, 91) 39%,\n            rgb(255, 112, 78) 51%,\n            rgb(255, 101, 104) 65%,\n            rgb(255, 94, 125) 79%,\n            rgb(255, 143, 107) 98%\n          );\n\n          @include mq(mobile) {\n            padding: 20px;\n          }\n        }\n        .wrapper-form-copy {\n          flex: 1.6;\n        }\n\n        .form-wrapper-get-in-touch {\n          // margin: 60px 0;\n          // margin-top: 80px;\n          margin-bottom: 0;\n          // padding: 30px 0;\n          padding-bottom: 0px;\n          display: flex;\n          flex-direction: column;\n          // -webkit-box-shadow: inset 0px 5px 16px -15px rgba(0, 0, 0, 0.57);\n          // -moz-box-shadow: inset 0px 5px 16px -15px rgba(0, 0, 0, 0.57);\n          // box-shadow: inset 0px 5px 16px -15px rgba(0, 0, 0, 0.57);\n          div {\n            // max-width: 500px;\n            // margin: auto;\n            // padding: 20px;\n            // background-color: #f9f9f9;\n            border-radius: 8px;\n            // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n            width: 100%;\n\n            @include mq(mobile) {\n              // padding: 10px;\n            }\n          }\n          .input-wrapper {\n            // max-width: 400px;\n            margin-top: 7px;\n            margin-bottom: 15px;\n            display: flex;\n            flex-direction: column;\n            // gap: 10px;\n\n            @include mq(mobile) {\n              gap: 5px;\n\n              label {\n                text-align: center;\n              }\n            }\n          }\n\n          .wrapper-radio-btn {\n            display: flex;\n            justify-content: center;\n            flex-direction: column;\n            padding: 0;\n            gap: 0px;\n            @include mq(mobile) {\n              display: grid;\n              grid-template-columns: repeat(2, 1fr);\n            }\n          }\n\n          .error-form {\n            font-family: $Msemibold;\n            font-size: 13px;\n            padding-top: 5px;\n            text-align: left;\n          }\n          .error-wrapper {\n            padding: 0;\n            margin-top: 10px;\n          }\n\n          .radio-btn-section {\n            // display: flex;\n            justify-content: center;\n            // gap: 40px;\n            padding: 0;\n          }\n\n          h2 {\n            text-align: center;\n            font-family: $Msemibold;\n            color: white;\n            font-size: 20px;\n            padding-bottom: 20px;\n\n            @include mq(mobile) {\n              // font-size: 20px;\n            }\n          }\n\n          form {\n            display: flex;\n            flex-direction: column;\n            gap: 5px;\n          }\n          .form-grid {\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            // grid-template-columns: repeat(2, 1fr);\n            @include mq(mobile) {\n              display: flex;\n              flex-direction: column;\n            }\n          }\n\n          label {\n            font-weight: bold;\n            color: white;\n            margin-bottom: 5px;\n            font-family: $Msemibold;\n            font-size: 30px;\n            @include mq(mobile) {\n              font-size: 22px;\n            }\n          }\n          select {\n            // color: #5c3688 !important;\n            padding: 7px 20px;\n            border: 1px solid white;\n            border-radius: 50px;\n            font-size: 18px;\n            width: 100%;\n            color: white !important;\n            font-family: $DMregular;\n          }\n\n          input[type=\"text\"],\n          input[type=\"number\"] {\n            padding: 7px 20px;\n            border: 1px solid white;\n            border-radius: 50px;\n            font-size: 18px;\n            width: 100%;\n            color: white !important;\n            font-family: $DMregular;\n          }\n\n          input::placeholder {\n            color: white; /* Placeholder text color */\n            // font-style: italic; /* Italic style */\n            font-size: 18px; /* Font size */\n            opacity: 0.8; /* Thoda transparent effect */\n            font-family: $DMregular;\n            text-transform: capitalize;\n            // text-align: center;\n          }\n\n          .radio-label {\n            display: inline-flex;\n            align-items: center;\n            margin-right: 15px;\n            font-size: 22px;\n            font-family: $Msemibold;\n            @include mq(mobile) {\n              font-size: 15px;\n            }\n          }\n\n          .radio-input {\n            width: 16px;\n            height: 16px;\n            margin-right: 15px;\n            padding: 10px;\n            border-radius: 50%;\n            border: 2px solid #5c3688;\n            transition: background-color 0.3s, border 0.3s;\n            @include mq(mobile) {\n              padding: 7px;\n            }\n          }\n\n          .radio-input:checked {\n            background-color: #4f1d89;\n            border-color: #4f1d89;\n          }\n\n          .radio-input:checked + .radio-label {\n            font-weight: bold;\n          }\n\n          p {\n            color: red;\n            font-size: 14px;\n            margin: 0;\n          }\n\n          button {\n            padding: 10px 20px;\n            background-color: #4caf50;\n            color: white;\n            border: none;\n            border-radius: 5px;\n            cursor: pointer;\n            font-size: 16px;\n            transition: background-color 0.3s;\n          }\n\n          button:hover {\n            background-color: #45a049;\n          }\n\n          div > div {\n            text-align: center;\n            // background-color: white;\n            // padding: 20px;\n            border-radius: 8px;\n            // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n            @include mq(mobile) {\n              text-align: center;\n              padding-bottom: 0;\n            }\n          }\n\n          .back-plate {\n            padding: 40px;\n            // -webkit-box-shadow: 0px -4px 24px -7px rgba(0, 0, 0, 0.57);\n            // -moz-box-shadow: 0px -4px 24px -7px rgba(0, 0, 0, 0.57);\n            // box-shadow: 0px -4px 24px -7px rgba(0, 0, 0, 0.57);\n          }\n\n          h4 {\n            color: #5c3688;\n            font-family: $Msemibold;\n            font-size: 40px;\n            margin-bottom: 10px;\n            @include mq(mobile) {\n              font-size: 28px;\n            }\n          }\n          .success-p {\n            color: #5c3688;\n            font-family: $Mregular;\n            font-size: 30px;\n            margin-bottom: 20px;\n            @include mq(mobile) {\n              font-size: 18px;\n            }\n          }\n\n          button {\n            background-color: white;\n            padding: 15px 20px;\n            font-size: $Mregular;\n            font-size: 22px;\n\n            color: #5c3688;\n            font-size: 20px;\n            line-height: 20px;\n            padding: 12px 25px;\n            border-radius: 40px;\n            letter-spacing: -0.23px;\n            margin: auto;\n          }\n\n          button:hover {\n            background-color: #470e89;\n          }\n        }\n      }\n    }\n\n    .msg-btn {\n      position: fixed;\n      bottom: 0;\n      width: 90px;\n      bottom: 20px;\n      right: 20px;\n      width: 90px;\n      z-index: 10;\n      // border: 1px solid white;\n      // border-radius: 50%;\n      img {\n        border-radius: 50%;\n        border: solid 1px white;\n      }\n      @include mq(mobile) {\n        width: 40px;\n      }\n    }\n\n    #about {\n      position: relative;\n\n      .swiper-container {\n        margin-top: 134px;\n        width: 100%;\n        overflow: hidden;\n        @include mq(mobile) {\n          margin-top: 60px;\n        }\n      }\n\n      .swiper-slide {\n        width: auto;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .hero-img {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n      }\n      .dot-img {\n        flex-grow: 1;\n      }\n    }\n\n    #partnership {\n      padding-top: 167px;\n      .partnership-wrapper {\n        text-align: center;\n      }\n      .head-copy {\n        font-size: 80px;\n        line-height: 90px;\n        font-family: $Msemibold;\n        @include mq(mobile) {\n          font-size: 40px;\n          line-height: 50px;\n        }\n      }\n      .copy {\n        margin-top: 33px;\n        font-size: 30px;\n        font-family: $medium;\n        line-height: 40px;\n      }\n    }\n\n    #mediaSpend {\n      margin-top: 120px;\n      @include mq(mobile) {\n        margin-top: 50px;\n      }\n      .spand-wrapper {\n        // position: relative;\n        display: flex;\n        justify-content: center;\n      }\n      .img-wrapper {\n        position: relative;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n      .copy-wrapper {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        h4 {\n          color: #5c3688;\n          font-size: 100px;\n          line-height: 100px;\n          font-weight: 600;\n          font-family: $Mregular;\n          text-align: center;\n          @include mq(mobile) {\n            font-size: 60px;\n            line-height: 1.2;\n          }\n        }\n        p {\n          color: #5c3688;\n          font-size: 60px;\n          line-height: 70px;\n          font-weight: 600;\n          font-family: $Mregular;\n          text-align: center;\n          @include mq(mobile) {\n            font-size: 45px;\n            line-height: 1.2;\n          }\n        }\n      }\n    }\n\n    #knowmore {\n      padding-top: 157px;\n      .knowmore-wrapper {\n        max-width: 1071px;\n        margin: auto;\n      }\n      .card-wrapper {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 137px;\n        @include mq(mobile) {\n          flex-direction: column;\n        }\n      }\n      .card-img {\n        flex: 1;\n      }\n      .card-copy {\n        flex: 1;\n      }\n      .card-title {\n        font-size: 40px;\n        line-height: 90px;\n        font-family: $Msemibold;\n        @include mq(mobile) {\n          line-height: 50px;\n        }\n      }\n      .card-discription {\n        font-size: 20px;\n        font-family: $medium;\n        line-height: 30px;\n        // letter-spacing: 0%;\n        width: 338px;\n      }\n      .learnmore-btn {\n        margin-top: 11px;\n        font-size: 15px;\n        font-family: $Mregular;\n        line-height: 30px;\n\n        display: flex;\n        align-items: center;\n        gap: 10px;\n      }\n    }\n\n    #sliderContainer {\n      padding-top: 0px;\n      padding-bottom: 160px;\n      box-shadow: rgba(0, 0, 0, 0.35) 0px -4px 11px -4px inset;\n      @include mq(mobile) {\n        padding-top: 0;\n        padding-bottom: 120px;\n        box-shadow: rgb(0 0 0 / 19%) 1px -10px 11px -4px inset;\n      }\n      .wrapper {\n        position: relative;\n        display: flex;\n        justify-content: center;\n        @include mq(mobile) {\n          display: block;\n        }\n      }\n      .heading-slider-2 {\n        font-family: $Msemibold;\n        font-size: 60px;\n        line-height: 90px;\n        text-align: center;\n        color: #5c3688;\n        margin-bottom: 60px;\n        @include mq(mobile) {\n          font-size: 40px;\n          line-height: 1.2;\n          margin-bottom: 40px;\n        }\n      }\n      .swiper-container {\n        display: flex;\n        position: absolute;\n        justify-content: center;\n        align-items: center;\n        top: 61px;\n        bottom: 0;\n        @include mq(mobile) {\n          position: static;\n          display: block;\n          width: 100%;\n          position: absolute;\n          display: block;\n          left: 50%;\n          // trasform: tran;\n          left: 50%;\n          top: 0;\n          transform: translate(-50%, 0);\n          bottom: unset;\n        }\n      }\n      .swiper-wrapper {\n        max-width: 1200px;\n      }\n      .swiper-slide {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        overflow: visible;\n        @include mq(mobile) {\n          padding: 0 40px;\n          width: 100%;\n        }\n      }\n      .swiper-button-next:after {\n        content: unset;\n      }\n      .swiper-button-prev:after {\n        content: unset;\n      }\n      .swiper-button-next2,\n      .swiper-button-prev2 {\n        background-size: contain;\n        background-repeat: no-repeat;\n        background-position: center;\n        width: 44px;\n        height: 44px;\n        position: absolute; /* Ensure absolute positioning */\n        top: 50%;\n        transform: translateY(-50%); /* Center vertically */\n        z-index: 10; /* Ensure buttons are on top */\n        cursor: pointer;\n      }\n      // .swiper-button-next,\n      // .swiper-button-prev {\n      //   display: none;\n      // }\n      .swiper-button-next2 {\n        background-image: url(\"../images/ad-images/arrowRight.svg\");\n        @include mq(mobile) {\n          width: 30px;\n          right: -5px;\n        }\n        @include mq(tab) {\n          right: 150px;\n        }\n      }\n\n      .swiper-button-prev2 {\n        background-image: url(\"../images/ad-images/leftArrow.svg\");\n        @include mq(mobile) {\n          width: 30px;\n          left: -5px;\n        }\n        @include mq(tab) {\n          left: 150px;\n        }\n      }\n      .heading,\n      .city {\n        font-size: 28px;\n        line-height: 34px;\n        font-family: $Mregular;\n        font-weight: 600;\n        color: #5c3688;\n        @include mq(mobile) {\n          text-align: center;\n        }\n      }\n      .para {\n        font-size: 18px;\n        line-height: 24px;\n        margin-top: 16px;\n        font-family: $Mregular;\n        font-weight: 400;\n        color: #5c3688;\n        text-align: center;\n        margin-bottom: 16px;\n        @include mq(mobile) {\n          font-size: 14px;\n          line-height: 18px;\n          margin-bottom: 10px;\n          margin-top: 10px;\n        }\n      }\n    }\n\n    #multichannel {\n      padding-top: px;\n      .multichannel-wrapper {\n      }\n      .head-title {\n        font-size: 80px;\n        line-height: 90px;\n        font-family: $Msemibold;\n        text-align: center;\n        @include mq(mobile) {\n          font-size: 35px;\n          line-height: 45px;\n        }\n      }\n\n      .head-copy {\n        font-size: 30px;\n        line-height: 40px;\n        font-family: $Msemibold;\n        text-align: center;\n        margin-bottom: 93px;\n      }\n\n      .card-wrapper {\n        margin-top: 93px;\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        column-gap: 339px;\n        row-gap: 199px;\n        position: relative;\n\n        @include mq(mobile) {\n          grid-template-columns: unset;\n        }\n      }\n      .center-img {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n\n        transform: translate(-50%, -50%);\n      }\n      .card-title {\n        font-size: 40px;\n        font-family: $Msemibold;\n        line-height: 90px;\n        @include mq(mobile) {\n          line-height: 50px;\n        }\n      }\n      .card-copy {\n        font-size: 20px;\n        font-family: $Msemibold;\n        line-height: 30px;\n      }\n    }\n\n    #cardSection {\n      padding-top: 80px;\n      .heading-cardSection {\n        font-size: 60px;\n        line-height: 90px;\n        color: #5c3688;\n        font-family: $Msemibold;\n        text-align: center;\n        margin-bottom: 32px;\n        @include mq(mobile) {\n          font-size: 40px;\n          line-height: 1.2;\n        }\n      }\n      .card-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        width: 100%;\n        max-width: 1200px;\n        margin: 0 auto;\n      }\n\n      .row {\n        display: flex;\n        width: 100%;\n        // justify-content: space-around;\n        // align-items: center;\n        position: relative;\n        // margin-bottom: 20px;\n        @include mq(mobile) {\n          flex-direction: column;\n        }\n      }\n\n      .top-cards .card {\n        width: 30%;\n        @include mq(mobile) {\n          width: 100%;\n        }\n      }\n\n      .center-card {\n        position: relative;\n      }\n\n      .center-card .card {\n        width: 45%;\n        @include mq(mobile) {\n          width: 100%;\n        }\n      }\n\n      .card {\n        // background-color: #f2f2f2;\n        padding: 16px;\n        padding-top: 23px;\n        padding-bottom: 76px;\n        // border-radius: 5px;\n        // text-align: center;\n        // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        // margin: 10px;\n        flex-grow: 1;\n        position: relative;\n      }\n      .heading-card {\n        font-size: 28px;\n        font-family: $Msemibold;\n        line-height: 34px;\n        color: #5c3688;\n        margin-bottom: 15px;\n      }\n      .copy-card {\n        font-size: 18px;\n        font-family: $Mregular;\n        line-height: 24px;\n        color: #5c3688;\n        position: relative;\n        z-index: 5;\n      }\n\n      .top-cards .card {\n        border-bottom: 1px solid #5c368833;\n        z-index: 5; /* Add border-right to all cards except the last one */\n      }\n      .top-cards .card:not(:last-child) {\n        border-right: 1px solid #5c368833; /* Add border-right to all cards except the last one */\n        z-index: 5; /* Add border-right to all cards except the last one */\n      }\n      .center-card .card:not(:last-child) {\n        border-right: 1px solid #5c368833; /* Add border-right to all cards except the last one */\n        z-index: 5; /* Add border-right to all cards except the last one */\n      }\n\n      .card-container .row .card::after {\n        content: \"\";\n        position: absolute;\n        width: 7px;\n        height: 7px;\n        background-color: #5c368833;\n        border-radius: 50%;\n        z-index: 10;\n      }\n      .top-cards .card:not(:last-child)::after {\n        top: 100%;\n        right: -4px;\n        transform: translateY(-50%);\n        z-index: 10;\n      }\n\n      .center-card .card:not(:last-child)::after {\n        top: 100%;\n        right: -4px;\n        transform: translateY(-50%);\n        top: 0;\n        z-index: 10;\n      }\n      .circle-pink {\n        margin-bottom: 30px;\n      }\n\n      .card-4 {\n        padding-left: 211px;\n        @include mq(mobile) {\n          padding-left: 16px;\n          border-bottom: 1px solid rgba(92, 54, 136, 0.2);\n        }\n      }\n      .card-5 {\n        padding-right: 211px;\n        @include mq(mobile) {\n          padding: 16px;\n        }\n      }\n\n      .card-5::after {\n        content: unset !important;\n        width: unset;\n      }\n      .card-3::after {\n        content: unset !important;\n        width: unset;\n      }\n    }\n  }\n\n  //\n  .scroll-container {\n    @include mq(mobile) {\n      padding-top: 60px;\n    }\n  }\n\n  .section {\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .pin-section {\n    position: relative;\n    height: 100vh;\n    display: flex;\n    overflow: hidden;\n    justify-content: center;\n    flex-direction: row-reverse;\n    gap: 40px;\n\n    @include mq(mobile) {\n      flex-direction: column-reverse;\n      gap: 20px;\n    }\n    .card-copy {\n      flex: 1;\n    }\n\n    .learnmore-btn {\n      margin-top: 11px;\n      font-size: 15px;\n      font-family: $Mregular;\n      line-height: 30px;\n\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n  .text-container,\n  .image-container {\n    flex: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    @include mq(mobile) {\n      align-items: unset;\n      top: 30px;\n    }\n  }\n  .text-container {\n    overflow: hidden;\n  }\n  .text-slide {\n    // font-size: 2rem;\n    position: absolute;\n    width: 100%;\n    // text-align: center;\n    opacity: 0;\n    color: #5c3688;\n\n    .card-title {\n      font-size: 40px;\n      line-height: 90px;\n      font-family: $Msemibold;\n      @include mq(mobile) {\n        font-size: 24px;\n        line-height: 50px;\n      }\n    }\n    .card-discription {\n      font-size: 20px;\n      font-family: $medium;\n      line-height: 30px;\n      // letter-spacing: 0%;\n      width: 338px;\n      @include mq(mobile) {\n        font-size: 15px;\n        line-height: 1.4;\n      }\n    }\n  }\n  .image-slide {\n    position: absolute;\n    width: 400px;\n    height: 400px;\n    background-size: cover;\n    background-position: center;\n    opacity: 0;\n    padding: 100px 0;\n    @include mq(mobile) {\n      width: 300px;\n      height: 300px;\n    }\n    @include mq(tab) {\n      width: 300px;\n      height: 300px;\n    }\n\n    &.backmeta {\n      background-image: url(\"../images/ad-images/backMeta.svg\");\n    }\n    &.google-ads {\n      background-image: url(\"../images/ad-images/google_ads.svg\");\n    }\n    &.tiktok {\n      background-image: url(\"../images/ad-images/Tiktok.svg\");\n    }\n    &.tabola {\n      background-image: url(\"../images/ad-images/Taboola.svg\");\n    }\n    &.snap {\n      background-image: url(\"../images/ad-images/Snap.svg\");\n    }\n  }\n  //\n\n  // .accordion-section {\n  //   padding-top: 89px;\n  //   .heading-acc {\n  //     font-size: 60px;\n  //     line-height: 90px;\n  //     color: #5c3688;\n  //     font-family: $Msemibold;\n  //     text-align: center;\n  //     margin-bottom: 50px;\n  //     @include mq(mobile) {\n  //       font-size: 40px;\n  //       line-height: 1.2;\n  //     }\n  //   }\n  //   .accordion {\n  //     width: 80%;\n  //     margin: 0 auto;\n  //   }\n\n  //   .accordion-item {\n  //     border: 1px solid #5c368833;\n  //     margin-bottom: 20px;\n  //     border-radius: 20px;\n  //   }\n\n  //   .accordion-button {\n  //     // background-color: #f1f1f1;\n  //     border: none;\n  //     padding: 30px 100px;\n  //     text-align: left;\n  //     cursor: pointer;\n  //     width: 100%;\n  //     outline: none;\n  //     font-size: 16px;\n  //     position: relative;\n  //     // padding-left: 30px;\n  //     display: flex;\n  //     flex-direction: row-reverse;\n  //     justify-content: flex-end;\n  //     align-items: center;\n  //     color: #5c3688;\n  //     border-radius: 20px;\n  //     span {\n  //       font-size: 28px;\n  //       width: 36px;\n  //     }\n\n  //     .btn-copy {\n  //       font-family: $Msemibold;\n  //       font-size: 28px;\n  //       line-height: 34px;\n  //     }\n  //     @include mq(mobile) {\n  //       padding: 30px;\n  //       gap: 5px;\n  //       .btn-copy {\n  //         font-size: 18px;\n  //         line-height: 22px;\n  //       }\n  //     }\n  //   }\n\n  //   .accordion-button .plus-minus {\n  //     // position: absolute;\n  //     // left: 10px; /* Adjust the position to your liking */\n  //     // font-size: 20px;\n  //     // line-height: 1;\n  //     // top: 50%;\n  //     // transform: translateY(-50%);\n  //   }\n\n  //   .accordion-content {\n  //     max-height: 0;\n  //     overflow: hidden;\n  //     transition: max-height 0.4s ease-out;\n  //     padding: 0 100px;\n  //     margin-left: 36px;\n  //     @include mq(mobile) {\n  //       padding: 0 20px;\n  //     }\n  //   }\n\n  //   .accordion-content p {\n  //     // margin: 10px 0;\n  //     font-family: $Mregular;\n  //     font-size: 18px;\n  //     line-height: 24px;\n  //     color: #5c3688;\n  //     margin-bottom: 30px;\n  //   }\n\n  //   .accordion-content.show {\n  //     max-height: 1000px; /* Arbitrarily large value to ensure content is visible */\n  //   }\n  // }\n\n  .accordion-section {\n    padding-top: 89px;\n\n    .heading-acc {\n      font-size: 60px;\n      line-height: 90px;\n      color: #5c3688;\n      text-align: center;\n      margin-bottom: 50px;\n      font-family: $Msemibold;\n\n      @include mq(mobile) {\n        font-size: 40px;\n        line-height: 1.2;\n      }\n    }\n\n    .accordion {\n      width: 80%;\n      margin: 0 auto;\n    }\n\n    .accordion-item {\n      border: 1px solid #5c368833;\n      margin-bottom: 20px;\n      border-radius: 20px;\n    }\n\n    .accordion-button {\n      border: none;\n      padding: 30px;\n      padding: 30px 100px;\n      text-align: left;\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      color: #5c3688;\n      font-size: 28px;\n      background: transparent;\n      display: flex;\n      flex-direction: row-reverse;\n      justify-content: flex-end;\n\n      span {\n        font-size: 28px;\n        width: 36px;\n      }\n\n      @include mq(mobile) {\n        padding: 30px;\n        gap: 5px;\n        .btn-copy {\n          font-size: 18px;\n          line-height: 22px;\n        }\n      }\n    }\n\n    .accordion-content {\n      max-height: 0;\n      overflow: hidden;\n      transition: max-height 0.4s ease;\n      padding: 0 30px;\n      font-size: 18px;\n      color: #5c3688;\n      padding: 0 100px;\n      margin-left: 36px;\n\n      &.show {\n        max-height: 1000px; // Large enough to cover content but not fixed\n        // padding: 20px 30px; // Adjust padding only when expanded\n      }\n      p {\n        font-family: $Mregular;\n      }\n\n      @include mq(mobile) {\n        padding: 0 20px;\n      }\n    }\n\n    .accordion-content p {\n      // margin: 10px 0;\n      font-family: $Mregular;\n      font-size: 18px;\n      line-height: 24px;\n      color: #5c3688;\n      margin-bottom: 30px;\n    }\n\n    .accordion-content.show {\n      max-height: 1000px; /* Arbitrarily large value to ensure content is visible */\n    }\n  }\n\n  #cardContact {\n    padding-top: 116px;\n    @include mq(mobile) {\n      padding-top: 60px;\n    }\n    @include mq(tab) {\n      padding: 64px 50px;\n    }\n    .wrapper {\n      display: flex;\n      background-color: #f17380;\n      justify-content: space-between;\n      padding: 83px 121px;\n      border-radius: 20px;\n      @include mq(mobile) {\n        flex-direction: column;\n        padding: 30px;\n      }\n\n      a {\n        font-family: $Mregular;\n        font-size: 18px;\n        line-height: 34px;\n        font-weight: 600;\n        color: white;\n      }\n      p {\n        font-family: $Mregular;\n        font-size: 18px;\n        line-height: 34px;\n        font-weight: 600;\n        color: white;\n        @include mq(mobile) {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  .footer-add {\n    margin-top: 106px;\n    padding-top: 56px;\n    padding-bottom: 80px;\n    background-color: #5c3688;\n    position: relative;\n    background-image: url(\"../images/ad-images/footerback.png\");\n    background-position: top;\n    background-size: cover;\n    background-repeat: no-repeat;\n    @include mq(mobile) {\n      background-image: url(\"../images/ad-images/footerback.png\");\n      background-position: bottom;\n      background-size: contain;\n      background-repeat: no-repeat;\n      padding-bottom: 80px;\n      margin-top: 80px;\n    }\n    .footer-wrapper-ad {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      // margin-bottom: 19px;\n      @include mq(mobile) {\n        flex-direction: column;\n        gap: 30px;\n      }\n\n      .privacy-policy {\n        font-family: $DMregular;\n        font-size: 16px;\n        color: white;\n      }\n    }\n    .logo {\n      width: 200px;\n      @include mq(mobile) {\n        width: 150px;\n      }\n    }\n    .nav-list {\n      display: flex;\n      align-items: center;\n      a {\n        display: block;\n      }\n\n      @include mq(mobile) {\n        flex-direction: column;\n        gap: 20px;\n      }\n    }\n    .nav-item {\n      font-size: 14px;\n      font-family: $medium;\n      margin-right: 31px;\n      letter-spacing: 0%;\n      color: white;\n      @include mq(mobile) {\n        margin-right: 0;\n      }\n    }\n\n    .footer-hero-img {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: absolute;\n      left: 50%;\n      transform: translate(-50%, 0);\n      width: 100%;\n      bottom: 10px;\n      img {\n        flex-grow: 1;\n      }\n      @include mq(mobile) {\n        bottom: 10px;\n      }\n    }\n\n    .copyright-copy {\n      color: white;\n      font-size: 14px;\n      font-family: $medium;\n      line-height: 40px;\n      text-align: center;\n\n      bottom: 32px;\n      // width: 100%;\n      @include mq(mobile) {\n        // width: 100%;\n        font-size: 14px;\n        width: 100%;\n        left: unset;\n        transform: unset;\n        text-align: center;\n        bottom: 10px;\n      }\n    }\n  }\n}\n.privacy-policy-media-solution {\n  padding: 40px 0;\n  .privacy-policy-wrapper {\n    h1 {\n      font-family: $bold;\n      font-size: 30px;\n      text-align: center;\n      padding-bottom: 40px;\n    }\n    p {\n      font-family: $light;\n      font-size: 20px;\n    }\n    h2 {\n      font-family: $DMbold;\n      font-size: 24px;\n      margin: 20px 0;\n    }\n    h3 {\n      font-family: $DMregular;\n      font-size: 24px;\n      margin: 20px 0;\n    }\n  }\n}\n\n// ecom-page\n.build-ecomm-page-css {\n  @mixin commonBackground {\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  //\n\n  .container_ecom {\n    max-width: 900px;\n    margin: 0 auto;\n    width: 90%;\n\n    @include mq(tab) {\n      width: 90%;\n      max-width: 768px;\n      margin: 0 auto;\n    }\n\n    @include mq(mobile) {\n      width: 320px;\n      // padding: 0 20px;\n      margin: 0 auto;\n    }\n  }\n\n  .container-1 {\n    max-width: 1200px;\n    margin: 0 auto;\n    width: 90%;\n\n    @include mq(tab) {\n      width: 90%;\n      max-width: 768px;\n      margin: 0 auto;\n    }\n\n    @include mq(mobile) {\n      width: 320px;\n      // padding: 0 20px;\n      margin: 0 auto;\n    }\n  }\n\n  .banner {\n    background-image: url(\"../images/blinkecom-images/gredient.png\");\n    background-size: cover;\n    @include commonBackground();\n\n    .wrapper {\n      padding: 6rem 0;\n      max-width: 1100px;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      @include mq(mobile) {\n        padding-bottom: 3rem;\n        padding-top: 3rem;\n      }\n\n      .gredient_back {\n        position: absolute;\n        width: 400px;\n        right: 0px;\n        z-index: 5;\n\n        @include mq(mobile) {\n          width: 225px;\n          bottom: 10px;\n          position: absolute;\n          right: 0;\n        }\n\n        .time {\n          width: 100%;\n          position: absolute;\n          z-index: 7;\n          left: 50%;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 10px;\n\n          i {\n            font-size: 50px;\n          }\n\n          h4 {\n            text-align: center;\n            font-family: $DMbold;\n            font-size: 20px;\n            line-height: 1.3;\n\n            @include mq(mobile) {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n\n      .logo-section {\n        position: relative;\n        z-index: 10;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        width: fit-content;\n\n        p {\n          text-align: end;\n          margin-bottom: 5px;\n          font-family: $DMregular;\n          font-size: 12px;\n          margin-right: -4px;\n\n          @include mq(mobile) {\n            padding-right: unset;\n          }\n        }\n\n        .flex-second {\n          @include flexbox();\n          align-items: stretch;\n          gap: 20px;\n\n          .logo {\n            // border: 1px solid black;\n            display: flex;\n            border: 1px solid black;\n            align-items: center;\n            padding: 10px 20px;\n            border-radius: 8px;\n\n            &.logo-p {\n              position: relative;\n\n              p {\n                position: absolute;\n                top: -10px;\n                // top: 50%;\n                right: 50%;\n                transform: translate(-50%, -50%);\n                font-size: 14px;\n              }\n            }\n\n            .blink_logo {\n              width: 250px;\n            }\n\n            .olm_logo {\n              width: 65px;\n            }\n          }\n        }\n      }\n\n      .hero-copy {\n        margin-top: 20px;\n        margin-bottom: 20px;\n        position: relative;\n        z-index: 10;\n\n        a {\n          display: block;\n          margin: 0 auto;\n        }\n\n        h2 {\n          font-size: 4rem;\n          font-family: $DMbold;\n          // text-transform: capitalize;\n          line-height: 1;\n          text-align: center;\n\n          @include mq(mobile) {\n            font-size: 2rem;\n          }\n        }\n      }\n\n      .para {\n        position: relative;\n        z-index: 10;\n        font-family: $DMregular;\n        font-size: 20px;\n\n        @include mq(mobile) {\n          font-size: 14px;\n        }\n      }\n\n      .btn {\n        position: relative;\n        z-index: 10;\n        display: inline-block;\n        font-size: 1.5rem;\n        font-family: $DMregular;\n        background-color: black;\n        color: $DmPink;\n        padding: 15px 30px;\n        border: 1px solid black;\n        border-radius: 50px;\n        margin: 20px 0;\n        margin: auto;\n\n        @include mq(mobile) {\n          font-size: 16px;\n          padding: 10px 30px;\n        }\n\n        &:hover {\n          background-color: transparent;\n          color: black;\n          transition: 0.5s;\n        }\n      }\n    }\n  }\n\n  .why_us {\n    .wrapper {\n      padding: 4rem 0;\n\n      .flex-logo-wrapper {\n        margin-top: 4rem;\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        row-gap: 50px;\n        column-gap: 50px;\n        @include mq(mobile) {\n          grid-template-columns: repeat(2, 1fr);\n          margin-top: 2rem;\n\n          gap: 10px;\n        }\n      }\n      .logo-copy-item {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        background-color: #f1f1f3;\n        padding: 30px;\n        text-align: center;\n        border-radius: 10px;\n        gap: 10px;\n        @include mq(mobile) {\n          padding: 15px;\n          gap: 5px;\n        }\n        img {\n          width: 80px;\n          @include mq(mobile) {\n            width: 40px;\n          }\n        }\n      }\n      h2 {\n        font-size: 3rem;\n        font-family: $DMbold;\n        margin-bottom: 10px;\n        background: linear-gradient(345deg, #e5b400, #e05300, #e977c1, #516beb);\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n\n        @include mq(mobile) {\n          font-size: 24px;\n          text-align: center;\n        }\n      }\n\n      p {\n        font-size: 20px;\n        font-family: $DMregular;\n        padding-top: 20px;\n\n        @include mq(mobile) {\n          font-size: 14px;\n          padding-top: 5px;\n        }\n      }\n    }\n  }\n\n  .agenda {\n    // display: none;\n    padding: 4rem 0;\n    background-color: #f2f2f2;\n\n    .wrapper {\n      .head {\n        display: flex;\n        align-items: baseline;\n        font-size: 20px;\n        font-family: $DMregular;\n        margin-bottom: 30px;\n        justify-content: space-between;\n      }\n\n      h2 {\n        color: black;\n        font-size: 3rem;\n        font-family: $DMbold;\n        text-transform: uppercase;\n      }\n\n      .border-bottom {\n        // border-bottom: 1px solid #B3B3B3;\n      }\n\n      .lunch {\n        // background: rgb(229, 180, 0);\n        background: linear-gradient(\n          90deg,\n          #e46f2f,\n          #e05301,\n          #e4ad00,\n          #c58403,\n          #ed86ae\n        );\n        @include flexbox();\n        padding: 10px 20px;\n        justify-content: space-between;\n\n        .copy {\n          padding-left: 50px;\n          font-size: 1.1rem;\n          font-family: $DMbold;\n          color: white;\n          text-transform: uppercase;\n\n          @include mq(mobile) {\n            padding-left: 0;\n          }\n        }\n\n        .time {\n          font-size: 1.1rem;\n          font-family: $DMbold;\n          color: white;\n          text-transform: uppercase;\n          padding-right: 50px;\n\n          @include mq(mobile) {\n            padding-right: 0;\n          }\n        }\n      }\n\n      .card-wrap {\n        display: flex;\n        flex-wrap: wrap;\n        row-gap: 0px;\n        column-gap: 2rem;\n        padding-bottom: 30px;\n        padding-top: 20px;\n        justify-content: space-between;\n\n        @include mq(mobile) {\n          flex-direction: column;\n          padding-bottom: 20px;\n        }\n\n        .card {\n          // width: 0;\n          // flex: 1 0 40%;\n          width: 48%;\n          @include flexbox();\n          align-items: flex-start;\n          padding: 20px 0;\n          gap: 20px;\n\n          @include mq(mobile) {\n            width: 100%;\n            padding: 20px 0;\n            gap: 10px;\n          }\n\n          // border-bottom: 1px solid #D7D7D7;\n\n          &:last-child {\n            // border-bottom: none;\n          }\n\n          .img-wrap {\n            img {\n              border-radius: 50%;\n              width: 100px;\n            }\n          }\n\n          .info {\n            @include flexbox();\n            // flex-direction: column;\n            justify-content: space-evenly;\n            width: 100%;\n            justify-content: space-between;\n            flex-direction: column;\n\n            .name {\n              font-size: 20px;\n              font-family: $DMbold;\n            }\n\n            .para {\n              font-size: 20px;\n              font-family: $DMregular;\n            }\n\n            .position {\n              @include flexbox();\n              gap: 14px;\n\n              @include mq(mobile) {\n                flex-direction: column;\n                gap: 5px;\n              }\n\n              .copy {\n                font-family: $DMregular;\n                color: #6d6d6d;\n\n                @include mq(mobile) {\n                  font-size: 13px;\n                }\n              }\n\n              .time {\n                font-family: $DMbold;\n\n                @include mq(mobile) {\n                  font-size: 14px;\n                }\n              }\n            }\n\n            .tag {\n              font-size: 16px;\n              font-family: $DMbold;\n              background: linear-gradient(345deg, #facc35, #ee2a23, #f58121);\n              -webkit-background-clip: text;\n              -webkit-text-fill-color: transparent;\n              // font-size: 4rem;\n              font-family: $DMbold;\n\n              @include mq(mobile) {\n                font-size: 12px;\n              }\n            }\n          }\n        }\n      }\n\n      .center-tag {\n        padding-top: 20px;\n        padding-bottom: 20px;\n\n        @include mq(mobile) {\n          padding-bottom: 0px;\n        }\n\n        .position {\n          @include flexbox();\n          gap: 3rem;\n\n          @include mq(mobile) {\n            flex-direction: column;\n            align-items: center;\n            gap: 0;\n          }\n\n          .copy {\n            font-family: $DMregular;\n            color: #6d6d6d;\n          }\n\n          .time {\n            font-family: $DMbold;\n\n            @include mq(mobile) {\n              font-size: 14px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .details {\n    padding: 4rem 0;\n    background-image: url(\"../images/blinkecom-images/gredient.png\");\n    background-size: cover;\n    @include commonBackground();\n\n    .wrapper {\n      h2 {\n        color: white;\n        font-size: 3rem;\n        font-family: $DMbold;\n        margin-bottom: 30px;\n\n        @include mq(mobile) {\n          font-size: 24px;\n          text-align: center;\n        }\n      }\n\n      iframe {\n        width: 100%;\n        .HMRMj {\n          display: none;\n        }\n        .HB1eCd-UMrnmb {\n          background-color: red;\n          .teQAzf {\n            width: 100% !important;\n          }\n          body {\n            background-color: transparent !important;\n          }\n          .D8bnZd {\n            background-color: rgba(62, 18, 107, 0) !important;\n          }\n        }\n      }\n\n      .form_container_1 {\n        @include flexbox();\n        flex-direction: column;\n        gap: 20px;\n\n        .form_container {\n          @include flexbox();\n          gap: 1rem;\n\n          @include mq(mobile) {\n            flex-direction: column;\n          }\n\n          .form_1 {\n            @include flexbox();\n            flex-wrap: wrap;\n            gap: 20px;\n            flex-grow: 1;\n            justify-content: space-between;\n\n            @include mq(mobile) {\n              flex-direction: column;\n            }\n          }\n\n          .field-wrap {\n            width: 48%;\n            position: relative;\n\n            @include mq(mobile) {\n              width: 100%;\n            }\n\n            .error_form {\n              font-size: 12px;\n              color: red;\n              position: absolute;\n              bottom: -14px;\n              margin: 0;\n            }\n\n            &.field-wrap-2 {\n              width: 100%;\n              position: relative;\n\n              .error_form {\n                font-size: 12px;\n                color: red;\n                position: absolute;\n                bottom: 5px;\n                margin: 0;\n              }\n            }\n          }\n\n          .input_css {\n            max-width: 100%;\n            width: 100%;\n            background-color: #f2f2f2;\n            font-size: 16px;\n            padding: 18px 10px;\n            border-radius: 5px;\n\n            flex-grow: 1;\n\n            &::placeholder {\n              color: #9d9d9d;\n            }\n\n            @include mq(mobile) {\n              width: 100%;\n              padding: 14px 10px;\n              font-size: 16px;\n            }\n          }\n        }\n\n        .input_css_2 {\n          background-color: #f2f2f2;\n          font-size: 24px;\n          padding: 18px 10px;\n          border-radius: 5px;\n          font-family: $DMregular;\n\n          &::placeholder {\n            color: #9d9d9d;\n            font-size: 16px;\n            vertical-align: middle;\n          }\n\n          @include mq(mobile) {\n            padding: 14px 10px;\n            font-size: 16px;\n          }\n        }\n\n        .input_css_1 {\n          background-color: #f2f2f2;\n          font-size: 16px;\n          padding: 18px 10px;\n          border-radius: 5px;\n          font-family: $DMregular;\n          width: 100%;\n\n          &::placeholder {\n            color: #9d9d9d;\n            font-size: 16px;\n            vertical-align: middle;\n          }\n\n          @include mq(mobile) {\n            padding: 14px 10px;\n            font-size: 16px;\n            height: 150px;\n          }\n        }\n      }\n\n      a {\n        display: inline-block;\n        font-size: 1.5rem;\n        font-family: $DMregular;\n        color: $DmPink;\n        padding: 15px 30px;\n        border: none;\n        border-radius: 50px;\n        margin: 40px 0;\n        // margin-top: 30px;\n        color: white;\n        background-color: transparent;\n        border: 1px solid white;\n\n        @include mq(mobile) {\n          margin: 30px 0;\n          padding: 10px 30px;\n          font-size: 17px;\n          display: block;\n          text-align: center;\n          /* margin: auto 0; */\n          margin-left: auto;\n          margin-right: auto;\n          width: fit-content;\n        }\n\n        &:hover {\n          background-color: black;\n          color: $DmPink;\n          border: 1px solid black;\n          transition: 0.5s;\n        }\n      }\n    }\n  }\n\n  .footer-ecom {\n    padding: 2rem 0;\n    position: absolute;\n    width: 100%;\n    // bottom: 0;\n    background-color: #f2f2f2;\n\n    .wrapper {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n\n      @include mq(mobile) {\n        flex-direction: column;\n        gap: 20px;\n        align-items: center;\n      }\n\n      .logo {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        img {\n          width: 130px;\n        }\n        p {\n          font-family: $DMmedium;\n        }\n      }\n\n      .email_wrap {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        font-family: $DMregular;\n        p {\n          font-family: $DMmedium;\n        }\n        .flex-footer {\n          display: flex;\n          justify-content: space-between;\n          gap: 10px;\n          @include mq(mobile) {\n            flex-direction: column;\n            align-items: center;\n          }\n        }\n\n        @include mq(mobile) {\n          flex-direction: column;\n          gap: 10px;\n          align-items: center;\n        }\n      }\n    }\n  }\n}\n\n.logo-main-css {\n  .banner-relative {\n    position: relative;\n  }\n  .absolute-copy {\n    position: absolute;\n    top: 50%;\n    color: white;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-family: $Mbold;\n    font-size: 60px;\n    @include mq(mobile) {\n      font-size: 20px;\n    }\n    @include mq(tab) {\n      font-size: 24px;\n    }\n  }\n  .wrapper-logo-row {\n    padding: 80px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 100px;\n    .grid-logo {\n      display: grid;\n      grid-template-columns: repeat(3, 3fr);\n      gap: 50px;\n\n      @include mq(mobile) {\n        grid-template-columns: repeat(1, 1fr);\n        padding: 0 40px;\n      }\n    }\n    .card-box {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 20px;\n    }\n    .img-box {\n      background-color: gray;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      flex-grow: 1;\n      padding: 50px;\n      justify-content: center;\n      background-color: rgb(248, 248, 248);\n      border: 1px solid rgba(0, 0, 0, 0.176);\n      border-radius: 6px;\n    }\n    .btn-dow {\n      background-color: rgba(0, 0, 0, 0);\n      color: black;\n      padding: 6px 12px;\n      font-size: 16px;\n      border: 1px solid black;\n      border-radius: 6px;\n    }\n  }\n}\n\n.not-found-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  // background-color: #f8f9fa;\n  text-align: center;\n  padding: 20px;\n}\n\n.not-found-container .container {\n  // background: #fff;\n  padding: 40px;\n  border-radius: 16px;\n  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  max-width: 500px;\n  width: 100%;\n}\n\n.not-found-container h1 {\n  font-size: 3.2rem;\n  margin-bottom: 10px;\n  font-family: $DMbold;\n  color: #000;\n  text-transform: capitalize;\n  @include mq(mobile) {\n    font-size: 1.5rem;\n  }\n}\n\n.not-found-container p {\n  font-size: 1.1rem;\n  // color: #6c757d;\n  margin-bottom: 40px;\n  font-family: $Mlight;\n}\n\n.cta-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  // padding: 12px 24px;\n  // background-color: #007bff;\n  // color: #fff;\n  text-decoration: none;\n  text-transform: capitalize;\n  // border-radius: 8px;\n  font-weight: bold;\n  transition: background-color 0.3s ease;\n  transition: border 0.3s ease;\n  font-family: $Mregular;\n  font-size: 26px;\n  padding-bottom: 2px;\n  border-bottom: 2px solid transparent;\n  img {\n    width: 20px;\n  }\n  @include mq(mobile) {\n    font-size: 1.2rem;\n    img {\n      width: 16px;\n    }\n  }\n}\n\n.cta-button:hover {\n  // background-color: #0056b3;\n  // padding-bottom: 2px;\n  // border-bottom: 2px solid black;\n  img {\n    transform: translate(15px, -15px); /* Move the arrow from bottom left */\n    opacity: 0; /* Start with the arrow hidden */\n    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
